import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { supabase } from '../lib/supabase';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Badge } from '../components/ui/badge';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../components/ui/dialog';
import { Switch } from '../components/ui/switch';
import { Label } from '../components/ui/label';
import { Textarea } from '../components/ui/textarea';
import { motion } from 'framer-motion';
import { 
  Users, 
  Package, 
  FileText, 
  ChartBar,
  Shield,
  Search,
  Eye,
  Ban,
  CircleCheck,
  CircleX,
  TrendingUp,
  Euro,
  Clock,
  TriangleAlert,
  Crown,
  Star,
  Sparkles,
  RefreshCw,
  ChevronLeft,
  ChevronRight,
  Settings,
  Rocket,
  Percent,
  FolderTree,
  Plus,
  Trash2,
  Pencil,
  Lock,
  Image,
  Type,
  ChevronDown,
  ChevronUp,
  Download,
  Upload,
  FileJson,
  AlertCircle,
  CheckCircle2,
  Loader2,
  // Abbigliamento & Moda
  Shirt,
  // Gioielli & Accessori
  Gem,
  Watch,
  CircleDot,
  Diamond,
  // Casa & Arredamento
  House,
  Armchair,
  Lamp,
  Bath,
  Sofa,
  BedDouble,
  DoorOpen,
  Blinds,
  // Cucina
  UtensilsCrossed,
  ChefHat,
  CookingPot,
  Refrigerator,
  Microwave,
  // Arte & Creatività
  Palette,
  Brush,
  PaintBucket,
  Pen,
  PencilLine,
  Eraser,
  Highlighter,
  PenTool,
  // Persone
  User,
  Baby,
  PersonStanding,
  // Natura & Piante
  Flower2,
  Leaf,
  Trees,
  TreePine,
  Shrub,
  Clover,
  // Cibo & Bevande
  Apple,
  Cherry,
  Grape,
  Wine,
  Beer,
  Coffee,
  CupSoda,
  IceCreamCone,
  Candy,
  Croissant,
  Pizza,
  Cake,
  Cookie,
  Soup,
  Salad,
  Sandwich,
  Egg,
  Fish,
  Beef,
  // Eventi & Celebrazioni
  Heart,
  PartyPopper,
  GraduationCap,
  Church,
  Gift,
  Sparkle,
  // Musica & Intrattenimento
  Music,
  Music2,
  Music3,
  Music4,
  Headphones,
  Radio,
  Mic,
  Piano,
  Guitar,
  Drum,
  // Sport & Attività
  Bike,
  Dumbbell,
  Trophy,
  Medal,
  Target,
  // Tecnologia
  Gamepad,
  Gamepad2,
  Joystick,
  Monitor,
  Smartphone,
  Tablet,
  Laptop,
  Tv,
  Speaker,
  // Fotografia & Video
  Camera,
  Video,
  Film,
  Clapperboard,
  Focus,
  Aperture,
  // Libri & Scrittura
  BookOpen,
  Book,
  Bookmark,
  Library,
  Newspaper,
  ScrollText,
  // Trasporti
  Car,
  Plane,
  Ship,
  TrainFront,
  Bus,
  Sailboat,
  // Animali
  Dog,
  Cat,
  Bird,
  Bug,
  Rabbit,
  Squirrel,
  // Tempo & Meteo
  Sun,
  Moon,
  Cloud,
  CloudRain,
  Snowflake,
  Wind,
  Rainbow,
  Umbrella,
  Thermometer,
  // Strumenti & Lavoro
  Hammer,
  Wrench,
  Drill,
  Scissors,
  Ruler,
  Compass,
  Magnet,
  // Forme & Simboli
  Frame,
  Square,
  Circle,
  Triangle,
  Hexagon,
  Octagon,
  Pentagon,
  // Tessile & Materiali
  Ribbon,
  Feather,
  Shell,
  Bone,
  // Contenitori
  Box,
  Archive,
  Briefcase,
  ShoppingBag,
  ShoppingCart,
  ShoppingBasket,
  Wallet,
  // Salute & Benessere
  HeartPulse,
  Stethoscope,
  Pill,
  Syringe,
  Bandage,
  ThermometerSun,
  // Bellezza
  Droplets,
  Droplet,
  Flame,
  // Edifici & Luoghi
  Building,
  Building2,
  Store,
  Warehouse,
  Factory,
  Castle,
  Landmark,
  Mountain,
  // Varie
  Glasses,
  Footprints,
  Key,
  Anchor,
  Zap,
  Lightbulb,
  Flashlight,
  // Frecce & Direzioni
  ArrowUp,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  // Comunicazione
  Mail,
  MessageCircle,
  Phone,
  Send,
  // Sicurezza
  LockKeyhole,
  LockOpen,
  KeyRound,
  // Bandiere & Simboli
  Flag,
  FlagTriangleRight,
  // Altro
  Puzzle,
  Shapes,
  Layers,
  Grid3x3,
  LayoutGrid,
  Pipette,
  WandSparkles,
  Stamp,
  Sticker,
  Tags,
  Tag,
  Ticket,
  BadgeCheck,
  Award,
  HandMetal,
  Hand,
  Pointer,
  MousePointer,
  Globe,
  Earth,
  Map,
  MapPin,
  Navigation,
  LocateFixed,
  Accessibility,
  Bed,
  Fan,
  AirVent,
  Heater,
  Toilet,
  ShowerHead,
  Timer,
  Hourglass,
  Calendar,
  CalendarHeart,
  Infinity,
  Hash,
  AtSign,
  Divide,
  Equal,
  Pi,
  Image as ImageIcon,
  X,
  Plug,
  ExternalLink,
  Copy,
  EyeOff,
  Info,
  BarChart3,
  // New icons added for extended ICON_PRESETS
  Swords,
  Sword,
  Wand2,
  Wand,
  Drama,
  Skull,
  Ghost,
  Receipt,
  CreditCard,
  Banknote,
  Coins,
  PiggyBank,
  BadgePercent,
  Wallet2,
  Calculator,
  DollarSign,
  PoundSterling,
  Paintbrush,
  PenLine,
  Figma,
  Origami,
  DoorClosed,
  Flower,
  Sprout,
  TreeDeciduous,
  PawPrint,
  Waves,
  Tent,
  Backpack,
  CloudSun,
  CloudMoon,
  Atom,
  Orbit,
  Satellite,
  Cpu,
  HardDrive,
  Server,
  Database,
  Code,
  Terminal,
  Binary,
  QrCode,
  Barcode,
  ScanLine,
  Scan,
  Shovel,
  Axe,
  Pickaxe,
  Scale,
  Construction,
  HardHat,
  Cone,
  Wheat,
  Carrot,
  Nut,
  Banana,
  Milk,
  GlassWater,
  Martini,
  Utensils,
  HeartHandshake,
  Handshake,
  Users2,
  UserPlus,
  UserMinus,
  UserCheck,
  UserX,
  Dice1,
  Dice2,
  Dice3,
  Dice4,
  Dice5,
  Dice6,
  Spade,
  Club,
  Train,
  PlaneTakeoff,
  PlaneLanding,
  Truck,
  LifeBuoy,
  Bell,
  BellOff,
  BellRing,
  Megaphone,
  MessageSquare,
  MessagesSquare,
  Activity,
  BarChart,
  BarChart2,
  PieChart,
  LineChart,
  TrendingDown,
  Wifi,
  WifiOff,
  Bluetooth,
  BluetoothOff,
  Signal,
  SignalHigh,
  SignalLow,
  Battery,
  BatteryCharging,
  BatteryFull,
  BatteryLow,
  BatteryMedium,
  Power,
  PowerOff,
  LogIn,
  LogOut,
  ImagePlus,
  Images,
  FileImage,
  Folder,
  FolderOpen,
  File,
  FilePlus,
  Paperclip,
  Pin,
  PinOff,
  BookmarkPlus,
  Check,
  AlertTriangle,
  HelpCircle,
  Settings2,
  Sliders,
  SlidersHorizontal,
  MoreHorizontal,
  MoreVertical,
  Menu,
  Grid,
  List,
  Layout,
  Share,
  Share2,
  Link2,
  Clipboard,
  ClipboardCheck,
  Trash,
  Edit,
  Edit2,
  Edit3,
  Save,
  RotateCw,
  Unlock,
  ChevronsUp,
  ChevronsDown,
  ChevronsLeft,
  ChevronsRight,
  ArrowUpRight,
  Play,
  Pause,
  StopCircle,
  SkipBack,
  SkipForward,
  Volume2,
  VolumeX,
  Maximize,
  Minimize,
  Minus,
  ZoomIn,
  ZoomOut,
  Inbox,
  Forward,
  Reply,
  ReplyAll,
  Printer,
  ThumbsUp,
  ThumbsDown,
  Smile,
  Frown,
  Meh,
  Angry,
  Laugh,
  Globe2,
  Languages,
  PackageCheck,
  PackageX,
  PackageSearch,
  Boxes,
  GalleryHorizontal,
  Home
} from 'lucide-react';
import { toast } from 'sonner';
import { adminFetch } from '../lib/adminFetch';

export default function SuperAdminDashboard() {
  const { user, profile } = useAuth();
  const navigate = useNavigate();
  const API_URL = process.env.REACT_APP_BACKEND_URL;
  
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('overview');
  
  // Data states
  const [stats, setStats] = useState({
    totalUsers: 0,
    totalCrafters: 0,
    totalOrders: 0,
    totalRequests: 0,
    totalRevenue: 0,
    pendingRequests: 0
  });
  const [users, setUsers] = useState([]);
  const [orders, setOrders] = useState([]);
  const [requests, setRequests] = useState([]);
  
  // Ref to track if initial data has been loaded (prevents reload on tab visibility change)
  const initialLoadDone = useRef(false);
  
  // Filters
  const [userSearch, setUserSearch] = useState('');
  const [userFilter, setUserFilter] = useState('all');
  const [orderFilter, setOrderFilter] = useState('all');
  
  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  
  // Detail dialogs
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedOrder, setSelectedOrder] = useState(null);
  
  // Platform settings
  const [launchMode, setLaunchMode] = useState(false);
  const [checkoutMode, setCheckoutMode] = useState('redirect'); // 'redirect' | 'express'
  const [maintenanceMode, setMaintenanceMode] = useState(true);
  const [premiumFeaturesEnabled, setPremiumFeaturesEnabled] = useState(true);
  const [savingSettings, setSavingSettings] = useState(false);

  // Categories management
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [categoryForm, setCategoryForm] = useState({
    name: '',
    slug: '',
    parent_id: '',
    icon: 'Package',
    image_url: '',
    seo_title: '',      // H1 title in header
    seo_intro: '',      // Intro text below H1
    seo_footer_title: '', // H2 title in footer section
    seo_description: '', // Long SEO text in footer
    sort_order: 0
  });
  const [isCreatingCategory, setIsCreatingCategory] = useState(false);
  const [savingCategory, setSavingCategory] = useState(false);
  const [showIconPicker, setShowIconPicker] = useState(false);
  const [expandedCategories, setExpandedCategories] = useState({});
  
  // Category Import/Export
  const [importPreview, setImportPreview] = useState(null);
  const [importParentSlug, setImportParentSlug] = useState(null);
  const [importLoading, setImportLoading] = useState(false);
  const [importResult, setImportResult] = useState(null);

  // Request options management (Budget & Timeline)
  const [budgetOptions, setBudgetOptions] = useState([]);
  const [timelineOptions, setTimelineOptions] = useState([]);
  const [editingBudgetOption, setEditingBudgetOption] = useState(null);
  const [editingTimelineOption, setEditingTimelineOption] = useState(null);
  const [newBudgetOption, setNewBudgetOption] = useState({ value: '', label: '', description: '', sort_order: 0 });
  const [newTimelineOption, setNewTimelineOption] = useState({ value: '', label: '', description: '', sort_order: 0 });
  const [savingOption, setSavingOption] = useState(false);

  // Hero images management
  const [heroImages, setHeroImages] = useState([]);
  const [newHeroImageUrl, setNewHeroImageUrl] = useState('');
  const [loadingHeroImages, setLoadingHeroImages] = useState(false);

  // Contact messages management
  const [contactMessages, setContactMessages] = useState([]);
  const [contactMessagesTotal, setContactMessagesTotal] = useState(0);
  const [unreadMessagesCount, setUnreadMessagesCount] = useState(0);
  const [loadingMessages, setLoadingMessages] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [messageFilter, setMessageFilter] = useState('all');

  // OAuth Connectors management
  const [oauthProviders, setOauthProviders] = useState([]);
  const [loadingOAuth, setLoadingOAuth] = useState(false);
  const [savingOAuth, setSavingOAuth] = useState(false);
  const [googleConfig, setGoogleConfig] = useState({ client_id: '', client_secret: '', is_enabled: false });
  const [facebookConfig, setFacebookConfig] = useState({ client_id: '', client_secret: '', is_enabled: false });
  const [showGoogleSecret, setShowGoogleSecret] = useState(false);
  const [showFacebookSecret, setShowFacebookSecret] = useState(false);

  // Google Analytics management
  const [analyticsConfig, setAnalyticsConfig] = useState({
    measurement_id: '',
    anonymize_ip: true,
    cookie_consent_required: true,
    is_enabled: false
  });
  const [loadingAnalytics, setLoadingAnalytics] = useState(false);
  const [savingAnalytics, setSavingAnalytics] = useState(false);

  // Stripe configuration management
  const [stripeConfig, setStripeConfig] = useState({
    // LIVE inputs (write-only)
    api_key: '',
    webhook_secret: '',
    fee_reconcile_webhook_secret: '',
    connect_client_id: '',
    publishable_key: '',
    // TEST inputs (write-only)
    api_key_test: '',
    webhook_secret_test: '',
    fee_reconcile_webhook_secret_test: '',
    connect_client_id_test: '',
    publishable_key_test: '',
    // Common
    platform_fee_percent: 10.0,
    is_live_mode: false,
    is_enabled: false,
    enabled_payment_methods: [],
    // Server-side masked / flags
    has_api_key: false,
    has_webhook_secret: false,
    has_fee_reconcile_webhook_secret: false,
    api_key_masked: '',
    webhook_secret_masked: '',
    fee_reconcile_webhook_secret_masked: '',
    has_api_key_test: false,
    has_webhook_secret_test: false,
    has_fee_reconcile_webhook_secret_test: false,
    api_key_test_masked: '',
    webhook_secret_test_masked: '',
    fee_reconcile_webhook_secret_test_masked: '',
  });
  const [loadingStripe, setLoadingStripe] = useState(false);
  const [savingStripe, setSavingStripe] = useState(false);
  const [showStripeApiKey, setShowStripeApiKey] = useState(false);
  const [showStripeWebhookSecret, setShowStripeWebhookSecret] = useState(false);
  const [showStripeFeeWebhookSecret, setShowStripeFeeWebhookSecret] = useState(false);
  const [showStripeApiKeyTest, setShowStripeApiKeyTest] = useState(false);
  const [showStripeWebhookSecretTest, setShowStripeWebhookSecretTest] = useState(false);
  const [showStripeFeeWebhookSecretTest, setShowStripeFeeWebhookSecretTest] = useState(false);

  // Icon preset for category picker
  // Extended icon presets organized by category
  const ICON_PRESETS = [
    // === ABBIGLIAMENTO & MODA ===
    { name: 'Shirt', icon: Shirt, category: 'Moda' },
    { name: 'Glasses', icon: Glasses, category: 'Moda' },
    { name: 'Footprints', icon: Footprints, category: 'Moda' },
    { name: 'Ribbon', icon: Ribbon, category: 'Moda' },
    { name: 'Umbrella', icon: Umbrella, category: 'Moda' },
    { name: 'Crown', icon: Crown, category: 'Moda' },
    
    // === GIOIELLI & ACCESSORI ===
    { name: 'Gem', icon: Gem, category: 'Gioielli' },
    { name: 'Diamond', icon: Diamond, category: 'Gioielli' },
    { name: 'Watch', icon: Watch, category: 'Gioielli' },
    { name: 'CircleDot', icon: CircleDot, category: 'Gioielli' },
    { name: 'Sparkles', icon: Sparkles, category: 'Gioielli' },
    { name: 'Star', icon: Star, category: 'Gioielli' },
    
    // === CASA & ARREDAMENTO ===
    { name: 'House', icon: House, category: 'Casa' },
    { name: 'Armchair', icon: Armchair, category: 'Casa' },
    { name: 'Sofa', icon: Sofa, category: 'Casa' },
    { name: 'Lamp', icon: Lamp, category: 'Casa' },
    { name: 'BedDouble', icon: BedDouble, category: 'Casa' },
    { name: 'Bed', icon: Bed, category: 'Casa' },
    { name: 'DoorOpen', icon: DoorOpen, category: 'Casa' },
    { name: 'Frame', icon: Frame, category: 'Casa' },
    { name: 'Blinds', icon: Blinds, category: 'Casa' },
    { name: 'Fan', icon: Fan, category: 'Casa' },
    { name: 'Lightbulb', icon: Lightbulb, category: 'Casa' },
    
    // === BAGNO ===
    { name: 'Bath', icon: Bath, category: 'Bagno' },
    { name: 'ShowerHead', icon: ShowerHead, category: 'Bagno' },
    { name: 'Toilet', icon: Toilet, category: 'Bagno' },
    { name: 'Droplet', icon: Droplet, category: 'Bagno' },
    { name: 'Droplets', icon: Droplets, category: 'Bagno' },
    
    // === CUCINA ===
    { name: 'UtensilsCrossed', icon: UtensilsCrossed, category: 'Cucina' },
    { name: 'ChefHat', icon: ChefHat, category: 'Cucina' },
    { name: 'CookingPot', icon: CookingPot, category: 'Cucina' },
    { name: 'Coffee', icon: Coffee, category: 'Cucina' },
    { name: 'Wine', icon: Wine, category: 'Cucina' },
    { name: 'Beer', icon: Beer, category: 'Cucina' },
    { name: 'CupSoda', icon: CupSoda, category: 'Cucina' },
    { name: 'Refrigerator', icon: Refrigerator, category: 'Cucina' },
    { name: 'Microwave', icon: Microwave, category: 'Cucina' },
    
    // === CIBO & BEVANDE ===
    { name: 'Apple', icon: Apple, category: 'Cibo' },
    { name: 'Cherry', icon: Cherry, category: 'Cibo' },
    { name: 'Grape', icon: Grape, category: 'Cibo' },
    { name: 'Cake', icon: Cake, category: 'Cibo' },
    { name: 'Cookie', icon: Cookie, category: 'Cibo' },
    { name: 'Croissant', icon: Croissant, category: 'Cibo' },
    { name: 'Pizza', icon: Pizza, category: 'Cibo' },
    { name: 'Sandwich', icon: Sandwich, category: 'Cibo' },
    { name: 'Salad', icon: Salad, category: 'Cibo' },
    { name: 'Soup', icon: Soup, category: 'Cibo' },
    { name: 'IceCreamCone', icon: IceCreamCone, category: 'Cibo' },
    { name: 'Candy', icon: Candy, category: 'Cibo' },
    { name: 'Egg', icon: Egg, category: 'Cibo' },
    { name: 'Fish', icon: Fish, category: 'Cibo' },
    { name: 'Beef', icon: Beef, category: 'Cibo' },
    
    // === ARTE & CREATIVITÀ ===
    { name: 'Palette', icon: Palette, category: 'Arte' },
    { name: 'Brush', icon: Brush, category: 'Arte' },
    { name: 'PaintBucket', icon: PaintBucket, category: 'Arte' },
    { name: 'Pen', icon: Pen, category: 'Arte' },
    { name: 'PencilLine', icon: PencilLine, category: 'Arte' },
    { name: 'PenTool', icon: PenTool, category: 'Arte' },
    { name: 'Eraser', icon: Eraser, category: 'Arte' },
    { name: 'Highlighter', icon: Highlighter, category: 'Arte' },
    { name: 'Pipette', icon: Pipette, category: 'Arte' },
    { name: 'WandSparkles', icon: WandSparkles, category: 'Arte' },
    { name: 'Stamp', icon: Stamp, category: 'Arte' },
    { name: 'Shapes', icon: Shapes, category: 'Arte' },
    { name: 'Layers', icon: Layers, category: 'Arte' },
    
    // === MUSICA ===
    { name: 'Music', icon: Music, category: 'Musica' },
    { name: 'Music2', icon: Music2, category: 'Musica' },
    { name: 'Music3', icon: Music3, category: 'Musica' },
    { name: 'Music4', icon: Music4, category: 'Musica' },
    { name: 'Headphones', icon: Headphones, category: 'Musica' },
    { name: 'Radio', icon: Radio, category: 'Musica' },
    { name: 'Mic', icon: Mic, category: 'Musica' },
    { name: 'Piano', icon: Piano, category: 'Musica' },
    { name: 'Guitar', icon: Guitar, category: 'Musica' },
    { name: 'Drum', icon: Drum, category: 'Musica' },
    { name: 'Speaker', icon: Speaker, category: 'Musica' },
    
    // === FOTOGRAFIA & VIDEO ===
    { name: 'Camera', icon: Camera, category: 'Foto' },
    { name: 'Video', icon: Video, category: 'Foto' },
    { name: 'Film', icon: Film, category: 'Foto' },
    { name: 'Clapperboard', icon: Clapperboard, category: 'Foto' },
    { name: 'Focus', icon: Focus, category: 'Foto' },
    { name: 'Aperture', icon: Aperture, category: 'Foto' },
    
    // === LIBRI & SCRITTURA ===
    { name: 'BookOpen', icon: BookOpen, category: 'Libri' },
    { name: 'Book', icon: Book, category: 'Libri' },
    { name: 'Bookmark', icon: Bookmark, category: 'Libri' },
    { name: 'Library', icon: Library, category: 'Libri' },
    { name: 'Newspaper', icon: Newspaper, category: 'Libri' },
    { name: 'ScrollText', icon: ScrollText, category: 'Libri' },
    
    // === EVENTI & CELEBRAZIONI ===
    { name: 'Heart', icon: Heart, category: 'Eventi' },
    { name: 'Gift', icon: Gift, category: 'Eventi' },
    { name: 'PartyPopper', icon: PartyPopper, category: 'Eventi' },
    { name: 'GraduationCap', icon: GraduationCap, category: 'Eventi' },
    { name: 'Church', icon: Church, category: 'Eventi' },
    { name: 'CalendarHeart', icon: CalendarHeart, category: 'Eventi' },
    { name: 'Sparkle', icon: Sparkle, category: 'Eventi' },
    { name: 'Trophy', icon: Trophy, category: 'Eventi' },
    { name: 'Medal', icon: Medal, category: 'Eventi' },
    { name: 'Award', icon: Award, category: 'Eventi' },
    { name: 'BadgeCheck', icon: BadgeCheck, category: 'Eventi' },
    
    // === PERSONE ===
    { name: 'User', icon: User, category: 'Persone' },
    { name: 'Users', icon: Users, category: 'Persone' },
    { name: 'Baby', icon: Baby, category: 'Persone' },
    { name: 'PersonStanding', icon: PersonStanding, category: 'Persone' },
    { name: 'Hand', icon: Hand, category: 'Persone' },
    { name: 'HandMetal', icon: HandMetal, category: 'Persone' },
    { name: 'Accessibility', icon: Accessibility, category: 'Persone' },
    
    // === NATURA & PIANTE ===
    { name: 'Flower2', icon: Flower2, category: 'Natura' },
    { name: 'Leaf', icon: Leaf, category: 'Natura' },
    { name: 'Trees', icon: Trees, category: 'Natura' },
    { name: 'TreePine', icon: TreePine, category: 'Natura' },
    { name: 'Shrub', icon: Shrub, category: 'Natura' },
    { name: 'Clover', icon: Clover, category: 'Natura' },
    { name: 'Feather', icon: Feather, category: 'Natura' },
    { name: 'Shell', icon: Shell, category: 'Natura' },
    { name: 'Mountain', icon: Mountain, category: 'Natura' },
    
    // === ANIMALI ===
    { name: 'Dog', icon: Dog, category: 'Animali' },
    { name: 'Cat', icon: Cat, category: 'Animali' },
    { name: 'Bird', icon: Bird, category: 'Animali' },
    { name: 'Bug', icon: Bug, category: 'Animali' },
    { name: 'Rabbit', icon: Rabbit, category: 'Animali' },
    { name: 'Squirrel', icon: Squirrel, category: 'Animali' },
    
    // === METEO & TEMPO ===
    { name: 'Sun', icon: Sun, category: 'Meteo' },
    { name: 'Moon', icon: Moon, category: 'Meteo' },
    { name: 'Cloud', icon: Cloud, category: 'Meteo' },
    { name: 'CloudRain', icon: CloudRain, category: 'Meteo' },
    { name: 'Snowflake', icon: Snowflake, category: 'Meteo' },
    { name: 'Wind', icon: Wind, category: 'Meteo' },
    { name: 'Rainbow', icon: Rainbow, category: 'Meteo' },
    { name: 'Thermometer', icon: Thermometer, category: 'Meteo' },
    { name: 'Flame', icon: Flame, category: 'Meteo' },
    
    // === STRUMENTI & LAVORO ===
    { name: 'Hammer', icon: Hammer, category: 'Strumenti' },
    { name: 'Wrench', icon: Wrench, category: 'Strumenti' },
    { name: 'Drill', icon: Drill, category: 'Strumenti' },
    { name: 'Scissors', icon: Scissors, category: 'Strumenti' },
    { name: 'Ruler', icon: Ruler, category: 'Strumenti' },
    { name: 'Compass', icon: Compass, category: 'Strumenti' },
    { name: 'Magnet', icon: Magnet, category: 'Strumenti' },
    { name: 'Key', icon: Key, category: 'Strumenti' },
    { name: 'KeyRound', icon: KeyRound, category: 'Strumenti' },
    
    // === TRASPORTI ===
    { name: 'Car', icon: Car, category: 'Trasporti' },
    { name: 'Bike', icon: Bike, category: 'Trasporti' },
    { name: 'Plane', icon: Plane, category: 'Trasporti' },
    { name: 'Ship', icon: Ship, category: 'Trasporti' },
    { name: 'TrainFront', icon: TrainFront, category: 'Trasporti' },
    { name: 'Bus', icon: Bus, category: 'Trasporti' },
    { name: 'Sailboat', icon: Sailboat, category: 'Trasporti' },
    { name: 'Anchor', icon: Anchor, category: 'Trasporti' },
    
    // === TECNOLOGIA & GAMING ===
    { name: 'Gamepad', icon: Gamepad, category: 'Tech' },
    { name: 'Gamepad2', icon: Gamepad2, category: 'Tech' },
    { name: 'Joystick', icon: Joystick, category: 'Tech' },
    { name: 'Monitor', icon: Monitor, category: 'Tech' },
    { name: 'Smartphone', icon: Smartphone, category: 'Tech' },
    { name: 'Tablet', icon: Tablet, category: 'Tech' },
    { name: 'Laptop', icon: Laptop, category: 'Tech' },
    { name: 'Tv', icon: Tv, category: 'Tech' },
    { name: 'Zap', icon: Zap, category: 'Tech' },
    
    // === SHOPPING & COMMERCIO ===
    { name: 'Package', icon: Package, category: 'Shopping' },
    { name: 'Box', icon: Box, category: 'Shopping' },
    { name: 'ShoppingBag', icon: ShoppingBag, category: 'Shopping' },
    { name: 'ShoppingCart', icon: ShoppingCart, category: 'Shopping' },
    { name: 'ShoppingBasket', icon: ShoppingBasket, category: 'Shopping' },
    { name: 'Wallet', icon: Wallet, category: 'Shopping' },
    { name: 'Tag', icon: Tag, category: 'Shopping' },
    { name: 'Tags', icon: Tags, category: 'Shopping' },
    { name: 'Ticket', icon: Ticket, category: 'Shopping' },
    { name: 'Store', icon: Store, category: 'Shopping' },
    
    // === EDIFICI & LUOGHI ===
    { name: 'Building', icon: Building, category: 'Edifici' },
    { name: 'Building2', icon: Building2, category: 'Edifici' },
    { name: 'Warehouse', icon: Warehouse, category: 'Edifici' },
    { name: 'Factory', icon: Factory, category: 'Edifici' },
    { name: 'Castle', icon: Castle, category: 'Edifici' },
    { name: 'Landmark', icon: Landmark, category: 'Edifici' },
    
    // === MAPPE & NAVIGAZIONE ===
    { name: 'Globe', icon: Globe, category: 'Mappe' },
    { name: 'Earth', icon: Earth, category: 'Mappe' },
    { name: 'Map', icon: Map, category: 'Mappe' },
    { name: 'MapPin', icon: MapPin, category: 'Mappe' },
    { name: 'Navigation', icon: Navigation, category: 'Mappe' },
    { name: 'LocateFixed', icon: LocateFixed, category: 'Mappe' },
    { name: 'Flag', icon: Flag, category: 'Mappe' },
    
    // === FORME GEOMETRICHE ===
    { name: 'Square', icon: Square, category: 'Forme' },
    { name: 'Circle', icon: Circle, category: 'Forme' },
    { name: 'Triangle', icon: Triangle, category: 'Forme' },
    { name: 'Hexagon', icon: Hexagon, category: 'Forme' },
    { name: 'Octagon', icon: Octagon, category: 'Forme' },
    { name: 'Pentagon', icon: Pentagon, category: 'Forme' },
    { name: 'Grid3x3', icon: Grid3x3, category: 'Forme' },
    { name: 'LayoutGrid', icon: LayoutGrid, category: 'Forme' },
    { name: 'Puzzle', icon: Puzzle, category: 'Forme' },
    
    // === TEMPO ===
    { name: 'Clock', icon: Clock, category: 'Tempo' },
    { name: 'Timer', icon: Timer, category: 'Tempo' },
    { name: 'Hourglass', icon: Hourglass, category: 'Tempo' },
    { name: 'Calendar', icon: Calendar, category: 'Tempo' },
    { name: 'Infinity', icon: Infinity, category: 'Tempo' },
    
    // === SALUTE & BENESSERE ===
    { name: 'HeartPulse', icon: HeartPulse, category: 'Salute' },
    { name: 'Stethoscope', icon: Stethoscope, category: 'Salute' },
    { name: 'Pill', icon: Pill, category: 'Salute' },
    { name: 'Bandage', icon: Bandage, category: 'Salute' },
    { name: 'Dumbbell', icon: Dumbbell, category: 'Salute' },
    { name: 'Target', icon: Target, category: 'Salute' },
    
    // === COMUNICAZIONE ===
    { name: 'Mail', icon: Mail, category: 'Comunicazione' },
    { name: 'MessageCircle', icon: MessageCircle, category: 'Comunicazione' },
    { name: 'Phone', icon: Phone, category: 'Comunicazione' },
    { name: 'Send', icon: Send, category: 'Comunicazione' },
    
    // === VARIE ===
    { name: 'Sticker', icon: Sticker, category: 'Varie' },
    { name: 'Archive', icon: Archive, category: 'Varie' },
    { name: 'Briefcase', icon: Briefcase, category: 'Varie' },
    { name: 'Flashlight', icon: Flashlight, category: 'Varie' },
    { name: 'Bone', icon: Bone, category: 'Varie' },
    
    // === FANTASY & GAMING ===
    { name: 'Swords', icon: Swords, category: 'Fantasy' },
    { name: 'Sword', icon: Sword, category: 'Fantasy' },
    { name: 'Shield', icon: Shield, category: 'Fantasy' },
    { name: 'Wand2', icon: Wand2, category: 'Fantasy' },
    { name: 'Wand', icon: Wand, category: 'Fantasy' },
    { name: 'Drama', icon: Drama, category: 'Fantasy' },
    { name: 'Skull', icon: Skull, category: 'Fantasy' },
    { name: 'Ghost', icon: Ghost, category: 'Fantasy' },
    
    // === SHOPPING & FINANZA EXTRA ===
    { name: 'Receipt', icon: Receipt, category: 'Finanza' },
    { name: 'CreditCard', icon: CreditCard, category: 'Finanza' },
    { name: 'Banknote', icon: Banknote, category: 'Finanza' },
    { name: 'Coins', icon: Coins, category: 'Finanza' },
    { name: 'PiggyBank', icon: PiggyBank, category: 'Finanza' },
    { name: 'BadgePercent', icon: BadgePercent, category: 'Finanza' },
    { name: 'Wallet2', icon: Wallet2, category: 'Finanza' },
    { name: 'Calculator', icon: Calculator, category: 'Finanza' },
    { name: 'Percent', icon: Percent, category: 'Finanza' },
    { name: 'DollarSign', icon: DollarSign, category: 'Finanza' },
    { name: 'Euro', icon: Euro, category: 'Finanza' },
    { name: 'PoundSterling', icon: PoundSterling, category: 'Finanza' },
    
    // === ARTE EXTRA ===
    { name: 'Paintbrush', icon: Paintbrush, category: 'Arte' },
    { name: 'Pencil', icon: Pencil, category: 'Arte' },
    { name: 'PenLine', icon: PenLine, category: 'Arte' },
    { name: 'Figma', icon: Figma, category: 'Arte' },
    { name: 'Origami', icon: Origami, category: 'Arte' },
    
    // === CASA & GIARDINO EXTRA ===
    { name: 'DoorClosed', icon: DoorClosed, category: 'Casa' },
    { name: 'Flower', icon: Flower, category: 'Giardino' },
    { name: 'Sprout', icon: Sprout, category: 'Giardino' },
    { name: 'TreeDeciduous', icon: TreeDeciduous, category: 'Giardino' },
    
    // === ANIMALI EXTRA ===
    { name: 'PawPrint', icon: PawPrint, category: 'Animali' },
    
    // === NATURA & OUTDOOR EXTRA ===
    { name: 'Waves', icon: Waves, category: 'Natura' },
    { name: 'Tent', icon: Tent, category: 'Outdoor' },
    { name: 'Backpack', icon: Backpack, category: 'Outdoor' },
    { name: 'CloudSun', icon: CloudSun, category: 'Meteo' },
    { name: 'CloudMoon', icon: CloudMoon, category: 'Meteo' },
    
    // === SCIENZA & TECH EXTRA ===
    { name: 'Rocket', icon: Rocket, category: 'Tech' },
    { name: 'Atom', icon: Atom, category: 'Scienza' },
    { name: 'Orbit', icon: Orbit, category: 'Scienza' },
    { name: 'Satellite', icon: Satellite, category: 'Tech' },
    { name: 'Cpu', icon: Cpu, category: 'Tech' },
    { name: 'HardDrive', icon: HardDrive, category: 'Tech' },
    { name: 'Server', icon: Server, category: 'Tech' },
    { name: 'Database', icon: Database, category: 'Tech' },
    { name: 'Code', icon: Code, category: 'Tech' },
    { name: 'Terminal', icon: Terminal, category: 'Tech' },
    { name: 'Binary', icon: Binary, category: 'Tech' },
    { name: 'QrCode', icon: QrCode, category: 'Tech' },
    { name: 'Barcode', icon: Barcode, category: 'Tech' },
    { name: 'ScanLine', icon: ScanLine, category: 'Tech' },
    { name: 'Scan', icon: Scan, category: 'Tech' },
    
    // === COSTRUZIONE ===
    { name: 'Shovel', icon: Shovel, category: 'Strumenti' },
    { name: 'Axe', icon: Axe, category: 'Strumenti' },
    { name: 'Pickaxe', icon: Pickaxe, category: 'Strumenti' },
    { name: 'Scale', icon: Scale, category: 'Strumenti' },
    { name: 'Construction', icon: Construction, category: 'Strumenti' },
    { name: 'HardHat', icon: HardHat, category: 'Strumenti' },
    { name: 'Cone', icon: Cone, category: 'Strumenti' },
    
    // === CIBO EXTRA ===
    { name: 'Wheat', icon: Wheat, category: 'Cibo' },
    { name: 'Carrot', icon: Carrot, category: 'Cibo' },
    { name: 'Nut', icon: Nut, category: 'Cibo' },
    { name: 'Banana', icon: Banana, category: 'Cibo' },
    { name: 'Milk', icon: Milk, category: 'Cibo' },
    { name: 'GlassWater', icon: GlassWater, category: 'Cucina' },
    { name: 'Martini', icon: Martini, category: 'Cucina' },
    { name: 'Utensils', icon: Utensils, category: 'Cucina' },
    
    // === PERSONE & SOCIAL EXTRA ===
    { name: 'HeartHandshake', icon: HeartHandshake, category: 'Persone' },
    { name: 'Handshake', icon: Handshake, category: 'Persone' },
    { name: 'Users2', icon: Users2, category: 'Persone' },
    { name: 'UserPlus', icon: UserPlus, category: 'Persone' },
    { name: 'UserMinus', icon: UserMinus, category: 'Persone' },
    { name: 'UserCheck', icon: UserCheck, category: 'Persone' },
    { name: 'UserX', icon: UserX, category: 'Persone' },
    
    // === GIOCHI CARTE/DADI ===
    { name: 'Dice1', icon: Dice1, category: 'Giochi' },
    { name: 'Dice2', icon: Dice2, category: 'Giochi' },
    { name: 'Dice3', icon: Dice3, category: 'Giochi' },
    { name: 'Dice4', icon: Dice4, category: 'Giochi' },
    { name: 'Dice5', icon: Dice5, category: 'Giochi' },
    { name: 'Dice6', icon: Dice6, category: 'Giochi' },
    { name: 'Spade', icon: Spade, category: 'Giochi' },
    { name: 'Club', icon: Club, category: 'Giochi' },
    
    // === TRASPORTI EXTRA ===
    { name: 'Train', icon: Train, category: 'Trasporti' },
    { name: 'PlaneTakeoff', icon: PlaneTakeoff, category: 'Trasporti' },
    { name: 'PlaneLanding', icon: PlaneLanding, category: 'Trasporti' },
    { name: 'Truck', icon: Truck, category: 'Trasporti' },
    
    // === COMUNICAZIONE EXTRA ===
    { name: 'Bell', icon: Bell, category: 'Comunicazione' },
    { name: 'BellOff', icon: BellOff, category: 'Comunicazione' },
    { name: 'BellRing', icon: BellRing, category: 'Comunicazione' },
    { name: 'Megaphone', icon: Megaphone, category: 'Comunicazione' },
    { name: 'MessageSquare', icon: MessageSquare, category: 'Comunicazione' },
    { name: 'MessagesSquare', icon: MessagesSquare, category: 'Comunicazione' },
    { name: 'AtSign', icon: AtSign, category: 'Comunicazione' },
    { name: 'Hash', icon: Hash, category: 'Comunicazione' },
    
    // === GRAFICI & ANALYTICS ===
    { name: 'Activity', icon: Activity, category: 'Analytics' },
    { name: 'BarChart', icon: BarChart, category: 'Analytics' },
    { name: 'BarChart2', icon: BarChart2, category: 'Analytics' },
    { name: 'BarChart3', icon: BarChart3, category: 'Analytics' },
    { name: 'PieChart', icon: PieChart, category: 'Analytics' },
    { name: 'LineChart', icon: LineChart, category: 'Analytics' },
    { name: 'TrendingUp', icon: TrendingUp, category: 'Analytics' },
    { name: 'TrendingDown', icon: TrendingDown, category: 'Analytics' },
    
    // === CONNETTIVITÀ ===
    { name: 'Wifi', icon: Wifi, category: 'Tech' },
    { name: 'WifiOff', icon: WifiOff, category: 'Tech' },
    { name: 'Bluetooth', icon: Bluetooth, category: 'Tech' },
    { name: 'BluetoothOff', icon: BluetoothOff, category: 'Tech' },
    { name: 'Signal', icon: Signal, category: 'Tech' },
    { name: 'SignalHigh', icon: SignalHigh, category: 'Tech' },
    { name: 'SignalLow', icon: SignalLow, category: 'Tech' },
    
    // === BATTERIA & POWER ===
    { name: 'Battery', icon: Battery, category: 'Tech' },
    { name: 'BatteryCharging', icon: BatteryCharging, category: 'Tech' },
    { name: 'BatteryFull', icon: BatteryFull, category: 'Tech' },
    { name: 'BatteryLow', icon: BatteryLow, category: 'Tech' },
    { name: 'BatteryMedium', icon: BatteryMedium, category: 'Tech' },
    { name: 'Power', icon: Power, category: 'Tech' },
    { name: 'PowerOff', icon: PowerOff, category: 'Tech' },
    
    // === FILE & IMMAGINI ===
    { name: 'Image', icon: Image, category: 'File' },
    { name: 'ImagePlus', icon: ImagePlus, category: 'File' },
    { name: 'Images', icon: Images, category: 'File' },
    { name: 'FileImage', icon: FileImage, category: 'File' },
    { name: 'Folder', icon: Folder, category: 'File' },
    { name: 'FolderOpen', icon: FolderOpen, category: 'File' },
    { name: 'File', icon: File, category: 'File' },
    { name: 'FileText', icon: FileText, category: 'File' },
    { name: 'FilePlus', icon: FilePlus, category: 'File' },
    { name: 'Paperclip', icon: Paperclip, category: 'File' },
    { name: 'Pin', icon: Pin, category: 'File' },
    { name: 'PinOff', icon: PinOff, category: 'File' },
    { name: 'BookmarkPlus', icon: BookmarkPlus, category: 'File' },
    
    // === AZIONI UI ===
    { name: 'Eye', icon: Eye, category: 'UI' },
    { name: 'EyeOff', icon: EyeOff, category: 'UI' },
    { name: 'Search', icon: Search, category: 'UI' },
    { name: 'Plus', icon: Plus, category: 'UI' },
    { name: 'Minus', icon: Minus, category: 'UI' },
    { name: 'X', icon: X, category: 'UI' },
    { name: 'Check', icon: Check, category: 'UI' },
    { name: 'Info', icon: Info, category: 'UI' },
    { name: 'AlertTriangle', icon: AlertTriangle, category: 'UI' },
    { name: 'HelpCircle', icon: HelpCircle, category: 'UI' },
    { name: 'Settings', icon: Settings, category: 'UI' },
    { name: 'Settings2', icon: Settings2, category: 'UI' },
    { name: 'Sliders', icon: Sliders, category: 'UI' },
    { name: 'SlidersHorizontal', icon: SlidersHorizontal, category: 'UI' },
    { name: 'MoreHorizontal', icon: MoreHorizontal, category: 'UI' },
    { name: 'MoreVertical', icon: MoreVertical, category: 'UI' },
    { name: 'Menu', icon: Menu, category: 'UI' },
    { name: 'Grid', icon: Grid, category: 'UI' },
    { name: 'List', icon: List, category: 'UI' },
    { name: 'Layout', icon: Layout, category: 'UI' },
    { name: 'Download', icon: Download, category: 'UI' },
    { name: 'Upload', icon: Upload, category: 'UI' },
    { name: 'Share', icon: Share, category: 'UI' },
    { name: 'Share2', icon: Share2, category: 'UI' },
    { name: 'Link2', icon: Link2, category: 'UI' },
    { name: 'ExternalLink', icon: ExternalLink, category: 'UI' },
    { name: 'Copy', icon: Copy, category: 'UI' },
    { name: 'Clipboard', icon: Clipboard, category: 'UI' },
    { name: 'ClipboardCheck', icon: ClipboardCheck, category: 'UI' },
    { name: 'Trash', icon: Trash, category: 'UI' },
    { name: 'Trash2', icon: Trash2, category: 'UI' },
    { name: 'Edit', icon: Edit, category: 'UI' },
    { name: 'Edit2', icon: Edit2, category: 'UI' },
    { name: 'Edit3', icon: Edit3, category: 'UI' },
    { name: 'Save', icon: Save, category: 'UI' },
    { name: 'RefreshCw', icon: RefreshCw, category: 'UI' },
    { name: 'RotateCw', icon: RotateCw, category: 'UI' },
    { name: 'Lock', icon: Lock, category: 'UI' },
    { name: 'Unlock', icon: Unlock, category: 'UI' },
    { name: 'LockKeyhole', icon: LockKeyhole, category: 'UI' },
    { name: 'LockOpen', icon: LockOpen, category: 'UI' },
    { name: 'LogIn', icon: LogIn, category: 'UI' },
    { name: 'LogOut', icon: LogOut, category: 'UI' },
    
    // === FRECCE ===
    { name: 'ArrowUp', icon: ArrowUp, category: 'Frecce' },
    { name: 'ArrowDown', icon: ArrowDown, category: 'Frecce' },
    { name: 'ArrowLeft', icon: ArrowLeft, category: 'Frecce' },
    { name: 'ArrowRight', icon: ArrowRight, category: 'Frecce' },
    { name: 'ArrowUpRight', icon: ArrowUpRight, category: 'Frecce' },
    { name: 'ChevronUp', icon: ChevronUp, category: 'Frecce' },
    { name: 'ChevronsUp', icon: ChevronsUp, category: 'Frecce' },
    { name: 'ChevronsDown', icon: ChevronsDown, category: 'Frecce' },
    { name: 'ChevronsLeft', icon: ChevronsLeft, category: 'Frecce' },
    { name: 'ChevronsRight', icon: ChevronsRight, category: 'Frecce' },
    
    // === MEDIA PLAYER ===
    { name: 'Play', icon: Play, category: 'Media' },
    { name: 'Pause', icon: Pause, category: 'Media' },
    { name: 'StopCircle', icon: StopCircle, category: 'Media' },
    { name: 'SkipBack', icon: SkipBack, category: 'Media' },
    { name: 'SkipForward', icon: SkipForward, category: 'Media' },
    { name: 'Volume2', icon: Volume2, category: 'Media' },
    { name: 'VolumeX', icon: VolumeX, category: 'Media' },
    { name: 'Maximize', icon: Maximize, category: 'Media' },
    { name: 'Minimize', icon: Minimize, category: 'Media' },
    { name: 'ZoomIn', icon: ZoomIn, category: 'Media' },
    { name: 'ZoomOut', icon: ZoomOut, category: 'Media' },
    
    // === EMAIL EXTRA ===
    { name: 'Inbox', icon: Inbox, category: 'Email' },
    { name: 'Forward', icon: Forward, category: 'Email' },
    { name: 'Reply', icon: Reply, category: 'Email' },
    { name: 'ReplyAll', icon: ReplyAll, category: 'Email' },
    
    // === DISPOSITIVI ===
    { name: 'Printer', icon: Printer, category: 'Dispositivi' },
    
    // === EMOZIONI ===
    { name: 'ThumbsUp', icon: ThumbsUp, category: 'Emozioni' },
    { name: 'ThumbsDown', icon: ThumbsDown, category: 'Emozioni' },
    { name: 'Smile', icon: Smile, category: 'Emozioni' },
    { name: 'Frown', icon: Frown, category: 'Emozioni' },
    { name: 'Meh', icon: Meh, category: 'Emozioni' },
    { name: 'Angry', icon: Angry, category: 'Emozioni' },
    { name: 'Laugh', icon: Laugh, category: 'Emozioni' },
    
    // === INTERNAZIONALE ===
    { name: 'Globe2', icon: Globe2, category: 'Mappe' },
    { name: 'Languages', icon: Languages, category: 'Varie' },
    
    // === SPEDIZIONI ===
    { name: 'PackageCheck', icon: PackageCheck, category: 'Shopping' },
    { name: 'PackageX', icon: PackageX, category: 'Shopping' },
    { name: 'PackageSearch', icon: PackageSearch, category: 'Shopping' },
    { name: 'Boxes', icon: Boxes, category: 'Shopping' },
    
    // === ALTRO ===
    { name: 'GalleryHorizontal', icon: GalleryHorizontal, category: 'Varie' },
    { name: 'FlagTriangleRight', icon: FlagTriangleRight, category: 'Varie' },
    { name: 'Home', icon: Home, category: 'Casa' },
  ];

  // Get icon component by name
  const getIconByName = (iconName) => {
    const found = ICON_PRESETS.find(i => i.name === iconName);
    return found ? found.icon : Package;
  };

  // Check admin access
  useEffect(() => {
    if (!user) {
      navigate('/login');
      return;
    }
    if (profile && !profile.is_admin) {
      toast.error('Accesso non autorizzato');
      navigate('/');
      return;
    }
    
    // Only load data on first mount, not on visibility changes or re-renders
    if (!initialLoadDone.current && profile?.is_admin) {
      initialLoadDone.current = true;
      loadDashboardData();
    }
  }, [user, profile, navigate]);

  const loadDashboardData = async () => {
    setLoading(true);
    try {
      await Promise.all([
        loadStats(),
        loadUsers(),
        loadOrders(),
        loadRequests(),
        loadPlatformSettings(),
        loadCategories(),
        loadRequestOptions(),
        fetchContactMessages(),
        loadOAuthProviders(),
        loadAnalyticsConfig(),
        loadStripeConfig()
      ]);
    } catch (error) {
      console.error('Error loading admin data:', error);
      toast.error('Errore nel caricamento dei dati');
    } finally {
      setLoading(false);
    }
  };

  const loadPlatformSettings = async () => {
    // Load launch mode from database
    loadLaunchMode();
    
    // Load premium features setting
    const savedPremiumFeatures = localStorage.getItem('rarifex_premium_features_enabled');
    setPremiumFeaturesEnabled(savedPremiumFeatures !== 'false'); // Default true
    
    // Load maintenance mode from database
    loadMaintenanceMode();
    
    // Load hero images
    loadHeroImages();
    
    // Load checkout mode from database
    loadCheckoutMode();
  };

  const loadCheckoutMode = async () => {
    try {
      const API_URL = process.env.REACT_APP_BACKEND_URL;
      const response = await adminFetch(`${API_URL}/api/settings/checkout-mode`);
      if (response.ok) {
        const data = await response.json();
        setCheckoutMode(data.checkout_mode === 'express' ? 'express' : 'redirect');
      }
    } catch (error) {
      console.error('Error loading checkout mode:', error);
    }
  };

  const toggleCheckoutMode = async (useExpress) => {
    const mode = useExpress ? 'express' : 'redirect';
    setSavingSettings(true);
    try {
      const API_URL = process.env.REACT_APP_BACKEND_URL;
      const response = await adminFetch(`${API_URL}/api/settings/checkout-mode?mode=${mode}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
      });
      if (!response.ok) throw new Error('Failed to save checkout mode');
      setCheckoutMode(mode);
      window.dispatchEvent(new CustomEvent('checkoutModeChanged', { detail: { mode } }));
      toast.success(
        mode === 'express'
          ? 'Checkout Express attivato — Pulsanti in-page'
          : 'Checkout Redirect (Stripe hosted) attivo'
      );
      logAdminAction?.('toggle_checkout_mode', 'platform', null, { checkout_mode: mode });
    } catch (error) {
      console.error('Error saving checkout mode:', error);
      toast.error('Errore nel salvataggio');
    } finally {
      setSavingSettings(false);
    }
  };

  const loadLaunchMode = async () => {
    try {
      const API_URL = process.env.REACT_APP_BACKEND_URL;
      const response = await adminFetch(`${API_URL}/api/settings/launch-mode`);
      if (response.ok) {
        const data = await response.json();
        const enabled = data.launch_mode === true;
        setLaunchMode(enabled);
        // Sync to localStorage for feeCalculator
        localStorage.setItem('rarifex_launch_mode', enabled.toString());
      }
    } catch (error) {
      console.error('Error loading launch mode:', error);
      // Fallback to localStorage
      const savedLaunchMode = localStorage.getItem('rarifex_launch_mode');
      setLaunchMode(savedLaunchMode === 'true');
    }
  };

  const loadMaintenanceMode = async () => {
    try {
      const { data, error } = await supabase
        .from('site_settings')
        .select('value')
        .eq('key', 'maintenance_mode')
        .single();
      
      if (!error && data) {
        setMaintenanceMode(data.value === true);
      } else {
        setMaintenanceMode(false);
      }
    } catch (error) {
      console.error('Error loading maintenance mode:', error);
      setMaintenanceMode(false);
    }
  };

  const loadHeroImages = async () => {
    setLoadingHeroImages(true);
    try {
      // Try backend first, fallback to Supabase
      const API_URL = process.env.REACT_APP_BACKEND_URL;
      try {
        const response = await adminFetch(`${API_URL}/api/settings/hero-images`);
        if (response.ok) {
          const data = await response.json();
          setHeroImages(data.images || []);
          setLoadingHeroImages(false);
          return;
        }
      } catch (backendError) {
        console.log('Backend not available, using Supabase directly');
      }
      
      // Fallback: Supabase direct
      const { data, error } = await supabase
        .from('site_settings')
        .select('value')
        .eq('key', 'hero_images')
        .single();
      
      if (!error && data) {
        setHeroImages(data.value || []);
      }
    } catch (error) {
      console.error('Error loading hero images:', error);
    } finally {
      setLoadingHeroImages(false);
    }
  };

  const addHeroImage = async () => {
    if (!newHeroImageUrl.trim()) {
      toast.error('Inserisci un URL valido');
      return;
    }
    
    // Simple URL validation
    try {
      new URL(newHeroImageUrl);
    } catch {
      toast.error('URL non valido');
      return;
    }
    
    const updatedImages = [...heroImages, newHeroImageUrl.trim()];
    await saveHeroImages(updatedImages);
    setNewHeroImageUrl('');
  };

  const removeHeroImage = async (index) => {
    if (heroImages.length <= 1) {
      toast.error('Devi avere almeno un\'immagine');
      return;
    }
    
    const updatedImages = heroImages.filter((_, i) => i !== index);
    await saveHeroImages(updatedImages);
  };

  const saveHeroImages = async (images) => {
    setLoadingHeroImages(true);
    try {
      // Try backend first, fallback to Supabase
      const API_URL = process.env.REACT_APP_BACKEND_URL;
      try {
        const response = await adminFetch(`${API_URL}/api/settings/hero-images`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(images)
        });
        
        if (response.ok) {
          setHeroImages(images);
          toast.success('Immagini salvate con successo');
          setLoadingHeroImages(false);
          return;
        }
      } catch (backendError) {
        console.log('Backend not available, using Supabase directly');
      }
      
      // Fallback: Supabase direct
      const { data: existing } = await supabase
        .from('site_settings')
        .select('id')
        .eq('key', 'hero_images')
        .single();
      
      if (existing) {
        const { error } = await supabase
          .from('site_settings')
          .update({ value: images, updated_at: new Date().toISOString() })
          .eq('key', 'hero_images');
        
        if (error) throw error;
      } else {
        const { error } = await supabase
          .from('site_settings')
          .insert({ key: 'hero_images', value: images });
        
        if (error) throw error;
      }
      
      setHeroImages(images);
      toast.success('Immagini salvate con successo');
    } catch (error) {
      console.error('Error saving hero images:', error);
      toast.error('Errore nel salvataggio: ' + (error.message || ''));
    } finally {
      setLoadingHeroImages(false);
    }
  };

  // ==================== OAuth Providers Functions ====================
  
  const loadOAuthProviders = async () => {
    setLoadingOAuth(true);
    try {
      const response = await adminFetch(`${API_URL}/api/admin/oauth-providers`);
      if (response.ok) {
        const data = await response.json();
        const providers = data.providers || [];
        
        // Set individual provider configs
        const google = providers.find(p => p.provider_name === 'google');
        const facebook = providers.find(p => p.provider_name === 'facebook');
        
        if (google) {
          setGoogleConfig({
            client_id: google.client_id || '',
            client_secret: '', // Don't show actual secret
            client_secret_masked: google.client_secret_masked || '',
            has_secret: google.has_secret || false,
            is_enabled: google.is_enabled || false
          });
        }
        
        if (facebook) {
          setFacebookConfig({
            client_id: facebook.client_id || '',
            client_secret: '',
            client_secret_masked: facebook.client_secret_masked || '',
            has_secret: facebook.has_secret || false,
            is_enabled: facebook.is_enabled || false
          });
        }
        
        setOauthProviders(providers);
      }
    } catch (error) {
      console.error('Error loading OAuth providers:', error);
    } finally {
      setLoadingOAuth(false);
    }
  };

  const saveOAuthProvider = async (providerName, config) => {
    setSavingOAuth(true);
    try {
      const payload = {
        provider_name: providerName,
        client_id: config.client_id || null
      };
      
      // Only include secret if it was changed (not empty)
      if (config.client_secret && config.client_secret.trim() !== '') {
        payload.client_secret = config.client_secret;
      }
      
      const response = await adminFetch(`${API_URL}/api/admin/oauth-providers`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      
      const result = await response.json();
      
      if (result.success) {
        toast.success(`Configurazione ${providerName} salvata`);
        loadOAuthProviders(); // Reload to get masked secret
        return true;
      } else {
        toast.error(result.error || 'Errore nel salvataggio');
        return false;
      }
    } catch (error) {
      toast.error('Errore: ' + error.message);
      return false;
    } finally {
      setSavingOAuth(false);
    }
  };

  const toggleOAuthProvider = async (providerName) => {
    try {
      const response = await adminFetch(`${API_URL}/api/admin/oauth-providers/${providerName}/toggle`, {
        method: 'PATCH'
      });
      
      const result = await response.json();
      
      if (result.success) {
        toast.success(result.message);
        
        // Update local state
        if (providerName === 'google') {
          setGoogleConfig(prev => ({ ...prev, is_enabled: result.is_enabled }));
        } else if (providerName === 'facebook') {
          setFacebookConfig(prev => ({ ...prev, is_enabled: result.is_enabled }));
        }
      } else {
        toast.error(result.error || 'Errore');
      }
    } catch (error) {
      toast.error('Errore: ' + error.message);
    }
  };

  // ==================== Google Analytics Functions ====================

  const loadAnalyticsConfig = async () => {
    setLoadingAnalytics(true);
    try {
      const response = await adminFetch(`${API_URL}/api/admin/analytics`);
      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          setAnalyticsConfig({
            measurement_id: data.config?.measurement_id || '',
            anonymize_ip: data.config?.anonymize_ip ?? true,
            cookie_consent_required: data.config?.cookie_consent_required ?? true,
            is_enabled: data.is_enabled || false
          });
        }
      }
    } catch (error) {
      console.error('Error loading analytics config:', error);
    } finally {
      setLoadingAnalytics(false);
    }
  };

  const saveAnalyticsConfig = async () => {
    setSavingAnalytics(true);
    try {
      const response = await adminFetch(`${API_URL}/api/admin/analytics`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          measurement_id: analyticsConfig.measurement_id,
          anonymize_ip: analyticsConfig.anonymize_ip,
          cookie_consent_required: analyticsConfig.cookie_consent_required
        })
      });
      
      const result = await response.json();
      
      if (result.success) {
        toast.success('Configurazione Analytics salvata');
        return true;
      } else {
        toast.error(result.error || 'Errore nel salvataggio');
        return false;
      }
    } catch (error) {
      toast.error('Errore: ' + error.message);
      return false;
    } finally {
      setSavingAnalytics(false);
    }
  };

  const toggleAnalytics = async () => {
    try {
      const response = await adminFetch(`${API_URL}/api/admin/analytics/toggle`, {
        method: 'PATCH'
      });
      
      const result = await response.json();
      
      if (result.success) {
        toast.success(result.message);
        setAnalyticsConfig(prev => ({ ...prev, is_enabled: result.is_enabled }));
      } else {
        toast.error(result.error || 'Errore');
      }
    } catch (error) {
      toast.error('Errore: ' + error.message);
    }
  };

  // ==================== Stripe Configuration Functions ====================
  
  const loadStripeConfig = async () => {
    setLoadingStripe(true);
    try {
      const response = await adminFetch(`${API_URL}/api/admin/stripe`);
      const result = await response.json();
      
      if (result.success) {
        setStripeConfig({
          // Write-only inputs vuoti a load
          api_key: '',
          webhook_secret: '',
          fee_reconcile_webhook_secret: '',
          api_key_test: '',
          webhook_secret_test: '',
          fee_reconcile_webhook_secret_test: '',
          // Readable fields
          connect_client_id: result.config?.connect_client_id || '',
          publishable_key: result.config?.publishable_key || '',
          connect_client_id_test: result.config?.connect_client_id_test || '',
          publishable_key_test: result.config?.publishable_key_test || '',
          platform_fee_percent: result.config?.platform_fee_percent || 10.0,
          is_live_mode: result.config?.is_live_mode || false,
          is_enabled: result.is_enabled || false,
          enabled_payment_methods: result.config?.enabled_payment_methods || [],
          // Server flags LIVE
          has_api_key: result.config?.has_api_key || false,
          has_webhook_secret: result.config?.has_webhook_secret || false,
          has_fee_reconcile_webhook_secret: result.config?.has_fee_reconcile_webhook_secret || false,
          api_key_masked: result.config?.api_key_masked || '',
          webhook_secret_masked: result.config?.webhook_secret_masked || '',
          fee_reconcile_webhook_secret_masked: result.config?.fee_reconcile_webhook_secret_masked || '',
          // Server flags TEST
          has_api_key_test: result.config?.has_api_key_test || false,
          has_webhook_secret_test: result.config?.has_webhook_secret_test || false,
          has_fee_reconcile_webhook_secret_test: result.config?.has_fee_reconcile_webhook_secret_test || false,
          api_key_test_masked: result.config?.api_key_test_masked || '',
          webhook_secret_test_masked: result.config?.webhook_secret_test_masked || '',
          fee_reconcile_webhook_secret_test_masked: result.config?.fee_reconcile_webhook_secret_test_masked || '',
        });
      }
    } catch (error) {
      console.error('Error loading Stripe config:', error);
    } finally {
      setLoadingStripe(false);
    }
  };

  const saveStripeConfig = async () => {
    setSavingStripe(true);
    try {
      const payload = {
        // LIVE
        connect_client_id: stripeConfig.connect_client_id,
        publishable_key: stripeConfig.publishable_key,
        // TEST
        connect_client_id_test: stripeConfig.connect_client_id_test,
        publishable_key_test: stripeConfig.publishable_key_test,
        // Common
        platform_fee_percent: stripeConfig.platform_fee_percent,
        is_live_mode: stripeConfig.is_live_mode,
        enabled_payment_methods: stripeConfig.enabled_payment_methods || [],
      };

      // Solo se l'utente ha immesso nuove chiavi sensibili le inviamo
      if (stripeConfig.api_key && stripeConfig.api_key.trim()) {
        payload.api_key = stripeConfig.api_key.trim();
      }
      if (stripeConfig.webhook_secret && stripeConfig.webhook_secret.trim()) {
        payload.webhook_secret = stripeConfig.webhook_secret.trim();
      }
      if (stripeConfig.fee_reconcile_webhook_secret && stripeConfig.fee_reconcile_webhook_secret.trim()) {
        payload.fee_reconcile_webhook_secret = stripeConfig.fee_reconcile_webhook_secret.trim();
      }
      if (stripeConfig.api_key_test && stripeConfig.api_key_test.trim()) {
        payload.api_key_test = stripeConfig.api_key_test.trim();
      }
      if (stripeConfig.webhook_secret_test && stripeConfig.webhook_secret_test.trim()) {
        payload.webhook_secret_test = stripeConfig.webhook_secret_test.trim();
      }
      if (stripeConfig.fee_reconcile_webhook_secret_test && stripeConfig.fee_reconcile_webhook_secret_test.trim()) {
        payload.fee_reconcile_webhook_secret_test = stripeConfig.fee_reconcile_webhook_secret_test.trim();
      }

      const response = await adminFetch(`${API_URL}/api/admin/stripe`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      
      const result = await response.json();
      
      if (result.success) {
        toast.success('Configurazione Stripe salvata');
        // Clear sensitive fields and reload
        setStripeConfig(prev => ({
          ...prev,
          api_key: '', webhook_secret: '', fee_reconcile_webhook_secret: '',
          api_key_test: '', webhook_secret_test: '', fee_reconcile_webhook_secret_test: '',
        }));
        await loadStripeConfig();
      } else {
        toast.error(result.error || 'Errore nel salvataggio');
      }
    } catch (error) {
      toast.error('Errore: ' + error.message);
    } finally {
      setSavingStripe(false);
    }
  };

  const toggleStripe = async () => {
    try {
      const response = await adminFetch(`${API_URL}/api/admin/stripe/toggle`, {
        method: 'PATCH'
      });
      
      const result = await response.json();
      
      if (result.success) {
        toast.success(result.message);
        setStripeConfig(prev => ({ ...prev, is_enabled: result.is_enabled }));
      } else {
        toast.error(result.error || 'Errore');
      }
    } catch (error) {
      toast.error('Errore: ' + error.message);
    }
  };

  const toggleLaunchMode = async (enabled) => {
    setSavingSettings(true);
    try {
      const API_URL = process.env.REACT_APP_BACKEND_URL;
      const response = await adminFetch(`${API_URL}/api/settings/launch-mode?enabled=${enabled}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      });
      
      if (!response.ok) throw new Error('Failed to save launch mode');
      
      // Sync to localStorage for feeCalculator
      localStorage.setItem('rarifex_launch_mode', enabled.toString());
      setLaunchMode(enabled);
      
      // Dispatch event so other components can react
      window.dispatchEvent(new CustomEvent('launchModeChanged', { detail: { enabled } }));
      
      toast.success(enabled 
        ? 'Modalità lancio attivata - Commissioni Rarifex azzerate' 
        : 'Modalità lancio disattivata - Commissioni Rarifex attive'
      );
      
      logAdminAction('toggle_launch_mode', 'platform', null, { launch_mode: enabled });
    } catch (error) {
      console.error('Error saving launch mode:', error);
      toast.error('Errore nel salvataggio');
    } finally {
      setSavingSettings(false);
    }
  };

  const toggleMaintenanceMode = async (enabled) => {
    setSavingSettings(true);
    try {
      // Check if setting exists
      const { data: existing } = await supabase
        .from('site_settings')
        .select('id')
        .eq('key', 'maintenance_mode')
        .single();
      
      if (existing) {
        // Update existing
        const { error } = await supabase
          .from('site_settings')
          .update({ value: enabled, updated_at: new Date().toISOString() })
          .eq('key', 'maintenance_mode');
        
        if (error) throw error;
      } else {
        // Insert new
        const { error } = await supabase
          .from('site_settings')
          .insert({ key: 'maintenance_mode', value: enabled });
        
        if (error) throw error;
      }
      
      setMaintenanceMode(enabled);
      
      // Dispatch event so App.js can react (for admin's own session)
      window.dispatchEvent(new CustomEvent('maintenanceModeChanged', { detail: { enabled } }));
      
      toast.success(enabled 
        ? 'Modalità manutenzione attivata - Sito bloccato per i visitatori' 
        : 'Modalità manutenzione disattivata - Sito aperto a tutti'
      );
      
      logAdminAction('toggle_maintenance_mode', 'platform', null, { maintenance_mode: enabled });
    } catch (error) {
      console.error('Error toggling maintenance mode:', error);
      toast.error('Errore nel salvataggio: ' + (error.message || 'Errore sconosciuto'));
    } finally {
      setSavingSettings(false);
    }
  };

  const togglePremiumFeatures = async (enabled) => {
    setSavingSettings(true);
    try {
      localStorage.setItem('rarifex_premium_features_enabled', enabled.toString());
      setPremiumFeaturesEnabled(enabled);
      
      // Dispatch event so other components can react
      window.dispatchEvent(new CustomEvent('premiumFeaturesChanged', { detail: { enabled } }));
      
      toast.success(enabled 
        ? 'Funzionalità Premium attivate - I vantaggi premium sono riservati agli abbonati' 
        : 'Funzionalità Premium disattivate - Tutti gli utenti hanno accesso ai vantaggi premium'
      );
      
      logAdminAction('toggle_premium_features', 'platform', null, { premium_features_enabled: enabled });
    } catch (error) {
      console.error('Error toggling premium features:', error);
      toast.error('Errore nel salvataggio');
    } finally {
      setSavingSettings(false);
    }
  };

  const loadStats = async () => {
    try {
      // Try backend API first
      const API_URL = process.env.REACT_APP_BACKEND_URL;
      try {
        const response = await adminFetch(`${API_URL}/api/admin/stats`);
        if (response.ok) {
          const data = await response.json();
          if (!data.error) {
            setStats({
              totalUsers: data.totalUsers || 0,
              totalCrafters: data.totalCrafters || 0,
              totalOrders: data.totalOrders || 0,
              totalRequests: data.totalRequests || 0,
              totalRevenue: data.totalRevenue || 0,
              pendingRequests: data.pendingRequests || 0
            });
            return;
          }
        }
      } catch (backendError) {
        console.log('Backend not available for stats, using Supabase directly');
      }
      
      // Fallback to direct Supabase queries
      const [usersRes, craftersRes, ordersRes, requestsRes, pendingRes] = await Promise.all([
        supabase.from('profiles').select('*', { count: 'exact', head: true }),
        supabase.from('profiles').select('*', { count: 'exact', head: true }).eq('is_crafter_enabled', true),
        supabase.from('orders').select('*', { count: 'exact', head: true }),
        supabase.from('direct_requests').select('*', { count: 'exact', head: true }),
        supabase.from('direct_requests').select('*', { count: 'exact', head: true }).eq('status', 'open')
      ]);

      setStats({
        totalUsers: usersRes.count || 0,
        totalCrafters: craftersRes.count || 0,
        totalOrders: ordersRes.count || 0,
        totalRequests: requestsRes.count || 0,
        totalRevenue: 0,
        pendingRequests: pendingRes.count || 0
      });
    } catch (error) {
      console.error('Error loading stats:', error);
    }
  };

  const loadUsers = async () => {
    const { data, error } = await supabase
      .from('profiles')
      .select('*')
      .order('created_at', { ascending: false });

    if (error) throw error;
    setUsers(data || []);
  };

  const loadOrders = async () => {
    try {
      // Try backend API first
      const API_URL = process.env.REACT_APP_BACKEND_URL;
      try {
        const response = await adminFetch(`${API_URL}/api/admin/orders`);
        if (response.ok) {
          const data = await response.json();
          if (!data.error && data.orders) {
            setOrders(data.orders);
            return;
          }
        }
      } catch (backendError) {
        console.log('Backend not available for orders, using Supabase directly');
      }
      
      // Fallback to direct Supabase query
      const { data, error: dbError } = await supabase
        .from('orders')
        .select(`
          *,
          client:client_id(id, full_name, email),
          crafter:crafter_id(id, full_name, storefront_title)
        `)
        .order('created_at', { ascending: false });

      if (dbError) {
        console.error('Supabase orders error:', dbError);
      }
      setOrders(data || []);
    } catch (error) {
      console.error('Error loading orders:', error);
      setOrders([]);
    }
  };

  const loadRequests = async () => {
    try {
      // Get all requests
      const { data: requestsData, error: reqError } = await supabase
        .from('direct_requests')
        .select(`
          *,
          client:client_id(id, full_name, email)
        `)
        .order('created_at', { ascending: false });

      if (reqError) throw reqError;

      // Get proposal counts separately
      const requestIds = (requestsData || []).map(r => r.id);
      if (requestIds.length > 0) {
        const { data: proposalCounts, error: propError } = await supabase
          .from('proposals')
          .select('request_id')
          .in('request_id', requestIds);

        if (!propError && proposalCounts) {
          // Count proposals per request
          const countMap = {};
          proposalCounts.forEach(p => {
            countMap[p.request_id] = (countMap[p.request_id] || 0) + 1;
          });

          // Merge counts into requests
          const requestsWithCounts = (requestsData || []).map(r => ({
            ...r,
            proposals_count: countMap[r.id] || 0
          }));
          setRequests(requestsWithCounts);
          return;
        }
      }

      setRequests(requestsData || []);
    } catch (error) {
      console.error('Error loading requests:', error);
      setRequests([]);
    }
  };

  // User actions
  const toggleUserStatus = async (userId, currentStatus) => {
    try {
      const { error } = await supabase
        .from('profiles')
        .update({ is_banned: !currentStatus })
        .eq('id', userId);

      if (error) throw error;
      toast.success(currentStatus ? 'Utente riattivato' : 'Utente sospeso');
      loadUsers();
      logAdminAction('toggle_user_status', 'user', userId, { banned: !currentStatus });
    } catch (error) {
      toast.error('Errore: ' + error.message);
    }
  };

  const toggleCrafterStatus = async (userId, currentStatus) => {
    try {
      const { error } = await supabase
        .from('profiles')
        .update({ is_crafter_enabled: !currentStatus })
        .eq('id', userId);

      if (error) throw error;
      toast.success(currentStatus ? 'Status artigiano rimosso' : 'Artigiano abilitato');
      loadUsers();
      loadStats();
      logAdminAction('toggle_crafter_status', 'user', userId, { crafter_enabled: !currentStatus });
    } catch (error) {
      toast.error('Errore: ' + error.message);
    }
  };

  const updateUserTier = async (userId, newTier) => {
    try {
      // Via backend (require_admin): gli utenti non possono cambiare il piano da soli.
      const res = await adminFetch(`${API_URL}/api/admin/users/${userId}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ tier: newTier }),
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || `HTTP ${res.status}`);
      }
      toast.success('Tier aggiornato');
      loadUsers();
      logAdminAction('update_user_tier', 'user', userId, { tier: newTier });
    } catch (error) {
      toast.error('Errore: ' + error.message);
    }
  };

  const toggleAdminStatus = async (userId, currentStatus) => {
    try {
      const res = await adminFetch(`${API_URL}/api/admin/users/${userId}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ is_admin: !currentStatus }),
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || `HTTP ${res.status}`);
      }
      toast.success(currentStatus ? 'Privilegi admin rimossi' : 'Admin abilitato');
      loadUsers();
      logAdminAction('toggle_admin_status', 'user', userId, { is_admin: !currentStatus });
    } catch (error) {
      toast.error('Errore: ' + error.message);
    }
  };

  // Order actions
  const updateOrderStatus = async (orderId, newStatus) => {
    try {
      const { error } = await supabase
        .from('orders')
        .update({ status: newStatus, [`${newStatus}_at`]: new Date().toISOString() })
        .eq('id', orderId);

      if (error) throw error;
      toast.success('Stato ordine aggiornato');
      loadOrders();
      logAdminAction('update_order_status', 'order', orderId, { status: newStatus });
    } catch (error) {
      toast.error('Errore: ' + error.message);
    }
  };

  // Log admin action
  const logAdminAction = async (action, targetType, targetId, details) => {
    try {
      await supabase.from('admin_logs').insert({
        admin_id: user.id,
        action,
        target_type: targetType,
        target_id: targetId,
        details
      });
    } catch (error) {
      console.error('Error logging action:', error);
    }
  };

  // ============ CATEGORIES MANAGEMENT ============
  
  const loadCategories = async () => {
    try {
      // Try backend first
      const API_URL = process.env.REACT_APP_BACKEND_URL;
      try {
        const response = await adminFetch(`${API_URL}/api/admin/categories`);
        if (response.ok) {
          const data = await response.json();
          if (!data.error && data.categories) {
            setCategories(data.categories);
            const expanded = {};
            data.categories.forEach(cat => {
              if (cat.is_main_category) expanded[cat.id] = true;
            });
            setExpandedCategories(expanded);
            return;
          }
        }
      } catch (backendError) {
        console.log('Backend not available for categories, using Supabase directly');
      }
      
      // Fallback: Supabase direct
      const { data, error } = await supabase
        .from('categories')
        .select('*')
        .order('sort_order', { ascending: true });
      
      if (!error && data) {
        setCategories(data);
        const expanded = {};
        data.forEach(cat => {
          if (!cat.parent_id) expanded[cat.id] = true;
        });
        setExpandedCategories(expanded);
      }
    } catch (error) {
      console.error('Error loading categories:', error);
    }
  };

  // ============ REQUEST OPTIONS MANAGEMENT ============
  
  const loadRequestOptions = async () => {
    try {
      // Try backend first
      const API_URL = process.env.REACT_APP_BACKEND_URL;
      try {
        const response = await adminFetch(`${API_URL}/api/admin/request-options`);
        if (response.ok) {
          const data = await response.json();
          setBudgetOptions(data.budget_options || []);
          setTimelineOptions(data.timeline_options || []);
          return;
        }
      } catch (backendError) {
        console.log('Backend not available for request options, using Supabase directly');
      }
      
      // Fallback: Supabase direct
      const [budgetRes, timelineRes] = await Promise.all([
        supabase.from('budget_options').select('*').order('sort_order', { ascending: true }),
        supabase.from('timeline_options').select('*').order('sort_order', { ascending: true })
      ]);
      
      setBudgetOptions(budgetRes.data || []);
      setTimelineOptions(timelineRes.data || []);
    } catch (error) {
      console.error('Error loading request options:', error);
    }
  };

  const saveBudgetOption = async (option, isNew = false) => {
    setSavingOption(true);
    try {
      const payload = {
        value: option.value,
        label: option.label,
        description: option.description || '',
        sort_order: option.sort_order || 0,
        is_active: option.is_active !== false
      };
      
      if (isNew) {
        const { error } = await supabase.from('budget_options').insert(payload);
        if (error) throw error;
        toast.success('Opzione budget creata!');
      } else {
        const { error } = await supabase.from('budget_options').update(payload).eq('id', option.id);
        if (error) throw error;
        toast.success('Opzione budget aggiornata!');
      }
      
      loadRequestOptions();
      setEditingBudgetOption(null);
      setNewBudgetOption({ value: '', label: '', description: '', sort_order: 0 });
    } catch (error) {
      toast.error('Errore nel salvataggio: ' + (error.message || ''));
    } finally {
      setSavingOption(false);
    }
  };

  const deleteBudgetOption = async (id) => {
    if (!window.confirm('Eliminare questa opzione budget?')) return;
    try {
      const { error } = await supabase.from('budget_options').delete().eq('id', id);
      if (error) throw error;
      toast.success('Opzione eliminata');
      loadRequestOptions();
    } catch (error) {
      toast.error('Errore nell\'eliminazione: ' + (error.message || ''));
    }
  };

  const saveTimelineOption = async (option, isNew = false) => {
    setSavingOption(true);
    try {
      const payload = {
        value: option.value,
        label: option.label,
        description: option.description || '',
        sort_order: option.sort_order || 0,
        is_active: option.is_active !== false
      };
      
      if (isNew) {
        const { error } = await supabase.from('timeline_options').insert(payload);
        if (error) throw error;
        toast.success('Opzione tempo creata!');
      } else {
        const { error } = await supabase.from('timeline_options').update(payload).eq('id', option.id);
        if (error) throw error;
        toast.success('Opzione tempo aggiornata!');
      }
      
      loadRequestOptions();
      setEditingTimelineOption(null);
      setNewTimelineOption({ value: '', label: '', description: '', sort_order: 0 });
    } catch (error) {
      toast.error('Errore nel salvataggio: ' + (error.message || ''));
    } finally {
      setSavingOption(false);
    }
  };

  const deleteTimelineOption = async (id) => {
    if (!window.confirm('Eliminare questa opzione tempistica?')) return;
    try {
      const { error } = await supabase.from('timeline_options').delete().eq('id', id);
      if (error) throw error;
      toast.success('Opzione eliminata');
      loadRequestOptions();
    } catch (error) {
      toast.error('Errore nell\'eliminazione: ' + (error.message || ''));
    }
  };

  // ==================== CONTACT MESSAGES ====================
  
  const fetchContactMessages = async (status = null) => {
    setLoadingMessages(true);
    try {
      let url = `${API_URL}/api/admin/contact-messages?limit=100`;
      if (status && status !== 'all') {
        url += `&status=${status}`;
      }
      
      const response = await fetch(url);
      if (!response.ok) throw new Error('Errore nel caricamento messaggi');
      
      const data = await response.json();
      setContactMessages(data.messages || []);
      setContactMessagesTotal(data.total || 0);
      setUnreadMessagesCount(data.unread_count || 0);
    } catch (error) {
      console.error('Error fetching contact messages:', error);
      toast.error('Errore nel caricamento messaggi');
    } finally {
      setLoadingMessages(false);
    }
  };

  const markMessageAsRead = async (messageId) => {
    try {
      const response = await adminFetch(`${API_URL}/api/admin/contact-messages/${messageId}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ read: true })
      });
      
      if (!response.ok) throw new Error('Errore');
      
      setContactMessages(prev => 
        prev.map(m => m.id === messageId ? { ...m, read: true } : m)
      );
      setUnreadMessagesCount(prev => Math.max(0, prev - 1));
    } catch (error) {
      console.error('Error marking message as read:', error);
    }
  };

  const updateMessageStatus = async (messageId, newStatus) => {
    try {
      const updates = { status: newStatus };
      if (newStatus === 'replied') {
        updates.replied_at = new Date().toISOString();
      }
      
      const response = await adminFetch(`${API_URL}/api/admin/contact-messages/${messageId}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(updates)
      });
      
      if (!response.ok) throw new Error('Errore');
      
      setContactMessages(prev => 
        prev.map(m => m.id === messageId ? { ...m, ...updates } : m)
      );
      toast.success('Stato aggiornato');
    } catch (error) {
      toast.error('Errore nell\'aggiornamento');
    }
  };

  const deleteContactMessage = async (messageId) => {
    if (!window.confirm('Eliminare questo messaggio?')) return;
    
    try {
      const response = await adminFetch(`${API_URL}/api/admin/contact-messages/${messageId}`, {
        method: 'DELETE'
      });
      
      if (!response.ok) throw new Error('Errore');
      
      setContactMessages(prev => prev.filter(m => m.id !== messageId));
      setSelectedMessage(null);
      toast.success('Messaggio eliminato');
    } catch (error) {
      toast.error('Errore nell\'eliminazione');
    }
  };

  const getReasonLabel = (reason) => {
    const labels = {
      'general': 'Informazioni generali',
      'order': 'Problema ordine',
      'crafter': 'Diventare artigiano',
      'partnership': 'Partnership',
      'press': 'Stampa',
      'other': 'Altro'
    };
    return labels[reason] || reason;
  };

  const getStatusBadge = (status) => {
    const styles = {
      'new': 'bg-blue-100 text-blue-700',
      'in_progress': 'bg-amber-100 text-amber-700',
      'replied': 'bg-green-100 text-green-700',
      'closed': 'bg-slate-100 text-slate-600'
    };
    const labels = {
      'new': 'Nuovo',
      'in_progress': 'In lavorazione',
      'replied': 'Risposto',
      'closed': 'Chiuso'
    };
    return (
      <span className={`px-2 py-1 rounded-full text-xs font-medium ${styles[status] || styles['new']}`}>
        {labels[status] || status}
      </span>
    );
  };

  // Build category tree
  const buildCategoryTree = () => {
    // Main categories are those with is_main_category=true OR parent_id=null
    const mainCategories = categories.filter(c => c.is_main_category || c.parent_id === null);
    const childCategories = categories.filter(c => !c.is_main_category && c.parent_id !== null);
    
    const getChildren = (parentId) => {
      return childCategories.filter(c => c.parent_id === parentId);
    };
    
    return mainCategories.map(main => ({
      ...main,
      children: getChildren(main.id).map(child => ({
        ...child,
        children: getChildren(child.id)
      }))
    }));
  };

  // Build flat sorted list with hierarchy indication for dropdowns
  const getSortedCategoriesForDropdown = (excludeId = null) => {
    const mainCategories = categories
      .filter(c => c.is_main_category || c.parent_id === null)
      .sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0));
    
    const result = [];
    
    const addCategoryWithChildren = (cat, level = 0) => {
      if (excludeId && cat.id === excludeId) return;
      
      const prefix = level === 0 ? '' : level === 1 ? '├─ ' : '│  ├─ ';
      result.push({
        ...cat,
        displayName: prefix + cat.name,
        level
      });
      
      // Get children sorted by sort_order
      const children = categories
        .filter(c => c.parent_id === cat.id)
        .sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0));
      
      children.forEach(child => addCategoryWithChildren(child, level + 1));
    };
    
    mainCategories.forEach(main => addCategoryWithChildren(main, 0));
    
    return result;
  };

  const handleSelectCategory = (category) => {
    console.log('Selected category data:', JSON.stringify(category, null, 2));
    setSelectedCategory(category);
    setIsCreatingCategory(false);
    
    // Force update form with category data
    const formData = {
      name: category.name ?? '',
      slug: category.slug ?? '',
      parent_id: category.parent_id ?? '',
      icon: category.icon ?? 'Package',
      image_url: category.image_url ?? '',
      seo_title: category.seo_title ?? '',
      seo_intro: category.seo_intro ?? '',
      seo_footer_title: category.seo_footer_title ?? '',
      seo_description: category.seo_description ?? '',
      sort_order: category.sort_order ?? 0
    };
    console.log('Setting form data:', formData);
    setCategoryForm(formData);
  };

  const handleStartCreateCategory = (parentId = null) => {
    setSelectedCategory(null);
    setIsCreatingCategory(true);
    const parentCat = categories.find(c => c.id === parentId);
    setCategoryForm({
      name: '',
      slug: '',
      parent_id: parentId || '',
      icon: 'Package',
      image_url: '',
      seo_title: '',
      seo_intro: '',
      seo_footer_title: '',
      seo_description: '',
      sort_order: parentCat ? categories.filter(c => c.parent_id === parentId).length : 0
    });
  };

  const handleCancelEdit = () => {
    setSelectedCategory(null);
    setIsCreatingCategory(false);
    setCategoryForm({
      name: '',
      slug: '',
      parent_id: '',
      icon: 'Package',
      image_url: '',
      seo_title: '',
      seo_intro: '',
      seo_footer_title: '',
      seo_description: '',
      sort_order: 0
    });
  };

  const generateSlug = (name) => {
    return name
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '');
  };

  const handleSaveCategory = async () => {
    if (!categoryForm.name.trim()) {
      toast.error('Inserisci un nome per la categoria');
      return;
    }
    
    setSavingCategory(true);
    
    try {
      const slug = categoryForm.slug || generateSlug(categoryForm.name);
      const payload = {
        name: categoryForm.name,
        slug,
        parent_id: categoryForm.parent_id || null,
        icon: categoryForm.icon || 'Package',
        image_url: categoryForm.image_url || null,
        seo_title: categoryForm.seo_title || null,
        seo_intro: categoryForm.seo_intro || null,
        seo_footer_title: categoryForm.seo_footer_title || null,
        seo_description: categoryForm.seo_description || null,
        sort_order: categoryForm.sort_order || 0,
        is_main_category: !categoryForm.parent_id
      };
      
      if (isCreatingCategory) {
        // Create new category
        const { data, error } = await supabase
          .from('categories')
          .insert(payload)
          .select()
          .single();
        
        if (error) throw error;
        
        toast.success('Categoria creata con successo');
        loadCategories();
        handleCancelEdit();
        logAdminAction('create_category', 'category', data?.id, { name: categoryForm.name });
      } else if (selectedCategory) {
        // Update existing category
        const { error } = await supabase
          .from('categories')
          .update(payload)
          .eq('id', selectedCategory.id);
        
        if (error) throw error;
        
        toast.success('Categoria aggiornata');
        loadCategories();
        logAdminAction('update_category', 'category', selectedCategory.id, { name: categoryForm.name });
      }
    } catch (error) {
      toast.error('Errore: ' + (error.message || 'Errore sconosciuto'));
    } finally {
      setSavingCategory(false);
    }
  };

  const handleDeleteCategory = async () => {
    if (!selectedCategory || selectedCategory.is_main_category) return;
    
    if (!window.confirm(`Sei sicuro di voler eliminare "${selectedCategory.name}"? Le sottocategorie verranno scollegate.`)) {
      return;
    }
    
    try {
      // First update children to have no parent
      await supabase
        .from('categories')
        .update({ parent_id: null })
        .eq('parent_id', selectedCategory.id);
      
      // Then delete the category
      const { error } = await supabase
        .from('categories')
        .delete()
        .eq('id', selectedCategory.id);
      
      if (error) throw error;
      
      toast.success('Categoria eliminata');
      loadCategories();
      handleCancelEdit();
      logAdminAction('delete_category', 'category', selectedCategory.id, { name: selectedCategory.name });
    } catch (error) {
      toast.error('Errore: ' + (error.message || 'Errore sconosciuto'));
    }
  };

  const toggleCategoryExpand = (categoryId) => {
    setExpandedCategories(prev => ({
      ...prev,
      [categoryId]: !prev[categoryId]
    }));
  };

  // Render category tree item
  const renderCategoryItem = (category, level = 0) => {
    const hasChildren = categories.some(c => c.parent_id === category.id);
    const isExpanded = expandedCategories[category.id];
    const isSelected = selectedCategory?.id === category.id;
    const IconComponent = getIconByName(category.icon);
    const isHidden = category.is_active === false;
    
    return (
      <div key={category.id} className="group">
        <div
          className={`flex items-center gap-2 p-2 rounded-lg cursor-pointer transition-colors ${
            isSelected ? 'bg-[#008080]/10 border border-[#008080]' : 'hover:bg-slate-100'
          } ${isHidden ? 'opacity-50' : ''}`}
          style={{ paddingLeft: `${12 + level * 20}px` }}
          onClick={() => handleSelectCategory(category)}
        >
          {hasChildren ? (
            <button
              onClick={(e) => {
                e.stopPropagation();
                toggleCategoryExpand(category.id);
              }}
              className="p-0.5 hover:bg-slate-200 rounded"
            >
              {isExpanded ? <ChevronDown className="w-4 h-4" /> : <ChevronRight className="w-4 h-4" />}
            </button>
          ) : (
            <span className="w-5" />
          )}
          
          <IconComponent className={`w-4 h-4 ${isHidden ? 'text-slate-400' : 'text-slate-600'}`} />
          
          <span className={`flex-1 text-sm font-medium truncate ${isHidden ? 'text-slate-400 line-through' : ''}`}>
            {category.name}
          </span>
          
          {/* Visibility indicator */}
          {isHidden && (
            <span className="px-1.5 py-0.5 text-[10px] bg-slate-200 text-slate-500 rounded">
              nascosta
            </span>
          )}
          
          {category.is_main_category && (
            <Lock className="w-3 h-3 text-slate-400" title="Categoria principale" />
          )}
          
          {/* Visibility toggle button */}
          <button
            onClick={async (e) => {
              e.stopPropagation();
              const newState = !category.is_active;
              const cascade = hasChildren; // Always cascade when there are children
              
              try {
                const response = await adminFetch(`${API_URL}/api/admin/categories/${category.id}/visibility`, {
                  method: 'PATCH',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ is_active: newState, cascade })
                });
                
                const result = await response.json();
                if (result.success) {
                  toast.success(newState 
                    ? `"${category.name}" pubblicata${result.updated_count > 1 ? ` (+ ${result.updated_count - 1} sottocategorie)` : ''}`
                    : `"${category.name}" nascosta${result.updated_count > 1 ? ` (+ ${result.updated_count - 1} sottocategorie)` : ''}`
                  );
                  loadCategories();
                } else {
                  toast.error('Errore aggiornamento');
                }
              } catch (error) {
                toast.error('Errore: ' + error.message);
              }
            }}
            className={`p-1 rounded transition-colors ${
              isHidden 
                ? 'hover:bg-green-100 text-slate-400 hover:text-green-600' 
                : 'hover:bg-red-100 text-slate-400 hover:text-red-500 opacity-0 group-hover:opacity-100'
            }`}
            title={isHidden ? 'Pubblica categoria' : 'Nascondi categoria'}
          >
            {isHidden ? (
              <Eye className="w-3.5 h-3.5" />
            ) : (
              <Ban className="w-3.5 h-3.5" />
            )}
          </button>
          
          {!category.is_main_category && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleStartCreateCategory(category.id);
              }}
              className="p-1 hover:bg-slate-200 rounded opacity-0 group-hover:opacity-100"
              title="Aggiungi sottocategoria"
            >
              <Plus className="w-3 h-3 text-slate-500" />
            </button>
          )}
        </div>
        
        {hasChildren && isExpanded && (
          <div>
            {categories
              .filter(c => c.parent_id === category.id)
              .sort((a, b) => a.sort_order - b.sort_order)
              .map(child => renderCategoryItem(child, level + 1))}
          </div>
        )}
      </div>
    );
  };

  // Filter users
  const filteredUsers = users.filter(u => {
    const matchesSearch = !userSearch || 
      u.full_name?.toLowerCase().includes(userSearch.toLowerCase()) ||
      u.email?.toLowerCase().includes(userSearch.toLowerCase());
    
    const matchesFilter = userFilter === 'all' ||
      (userFilter === 'crafters' && u.is_crafter_enabled) ||
      (userFilter === 'clients' && !u.is_crafter_enabled) ||
      (userFilter === 'admins' && u.is_admin) ||
      (userFilter === 'banned' && u.is_banned);
    
    return matchesSearch && matchesFilter;
  });

  // Filter orders
  const filteredOrders = orders.filter(o => {
    return orderFilter === 'all' || o.status === orderFilter;
  });

  // Pagination
  const paginatedUsers = filteredUsers.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
  const totalUserPages = Math.ceil(filteredUsers.length / itemsPerPage);

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString('it-IT', { 
      day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' 
    });
  };

  const getStatusColor = (status) => {
    const colors = {
      'confirmed': 'bg-blue-100 text-blue-700',
      'in_progress': 'bg-amber-100 text-amber-700',
      'ready': 'bg-purple-100 text-purple-700',
      'shipped': 'bg-indigo-100 text-indigo-700',
      'delivered': 'bg-teal-100 text-teal-700',
      'completed': 'bg-green-100 text-green-700',
      'cancelled': 'bg-red-100 text-red-700',
      'open': 'bg-cyan-100 text-cyan-700'
    };
    return colors[status] || 'bg-slate-100 text-slate-700';
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#008080]"></div>
      </div>
    );
  }

  if (!profile?.is_admin) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <Card className="p-8 text-center">
          <Shield className="w-16 h-16 text-red-500 mx-auto mb-4" />
          <h2 className="text-2xl font-bold text-slate-800 mb-2">Accesso Negato</h2>
          <p className="text-slate-600">Non hai i permessi per accedere a questa sezione.</p>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-100" data-testid="superadmin-dashboard">
      {/* Header */}
      <div className="bg-gradient-to-r from-slate-900 to-slate-800 text-white py-6">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex items-center gap-3">
            <Shield className="w-8 h-8 text-[#DAA520]" />
            <div>
              <h1 className="text-2xl font-bold">SuperAdmin Dashboard</h1>
              <p className="text-slate-300 text-sm">Gestione completa della piattaforma Rarifex</p>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-6">
        {/* Stats Overview */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-6">
          <Card className="p-4">
            <div className="flex items-center gap-3">
              <Users className="w-8 h-8 text-blue-500" />
              <div>
                <p className="text-2xl font-bold">{stats.totalUsers}</p>
                <p className="text-xs text-slate-500">Utenti Totali</p>
              </div>
            </div>
          </Card>
          <Card className="p-4">
            <div className="flex items-center gap-3">
              <Crown className="w-8 h-8 text-amber-500" />
              <div>
                <p className="text-2xl font-bold">{stats.totalCrafters}</p>
                <p className="text-xs text-slate-500">Artigiani</p>
              </div>
            </div>
          </Card>
          <Card className="p-4">
            <div className="flex items-center gap-3">
              <Package className="w-8 h-8 text-green-500" />
              <div>
                <p className="text-2xl font-bold">{stats.totalOrders}</p>
                <p className="text-xs text-slate-500">Ordini</p>
              </div>
            </div>
          </Card>
          <Card className="p-4">
            <div className="flex items-center gap-3">
              <FileText className="w-8 h-8 text-purple-500" />
              <div>
                <p className="text-2xl font-bold">{stats.totalRequests}</p>
                <p className="text-xs text-slate-500">Richieste</p>
              </div>
            </div>
          </Card>
          <Card className="p-4">
            <div className="flex items-center gap-3">
              <Clock className="w-8 h-8 text-cyan-500" />
              <div>
                <p className="text-2xl font-bold">{stats.pendingRequests}</p>
                <p className="text-xs text-slate-500">In Attesa</p>
              </div>
            </div>
          </Card>
          <Card className="p-4 bg-gradient-to-br from-green-50 to-green-100">
            <div className="flex items-center gap-3">
              <Euro className="w-8 h-8 text-green-600" />
              <div>
                <p className="text-2xl font-bold text-green-700">€{stats.totalRevenue.toFixed(0)}</p>
                <p className="text-xs text-green-600">Revenue</p>
              </div>
            </div>
          </Card>
        </div>

        {/* Main Tabs */}
        <Tabs value={activeTab} onValueChange={setActiveTab}>
          <TabsList className="mb-6 flex-wrap">
            <TabsTrigger value="overview"><ChartBar className="w-4 h-4 mr-1" />Overview</TabsTrigger>
            <TabsTrigger value="categories"><FolderTree className="w-4 h-4 mr-1" />Categorie</TabsTrigger>
            <TabsTrigger value="request-options"><Euro className="w-4 h-4 mr-1" />Opzioni Richieste</TabsTrigger>
            <TabsTrigger value="users"><Users className="w-4 h-4 mr-1" />Utenti</TabsTrigger>
            <TabsTrigger value="orders"><Package className="w-4 h-4 mr-1" />Ordini</TabsTrigger>
            <TabsTrigger value="shipments" onClick={() => navigate('/admin/shipments')} data-testid="admin-tab-shipments">
              <Truck className="w-4 h-4 mr-1" />Spedizioni
            </TabsTrigger>
            <TabsTrigger value="order-cases" onClick={() => navigate('/admin/order-cases')} data-testid="admin-tab-order-cases">
              <LifeBuoy className="w-4 h-4 mr-1" />Assistenza ordini
            </TabsTrigger>
            <TabsTrigger value="requests"><FileText className="w-4 h-4 mr-1" />Richieste</TabsTrigger>
            <TabsTrigger value="messages" className="relative">
              <Mail className="w-4 h-4 mr-1" />Messaggi
              {unreadMessagesCount > 0 && (
                <span className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 text-white text-xs rounded-full flex items-center justify-center">
                  {unreadMessagesCount > 9 ? '9+' : unreadMessagesCount}
                </span>
              )}
            </TabsTrigger>
            <TabsTrigger value="connectors"><Plug className="w-4 h-4 mr-1" />Connettori</TabsTrigger>
            <TabsTrigger value="settings"><Settings className="w-4 h-4 mr-1" />Impostazioni</TabsTrigger>
          </TabsList>

          {/* Overview Tab */}
          <TabsContent value="overview">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {/* Recent Orders */}
              <Card className="p-6">
                <h3 className="font-bold text-lg mb-4 flex items-center gap-2">
                  <Package className="w-5 h-5 text-green-500" />
                  Ordini Recenti
                </h3>
                <div className="space-y-3">
                  {orders.slice(0, 5).map(order => (
                    <div key={order.id} className="flex items-center justify-between p-3 bg-slate-50 rounded-lg">
                      <div>
                        <p className="font-medium text-sm">{order.title}</p>
                        <p className="text-xs text-slate-500">
                          {order.client?.full_name} → {order.crafter?.storefront_title || order.crafter?.full_name}
                        </p>
                      </div>
                      <div className="text-right">
                        <Badge className={getStatusColor(order.status)}>{order.status}</Badge>
                        <p className="text-sm font-semibold text-green-600 mt-1">€{(order.total || order.agreed_price || 0).toFixed(2)}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </Card>

              {/* Recent Users */}
              <Card className="p-6">
                <h3 className="font-bold text-lg mb-4 flex items-center gap-2">
                  <Users className="w-5 h-5 text-blue-500" />
                  Nuovi Utenti
                </h3>
                <div className="space-y-3">
                  {users.slice(0, 5).map(u => (
                    <div key={u.id} className="flex items-center gap-3 p-3 bg-slate-50 rounded-lg">
                      <div className="w-10 h-10 rounded-full bg-[#008080] flex items-center justify-center text-white font-bold">
                        {(u.full_name || u.email || 'U')[0].toUpperCase()}
                      </div>
                      <div className="flex-1">
                        <p className="font-medium text-sm">{u.full_name || 'Nome non impostato'}</p>
                        <p className="text-xs text-slate-500">{u.email}</p>
                      </div>
                      <div className="flex gap-1">
                        {u.is_admin && <Badge className="bg-red-500 text-white text-xs">Admin</Badge>}
                        {u.is_crafter_enabled && <Badge className="bg-amber-500 text-white text-xs">Crafter</Badge>}
                      </div>
                    </div>
                  ))}
                </div>
              </Card>

              {/* Pending Requests */}
              <Card className="p-6 lg:col-span-2">
                <h3 className="font-bold text-lg mb-4 flex items-center gap-2">
                  <TriangleAlert className="w-5 h-5 text-amber-500" />
                  Richieste in Attesa di Proposte
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                  {requests.filter(r => r.status === 'open').slice(0, 6).map(req => (
                    <div key={req.id} className="p-4 bg-amber-50 border border-amber-200 rounded-lg">
                      <p className="font-medium truncate">{req.title}</p>
                      <p className="text-sm text-slate-600 truncate">{req.description}</p>
                      <div className="flex items-center justify-between mt-2">
                        <span className="text-xs text-slate-500">{req.client?.full_name}</span>
                        <Badge variant="outline">{req.proposals?.[0]?.count || 0} proposte</Badge>
                      </div>
                    </div>
                  ))}
                </div>
              </Card>
            </div>
          </TabsContent>

          {/* Categories Tab */}
          <TabsContent value="categories">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
              {/* Left Column - Category Tree */}
              <Card className="p-4 lg:col-span-1 max-h-[700px] overflow-y-auto">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="font-semibold text-lg flex items-center gap-2">
                    <FolderTree className="w-5 h-5 text-[#008080]" />
                    Alberatura
                  </h3>
                  <Button
                    size="sm"
                    variant="outline"
                    onClick={() => loadCategories()}
                    title="Ricarica"
                  >
                    <RefreshCw className="w-4 h-4" />
                  </Button>
                </div>
                
                {categories.length === 0 ? (
                  <div className="text-center py-8 text-slate-500">
                    <FolderTree className="w-12 h-12 mx-auto mb-2 opacity-30" />
                    <p className="text-sm">Nessuna categoria trovata</p>
                    <p className="text-xs mt-1">Esegui lo script di migrazione su Supabase</p>
                  </div>
                ) : (
                  <div className="space-y-1">
                    {buildCategoryTree().map(cat => renderCategoryItem(cat, 0))}
                    
                    {/* Add new root category button */}
                    <button
                      onClick={() => handleStartCreateCategory(null)}
                      className="flex items-center gap-2 w-full p-2 mt-4 text-sm text-[#008080] hover:bg-[#008080]/5 rounded-lg transition-colors"
                    >
                      <Plus className="w-4 h-4" />
                      Aggiungi sottocategoria a una principale
                    </button>
                  </div>
                )}
              </Card>

              {/* Right Column - Category Editor */}
              <Card className="p-6 lg:col-span-2">
                {!selectedCategory && !isCreatingCategory ? (
                  <div className="text-center py-16 text-slate-500">
                    <Pencil className="w-16 h-16 mx-auto mb-4 opacity-20" />
                    <h3 className="text-lg font-medium mb-2">Seleziona una categoria</h3>
                    <p className="text-sm">Clicca su una categoria nell'alberatura per modificarla</p>
                  </div>
                ) : (
                  <div>
                    <div className="flex items-center justify-between mb-6">
                      <h3 className="font-semibold text-lg flex items-center gap-2">
                        {isCreatingCategory ? (
                          <>
                            <Plus className="w-5 h-5 text-green-600" />
                            Nuova Categoria
                          </>
                        ) : (
                          <>
                            <Pencil className="w-5 h-5 text-[#008080]" />
                            Modifica: {selectedCategory?.name}
                            {selectedCategory?.is_main_category && (
                              <Badge className="ml-2 bg-amber-100 text-amber-800">
                                <Lock className="w-3 h-3 mr-1" />
                                Principale
                              </Badge>
                            )}
                          </>
                        )}
                      </h3>
                      <Button variant="ghost" size="sm" onClick={handleCancelEdit}>
                        <CircleX className="w-4 h-4" />
                      </Button>
                    </div>

                    <div className="space-y-5">
                      {/* Name */}
                      <div>
                        <Label className="flex items-center gap-2 mb-2">
                          <Type className="w-4 h-4" />
                          Nome Categoria *
                        </Label>
                        <Input
                          value={categoryForm.name}
                          onChange={(e) => setCategoryForm(prev => ({ 
                            ...prev, 
                            name: e.target.value,
                            slug: isCreatingCategory ? generateSlug(e.target.value) : prev.slug
                          }))}
                          placeholder="es. Vestiti Donna"
                        />
                      </div>

                      {/* Slug */}
                      <div>
                        <Label className="flex items-center gap-2 mb-2">
                          Slug URL
                        </Label>
                        <Input
                          value={categoryForm.slug}
                          onChange={(e) => setCategoryForm(prev => ({ ...prev, slug: e.target.value }))}
                          placeholder="es. vestiti-donna"
                          disabled={selectedCategory?.is_main_category}
                        />
                        <p className="text-xs text-slate-500 mt-1">
                          Usato nell'URL: /categoria/{categoryForm.slug || 'slug'}
                        </p>
                      </div>

                      {/* Parent Category */}
                      {!selectedCategory?.is_main_category && (
                        <div>
                          <Label className="flex items-center gap-2 mb-2">
                            <FolderTree className="w-4 h-4" />
                            Categoria Padre
                          </Label>
                          <Select
                            value={categoryForm.parent_id || 'none'}
                            onValueChange={(value) => setCategoryForm(prev => ({ 
                              ...prev, 
                              parent_id: value === 'none' ? '' : value 
                            }))}
                          >
                            <SelectTrigger>
                              <SelectValue placeholder="Seleziona categoria padre" />
                            </SelectTrigger>
                            <SelectContent>
                              <SelectItem value="none">-- Nessuna (radice) --</SelectItem>
                              {getSortedCategoriesForDropdown(selectedCategory?.id)
                                .map(cat => (
                                  <SelectItem key={cat.id} value={cat.id}>
                                    <span className={cat.level > 0 ? 'text-slate-600' : 'font-medium'}>
                                      {cat.is_main_category ? '🔒 ' : ''}{cat.displayName}
                                    </span>
                                  </SelectItem>
                                ))}
                            </SelectContent>
                          </Select>
                        </div>
                      )}

                      {/* Icon */}
                      <div>
                        <Label className="flex items-center gap-2 mb-2">
                          Icona
                        </Label>
                        <div className="flex items-center gap-2">
                          {(() => {
                            const IconComponent = getIconByName(categoryForm.icon);
                            return (
                              <div className="w-12 h-12 rounded-lg bg-slate-100 flex items-center justify-center">
                                <IconComponent className="w-6 h-6 text-[#008080]" />
                              </div>
                            );
                          })()}
                          <Button
                            type="button"
                            variant="outline"
                            onClick={() => setShowIconPicker(!showIconPicker)}
                          >
                            {showIconPicker ? 'Chiudi' : 'Cambia Icona'}
                          </Button>
                        </div>
                        
                        {showIconPicker && (
                          <div className="mt-3 p-4 border rounded-lg bg-slate-50 max-h-80 overflow-y-auto">
                            <p className="text-xs text-slate-500 mb-3">
                              {ICON_PRESETS.length} icone disponibili - Clicca per selezionare
                            </p>
                            {/* Group icons by category */}
                            {[...new Set(ICON_PRESETS.map(i => i.category))].map(cat => (
                              <div key={cat} className="mb-4">
                                <p className="text-xs font-semibold text-slate-600 mb-2 uppercase tracking-wide">{cat}</p>
                                <div className="grid grid-cols-10 gap-1">
                                  {ICON_PRESETS.filter(i => i.category === cat).map(({ name, icon: IconComp }) => (
                                    <button
                                      key={name}
                                      type="button"
                                      onClick={() => {
                                        setCategoryForm(prev => ({ ...prev, icon: name }));
                                        setShowIconPicker(false);
                                      }}
                                      className={`p-2 rounded-lg transition-colors ${
                                        categoryForm.icon === name 
                                          ? 'bg-[#008080] text-white' 
                                          : 'hover:bg-slate-200'
                                      }`}
                                      title={name}
                                    >
                                      <IconComp className="w-4 h-4" />
                                    </button>
                                  ))}
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>

                      {/* Image URL */}
                      <div>
                        <Label className="flex items-center gap-2 mb-2">
                          <Image className="w-4 h-4" />
                          Immagine Sfondo Categoria (Hero)
                        </Label>
                        <p className="text-xs text-slate-500 mb-3">
                          Questa immagine verrà usata come sfondo nella sezione hero della pagina categoria, con un overlay gradiente teal.
                        </p>
                        <div className="flex gap-2">
                          <Input
                            value={categoryForm.image_url}
                            onChange={(e) => setCategoryForm(prev => ({ ...prev, image_url: e.target.value }))}
                            placeholder="https://example.com/image.jpg o carica un file"
                            className="flex-1"
                          />
                          <label className="cursor-pointer">
                            <input 
                              type="file" 
                              accept="image/*" 
                              className="hidden"
                              onChange={async (e) => {
                                const file = e.target.files?.[0];
                                if (!file) return;
                                
                                // Check file size (max 5MB)
                                if (file.size > 5 * 1024 * 1024) {
                                  toast.error('Immagine troppo grande (max 5MB)');
                                  return;
                                }
                                
                                const toastId = toast.loading('Caricamento immagine...');
                                try {
                                  const formData = new FormData();
                                  formData.append('file', file);
                                  formData.append('folder', 'categories');
                                  
                                  const response = await adminFetch(`${API_URL}/api/upload/image`, {
                                    method: 'POST',
                                    body: formData
                                  });
                                  
                                  if (response.ok) {
                                    const data = await response.json();
                                    setCategoryForm(prev => ({ ...prev, image_url: data.url }));
                                    toast.success('Immagine caricata', { id: toastId });
                                  } else {
                                    throw new Error('Upload failed');
                                  }
                                } catch (error) {
                                  console.error('Upload error:', error);
                                  toast.error('Errore nel caricamento', { id: toastId });
                                }
                              }}
                            />
                            <Button type="button" variant="outline" size="sm" className="h-10">
                              <Upload className="w-4 h-4 mr-1" />
                              Carica
                            </Button>
                          </label>
                        </div>
                        {categoryForm.image_url && (
                          <div className="mt-3 relative inline-block">
                            <img 
                              src={categoryForm.image_url} 
                              alt="Preview" 
                              className="w-full max-w-md h-32 object-cover rounded-lg border"
                              onError={(e) => e.target.style.display = 'none'}
                            />
                            <div 
                              className="absolute inset-0 rounded-lg"
                              style={{
                                background: 'linear-gradient(135deg, rgba(0, 100, 100, 0.7), rgba(0, 80, 80, 0.75))'
                              }}
                            />
                            <p className="absolute bottom-2 left-2 text-white text-xs font-medium">
                              Anteprima con overlay
                            </p>
                            <button
                              type="button"
                              onClick={() => setCategoryForm(prev => ({ ...prev, image_url: '' }))}
                              className="absolute top-2 right-2 bg-red-500 text-white rounded-full p-1 hover:bg-red-600 transition-colors"
                            >
                              <X className="w-3 h-3" />
                            </button>
                          </div>
                        )}
                      </div>

                      {/* SEO Title */}
                      <div className="border-t pt-5 mt-2">
                        <h4 className="text-sm font-semibold text-slate-700 mb-4 flex items-center gap-2">
                          <FileText className="w-4 h-4 text-[#008080]" />
                          Contenuto SEO - Sezione Header (Alto)
                        </h4>
                        <div className="space-y-4">
                          <div>
                            <Label className="mb-2 block">Titolo H1</Label>
                            <Input
                              value={categoryForm.seo_title}
                              onChange={(e) => setCategoryForm(prev => ({ ...prev, seo_title: e.target.value }))}
                              placeholder="es. Abbigliamento Donna Artigianale"
                            />
                            <p className="text-xs text-slate-500 mt-1">
                              Mostrato come titolo principale della pagina
                            </p>
                          </div>
                          <div>
                            <Label className="mb-2 block">Testo Introduttivo</Label>
                            <Textarea
                              value={categoryForm.seo_intro}
                              onChange={(e) => setCategoryForm(prev => ({ ...prev, seo_intro: e.target.value }))}
                              placeholder="Breve descrizione mostrata sotto il titolo nella parte alta della pagina..."
                              rows={2}
                            />
                            <p className="text-xs text-slate-500 mt-1">
                              {categoryForm.seo_intro?.length || 0} caratteri
                            </p>
                          </div>
                        </div>
                      </div>

                      {/* SEO Footer Description */}
                      <div className="border-t pt-5">
                        <h4 className="text-sm font-semibold text-slate-700 mb-4 flex items-center gap-2">
                          <FileText className="w-4 h-4 text-[#008080]" />
                          Contenuto SEO - Sezione Footer (Basso)
                        </h4>
                        <div className="space-y-4">
                          <div>
                            <Label className="mb-2 block">Titolo H2 Footer</Label>
                            <Input
                              value={categoryForm.seo_footer_title}
                              onChange={(e) => setCategoryForm(prev => ({ ...prev, seo_footer_title: e.target.value }))}
                              placeholder="es. Abbigliamento Donna Artigianale Italiano"
                            />
                            <p className="text-xs text-slate-500 mt-1">
                              Titolo mostrato sopra il testo descrittivo nel footer della pagina
                            </p>
                          </div>
                          <div>
                            <Label className="mb-2 block">Descrizione SEO Estesa</Label>
                            <Textarea
                              value={categoryForm.seo_description}
                              onChange={(e) => setCategoryForm(prev => ({ ...prev, seo_description: e.target.value }))}
                              placeholder="Testo SEO completo mostrato nella parte bassa della pagina categoria. Può essere più lungo e descrittivo..."
                              rows={5}
                            />
                            <p className="text-xs text-slate-500 mt-1">
                              {categoryForm.seo_description?.length || 0} caratteri - Mostrato nella sezione in fondo alla pagina
                            </p>
                          </div>
                        </div>
                      </div>

                      {/* Sort Order */}
                      <div>
                        <Label className="flex items-center gap-2 mb-2">
                          Ordine di Visualizzazione
                        </Label>
                        <Input
                          type="number"
                          value={categoryForm.sort_order}
                          onChange={(e) => setCategoryForm(prev => ({ ...prev, sort_order: parseInt(e.target.value) || 0 }))}
                          min={0}
                          className="w-24"
                        />
                      </div>

                      {/* Action Buttons */}
                      <div className="flex items-center gap-3 pt-4 border-t">
                        <Button
                          onClick={handleSaveCategory}
                          disabled={savingCategory}
                          className="bg-[#008080] hover:bg-[#006666]"
                        >
                          {savingCategory ? (
                            <RefreshCw className="w-4 h-4 mr-2 animate-spin" />
                          ) : (
                            <CircleCheck className="w-4 h-4 mr-2" />
                          )}
                          {isCreatingCategory ? 'Crea Categoria' : 'Salva Modifiche'}
                        </Button>
                        
                        <Button variant="outline" onClick={handleCancelEdit}>
                          Annulla
                        </Button>
                        
                        {selectedCategory && !selectedCategory.is_main_category && (
                          <Button 
                            variant="destructive" 
                            onClick={handleDeleteCategory}
                            className="ml-auto"
                          >
                            <Trash2 className="w-4 h-4 mr-2" />
                            Elimina
                          </Button>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </Card>
            </div>

            {/* Category Import/Export Section */}
            <div className="mt-6">
              <Card className="p-6">
                <h3 className="font-bold text-lg flex items-center gap-2 mb-4">
                  <FileJson className="w-5 h-5 text-[#008080]" />
                  Import/Export Categorie (Batch)
                </h3>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {/* Export Section */}
                  <div className="p-4 bg-slate-50 rounded-lg border">
                    <h4 className="font-semibold text-sm mb-3 flex items-center gap-2">
                      <Download className="w-4 h-4 text-blue-500" />
                      Esporta Categorie
                    </h4>
                    <p className="text-xs text-slate-600 mb-4">
                      Scarica l'alberatura completa delle categorie in formato JSON. 
                      Utile per backup o come template per nuove categorie.
                    </p>
                    <Button 
                      variant="outline" 
                      className="w-full"
                      onClick={async () => {
                        try {
                          const response = await adminFetch(`${API_URL}/api/admin/categories/export`);
                          if (response.ok) {
                            const data = await response.json();
                            const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
                            const url = URL.createObjectURL(blob);
                            const a = document.createElement('a');
                            a.href = url;
                            a.download = `rarifex_categories_${new Date().toISOString().split('T')[0]}.json`;
                            a.click();
                            URL.revokeObjectURL(url);
                            toast.success(`Esportate ${data.total_categories} categorie`);
                          } else {
                            toast.error('Errore durante l\'export');
                          }
                        } catch (error) {
                          toast.error('Errore: ' + error.message);
                        }
                      }}
                    >
                      <Download className="w-4 h-4 mr-2" />
                      Scarica JSON
                    </Button>
                  </div>

                  {/* Import Section */}
                  <div className="p-4 bg-slate-50 rounded-lg border">
                    <h4 className="font-semibold text-sm mb-3 flex items-center gap-2">
                      <Upload className="w-4 h-4 text-green-500" />
                      Importa Categorie (Solo Aggiunta)
                    </h4>
                    <p className="text-xs text-slate-600 mb-3">
                      Carica un file JSON per aggiungere nuove categorie in batch. 
                      Le categorie con slug esistenti verranno saltate.
                    </p>
                    
                    <div className="space-y-3">
                      {/* Parent Category Selector */}
                      <div>
                        <Label className="text-xs text-slate-500 mb-1 block">
                          Categoria padre (opzionale)
                        </Label>
                        <Select 
                          value={importParentSlug || '_root'} 
                          onValueChange={(v) => setImportParentSlug(v === '_root' ? null : v)}
                        >
                          <SelectTrigger className="text-sm">
                            <SelectValue placeholder="Seleziona categoria padre" />
                          </SelectTrigger>
                          <SelectContent>
                            <SelectItem value="_root">
                              <span className="text-slate-500">— Categorie principali (root) —</span>
                            </SelectItem>
                            {getSortedCategoriesForDropdown().map(cat => (
                              <SelectItem key={cat.id} value={cat.slug}>
                                <span className={cat.level > 0 ? 'text-slate-600' : 'font-medium'}>
                                  {cat.displayName}
                                </span>
                              </SelectItem>
                            ))}
                          </SelectContent>
                        </Select>
                      </div>
                      
                      {/* File Input */}
                      <div>
                        <input
                          type="file"
                          accept=".json"
                          className="hidden"
                          id="category-import-file"
                          onChange={async (e) => {
                            const file = e.target.files?.[0];
                            if (!file) return;
                            
                            try {
                              const text = await file.text();
                              const json = JSON.parse(text);
                              
                              // Support both direct array and wrapped format
                              let categoriesToImport = [];
                              if (Array.isArray(json)) {
                                categoriesToImport = json;
                              } else if (json.categories && Array.isArray(json.categories)) {
                                categoriesToImport = json.categories;
                              } else {
                                throw new Error('Formato JSON non valido. Atteso array o oggetto con campo "categories"');
                              }
                              
                              setImportPreview(categoriesToImport);
                              toast.success(`File caricato: ${categoriesToImport.length} categorie trovate`);
                            } catch (error) {
                              toast.error('Errore lettura file: ' + error.message);
                            }
                            e.target.value = '';
                          }}
                        />
                        <Button 
                          variant="outline" 
                          className="w-full"
                          onClick={() => document.getElementById('category-import-file').click()}
                        >
                          <Upload className="w-4 h-4 mr-2" />
                          Seleziona File JSON
                        </Button>
                      </div>
                      
                      {/* Preview */}
                      {importPreview && importPreview.length > 0 && (
                        <div className="mt-3 p-3 bg-white rounded border border-slate-200">
                          <p className="text-xs font-semibold text-slate-700 mb-2">
                            Anteprima: {importPreview.length} categorie da importare
                          </p>
                          <div className="max-h-32 overflow-y-auto text-xs text-slate-600 space-y-1">
                            {importPreview.slice(0, 10).map((cat, idx) => (
                              <div key={idx} className="flex items-center gap-2">
                                <span className="font-medium">{cat.name}</span>
                                <span className="text-slate-400">({cat.slug || 'auto-slug'})</span>
                                {cat.children?.length > 0 && (
                                  <Badge variant="outline" className="text-[10px]">
                                    +{cat.children.length} figli
                                  </Badge>
                                )}
                              </div>
                            ))}
                            {importPreview.length > 10 && (
                              <p className="text-slate-400 italic">...e altre {importPreview.length - 10}</p>
                            )}
                          </div>
                          
                          <div className="flex gap-2 mt-3">
                            <Button 
                              size="sm"
                              className="flex-1 bg-[#008080] hover:bg-[#006666]"
                              disabled={importLoading}
                              onClick={async () => {
                                setImportLoading(true);
                                try {
                                  const response = await adminFetch(`${API_URL}/api/admin/categories/import`, {
                                    method: 'POST',
                                    headers: { 'Content-Type': 'application/json' },
                                    body: JSON.stringify({
                                      parent_slug: importParentSlug,
                                      categories: importPreview
                                    })
                                  });
                                  
                                  const result = await response.json();
                                  
                                  if (result.success) {
                                    toast.success(`Importazione completata: ${result.created} create, ${result.skipped} saltate`);
                                    setImportPreview(null);
                                    setImportParentSlug(null);
                                    loadCategories();
                                    
                                    // Show details in dialog
                                    if (result.created > 0 || result.skipped > 0) {
                                      setImportResult(result);
                                    }
                                  } else {
                                    toast.error('Errore importazione: ' + (result.errors?.join(', ') || 'sconosciuto'));
                                  }
                                } catch (error) {
                                  toast.error('Errore: ' + error.message);
                                } finally {
                                  setImportLoading(false);
                                }
                              }}
                            >
                              {importLoading ? (
                                <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                              ) : (
                                <CheckCircle2 className="w-4 h-4 mr-2" />
                              )}
                              Importa
                            </Button>
                            <Button 
                              size="sm"
                              variant="outline"
                              onClick={() => {
                                setImportPreview(null);
                              }}
                            >
                              Annulla
                            </Button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Format Info */}
                <div className="mt-4 p-3 bg-blue-50 rounded-lg border border-blue-100">
                  <div className="flex items-start gap-2">
                    <AlertCircle className="w-4 h-4 text-blue-500 mt-0.5 flex-shrink-0" />
                    <div className="text-xs text-blue-800">
                      <p className="font-semibold mb-1">Formato JSON per import:</p>
                      <pre className="bg-white/50 p-2 rounded text-[10px] overflow-x-auto">
{`[
  {
    "name": "Nome Categoria",
    "slug": "nome-categoria",
    "icon": "Shirt",
    "sort_order": 10,
    "children": [
      { "name": "Sottocategoria", "slug": "sottocategoria" }
    ]
  }
]`}
                      </pre>
                      <p className="mt-2 text-blue-600">
                        <strong>Nota:</strong> slug auto-generato se non specificato. Categorie con slug esistente vengono saltate.
                      </p>
                    </div>
                  </div>
                </div>
              </Card>
            </div>

            {/* Import Result Dialog */}
            <Dialog open={!!importResult} onOpenChange={() => setImportResult(null)}>
              <DialogContent className="max-w-md">
                <DialogHeader>
                  <DialogTitle className="flex items-center gap-2">
                    <CheckCircle2 className="w-5 h-5 text-green-500" />
                    Importazione Completata
                  </DialogTitle>
                </DialogHeader>
                {importResult && (
                  <div className="space-y-4">
                    <div className="grid grid-cols-2 gap-3">
                      <div className="p-3 bg-green-50 rounded-lg text-center">
                        <p className="text-2xl font-bold text-green-600">{importResult.created}</p>
                        <p className="text-xs text-green-700">Create</p>
                      </div>
                      <div className="p-3 bg-slate-50 rounded-lg text-center">
                        <p className="text-2xl font-bold text-slate-600">{importResult.skipped}</p>
                        <p className="text-xs text-slate-500">Saltate</p>
                      </div>
                    </div>
                    
                    {importResult.created_categories?.length > 0 && (
                      <div>
                        <p className="text-xs font-semibold text-slate-700 mb-2">Categorie create:</p>
                        <div className="max-h-40 overflow-y-auto text-xs space-y-1">
                          {importResult.created_categories.map((cat, idx) => (
                            <div key={idx} className="flex items-center gap-2 p-1.5 bg-green-50 rounded">
                              <CheckCircle2 className="w-3 h-3 text-green-500" />
                              <span>{cat.name}</span>
                              <span className="text-slate-400">({cat.slug})</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                    
                    {importResult.skipped_categories?.length > 0 && (
                      <div>
                        <p className="text-xs font-semibold text-slate-700 mb-2">Categorie saltate (già esistenti):</p>
                        <div className="max-h-32 overflow-y-auto text-xs space-y-1">
                          {importResult.skipped_categories.map((cat, idx) => (
                            <div key={idx} className="flex items-center gap-2 p-1.5 bg-slate-50 rounded">
                              <AlertCircle className="w-3 h-3 text-slate-400" />
                              <span>{cat.name}</span>
                              <span className="text-slate-400">({cat.slug})</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                    
                    <Button className="w-full" onClick={() => setImportResult(null)}>
                      Chiudi
                    </Button>
                  </div>
                )}
              </DialogContent>
            </Dialog>
          </TabsContent>

          {/* Request Options Tab */}
          <TabsContent value="request-options">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {/* Budget Options */}
              <Card className="p-6">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="font-bold text-lg flex items-center gap-2">
                    <Euro className="w-5 h-5 text-green-500" />
                    Opzioni Budget
                  </h3>
                  <Button size="sm" variant="outline" onClick={loadRequestOptions}>
                    <RefreshCw className="w-4 h-4" />
                  </Button>
                </div>
                
                <div className="space-y-3 mb-4">
                  {budgetOptions.map((opt) => (
                    <div key={opt.id} className="flex items-center gap-3 p-3 bg-slate-50 rounded-lg">
                      {editingBudgetOption?.id === opt.id ? (
                        <div className="flex-1 space-y-2">
                          <Input
                            value={editingBudgetOption.value}
                            onChange={(e) => setEditingBudgetOption({...editingBudgetOption, value: e.target.value})}
                            placeholder="Valore (es: 0-50)"
                            className="text-sm"
                          />
                          <Input
                            value={editingBudgetOption.label}
                            onChange={(e) => setEditingBudgetOption({...editingBudgetOption, label: e.target.value})}
                            placeholder="Label (es: €0 - €50)"
                            className="text-sm"
                          />
                          <Input
                            value={editingBudgetOption.description}
                            onChange={(e) => setEditingBudgetOption({...editingBudgetOption, description: e.target.value})}
                            placeholder="Descrizione"
                            className="text-sm"
                          />
                          <div className="flex gap-2">
                            <Button size="sm" onClick={() => saveBudgetOption(editingBudgetOption)} disabled={savingOption}>
                              Salva
                            </Button>
                            <Button size="sm" variant="ghost" onClick={() => setEditingBudgetOption(null)}>
                              Annulla
                            </Button>
                          </div>
                        </div>
                      ) : (
                        <>
                          <div className="flex-1">
                            <p className="font-medium text-sm">{opt.label}</p>
                            <p className="text-xs text-slate-500">{opt.description}</p>
                            <p className="text-xs text-slate-400">value: {opt.value}</p>
                          </div>
                          <div className="flex gap-1">
                            <Button size="sm" variant="ghost" onClick={() => setEditingBudgetOption(opt)}>
                              <Pencil className="w-4 h-4" />
                            </Button>
                            <Button size="sm" variant="ghost" className="text-red-500" onClick={() => deleteBudgetOption(opt.id)}>
                              <Trash2 className="w-4 h-4" />
                            </Button>
                          </div>
                        </>
                      )}
                    </div>
                  ))}
                </div>

                {/* Add new budget option */}
                <div className="border-t pt-4">
                  <p className="font-medium text-sm mb-2">Aggiungi nuova opzione</p>
                  <div className="space-y-2">
                    <Input
                      value={newBudgetOption.value}
                      onChange={(e) => setNewBudgetOption({...newBudgetOption, value: e.target.value})}
                      placeholder="Valore (es: 10000+)"
                      className="text-sm"
                    />
                    <Input
                      value={newBudgetOption.label}
                      onChange={(e) => setNewBudgetOption({...newBudgetOption, label: e.target.value})}
                      placeholder="Label (es: €10.000+)"
                      className="text-sm"
                    />
                    <Input
                      value={newBudgetOption.description}
                      onChange={(e) => setNewBudgetOption({...newBudgetOption, description: e.target.value})}
                      placeholder="Descrizione"
                      className="text-sm"
                    />
                    <Button 
                      size="sm" 
                      onClick={() => saveBudgetOption(newBudgetOption, true)}
                      disabled={!newBudgetOption.value || !newBudgetOption.label || savingOption}
                    >
                      <Plus className="w-4 h-4 mr-1" /> Aggiungi
                    </Button>
                  </div>
                </div>
              </Card>

              {/* Timeline Options */}
              <Card className="p-6">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="font-bold text-lg flex items-center gap-2">
                    <Clock className="w-5 h-5 text-blue-500" />
                    Opzioni Tempistiche
                  </h3>
                </div>
                
                <div className="space-y-3 mb-4">
                  {timelineOptions.map((opt) => (
                    <div key={opt.id} className="flex items-center gap-3 p-3 bg-slate-50 rounded-lg">
                      {editingTimelineOption?.id === opt.id ? (
                        <div className="flex-1 space-y-2">
                          <Input
                            value={editingTimelineOption.value}
                            onChange={(e) => setEditingTimelineOption({...editingTimelineOption, value: e.target.value})}
                            placeholder="Valore (es: 1week)"
                            className="text-sm"
                          />
                          <Input
                            value={editingTimelineOption.label}
                            onChange={(e) => setEditingTimelineOption({...editingTimelineOption, label: e.target.value})}
                            placeholder="Label (es: 1 Settimana)"
                            className="text-sm"
                          />
                          <Input
                            value={editingTimelineOption.description}
                            onChange={(e) => setEditingTimelineOption({...editingTimelineOption, description: e.target.value})}
                            placeholder="Descrizione"
                            className="text-sm"
                          />
                          <div className="flex gap-2">
                            <Button size="sm" onClick={() => saveTimelineOption(editingTimelineOption)} disabled={savingOption}>
                              Salva
                            </Button>
                            <Button size="sm" variant="ghost" onClick={() => setEditingTimelineOption(null)}>
                              Annulla
                            </Button>
                          </div>
                        </div>
                      ) : (
                        <>
                          <div className="flex-1">
                            <p className="font-medium text-sm">{opt.label}</p>
                            <p className="text-xs text-slate-500">{opt.description}</p>
                            <p className="text-xs text-slate-400">value: {opt.value}</p>
                          </div>
                          <div className="flex gap-1">
                            <Button size="sm" variant="ghost" onClick={() => setEditingTimelineOption(opt)}>
                              <Pencil className="w-4 h-4" />
                            </Button>
                            <Button size="sm" variant="ghost" className="text-red-500" onClick={() => deleteTimelineOption(opt.id)}>
                              <Trash2 className="w-4 h-4" />
                            </Button>
                          </div>
                        </>
                      )}
                    </div>
                  ))}
                </div>

                {/* Add new timeline option */}
                <div className="border-t pt-4">
                  <p className="font-medium text-sm mb-2">Aggiungi nuova opzione</p>
                  <div className="space-y-2">
                    <Input
                      value={newTimelineOption.value}
                      onChange={(e) => setNewTimelineOption({...newTimelineOption, value: e.target.value})}
                      placeholder="Valore (es: 1year)"
                      className="text-sm"
                    />
                    <Input
                      value={newTimelineOption.label}
                      onChange={(e) => setNewTimelineOption({...newTimelineOption, label: e.target.value})}
                      placeholder="Label (es: 1 Anno)"
                      className="text-sm"
                    />
                    <Input
                      value={newTimelineOption.description}
                      onChange={(e) => setNewTimelineOption({...newTimelineOption, description: e.target.value})}
                      placeholder="Descrizione"
                      className="text-sm"
                    />
                    <Button 
                      size="sm" 
                      onClick={() => saveTimelineOption(newTimelineOption, true)}
                      disabled={!newTimelineOption.value || !newTimelineOption.label || savingOption}
                    >
                      <Plus className="w-4 h-4 mr-1" /> Aggiungi
                    </Button>
                  </div>
                </div>
              </Card>
            </div>
          </TabsContent>

          {/* Users Tab */}
          <TabsContent value="users">
            <Card className="p-6">
              {/* Filters */}
              <div className="flex flex-col md:flex-row gap-4 mb-6">
                <div className="relative flex-1">
                  <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
                  <Input
                    placeholder="Cerca per nome o email..."
                    value={userSearch}
                    onChange={(e) => setUserSearch(e.target.value)}
                    className="pl-10"
                  />
                </div>
                <Select value={userFilter} onValueChange={setUserFilter}>
                  <SelectTrigger className="w-[180px]">
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="all">Tutti</SelectItem>
                    <SelectItem value="crafters">Artigiani</SelectItem>
                    <SelectItem value="clients">Solo Clienti</SelectItem>
                    <SelectItem value="admins">Admin</SelectItem>
                    <SelectItem value="banned">Sospesi</SelectItem>
                  </SelectContent>
                </Select>
                <Button variant="outline" onClick={loadUsers}>
                  <RefreshCw className="w-4 h-4 mr-2" />Aggiorna
                </Button>
              </div>

              {/* Users Table */}
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead>
                    <tr className="border-b">
                      <th className="text-left py-3 px-4">Utente</th>
                      <th className="text-left py-3 px-4">Ruolo</th>
                      <th className="text-left py-3 px-4">Tier</th>
                      <th className="text-left py-3 px-4">Status</th>
                      <th className="text-left py-3 px-4">Registrato</th>
                      <th className="text-left py-3 px-4">Azioni</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedUsers.map(u => (
                      <tr key={u.id} className="border-b hover:bg-slate-50">
                        <td className="py-3 px-4">
                          <div className="flex items-center gap-3">
                            <div className="w-8 h-8 rounded-full bg-[#008080] flex items-center justify-center text-white text-sm font-bold">
                              {(u.full_name || u.email || 'U')[0].toUpperCase()}
                            </div>
                            <div>
                              <p className="font-medium text-sm">{u.full_name || '-'}</p>
                              <p className="text-xs text-slate-500">{u.email}</p>
                            </div>
                          </div>
                        </td>
                        <td className="py-3 px-4">
                          <div className="flex flex-wrap gap-1">
                            {u.is_admin && <Badge className="bg-red-500 text-white text-xs">Admin</Badge>}
                            {u.is_crafter_enabled && <Badge className="bg-amber-500 text-white text-xs">Crafter</Badge>}
                            {!u.is_crafter_enabled && !u.is_admin && <Badge variant="outline" className="text-xs">Cliente</Badge>}
                          </div>
                        </td>
                        <td className="py-3 px-4">
                          <Select 
                            value={u.tier || 'free'} 
                            onValueChange={(val) => updateUserTier(u.id, val)}
                          >
                            <SelectTrigger className="w-[100px] h-8 text-xs">
                              <SelectValue />
                            </SelectTrigger>
                            <SelectContent>
                              <SelectItem value="free">Free</SelectItem>
                              <SelectItem value="premium">Premium</SelectItem>
                              <SelectItem value="pro">Pro</SelectItem>
                            </SelectContent>
                          </Select>
                        </td>
                        <td className="py-3 px-4">
                          {u.is_banned ? (
                            <Badge className="bg-red-100 text-red-700">Sospeso</Badge>
                          ) : (
                            <Badge className="bg-green-100 text-green-700">Attivo</Badge>
                          )}
                        </td>
                        <td className="py-3 px-4 text-sm text-slate-500">
                          {formatDate(u.created_at)}
                        </td>
                        <td className="py-3 px-4">
                          <div className="flex gap-1">
                            <Button 
                              size="sm" 
                              variant="ghost" 
                              onClick={() => setSelectedUser(u)}
                              title="Dettagli"
                            >
                              <Eye className="w-4 h-4" />
                            </Button>
                            <Button 
                              size="sm" 
                              variant="ghost"
                              onClick={() => toggleCrafterStatus(u.id, u.is_crafter_enabled)}
                              title={u.is_crafter_enabled ? 'Rimuovi crafter' : 'Abilita crafter'}
                            >
                              <Crown className={`w-4 h-4 ${u.is_crafter_enabled ? 'text-amber-500' : 'text-slate-400'}`} />
                            </Button>
                            <Button 
                              size="sm" 
                              variant="ghost"
                              onClick={() => toggleUserStatus(u.id, u.is_banned)}
                              title={u.is_banned ? 'Riattiva' : 'Sospendi'}
                            >
                              {u.is_banned ? (
                                <CircleCheck className="w-4 h-4 text-green-500" />
                              ) : (
                                <Ban className="w-4 h-4 text-red-500" />
                              )}
                            </Button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              {totalUserPages > 1 && (
                <div className="flex items-center justify-between mt-4 pt-4 border-t">
                  <p className="text-sm text-slate-500">
                    Mostrando {((currentPage - 1) * itemsPerPage) + 1} - {Math.min(currentPage * itemsPerPage, filteredUsers.length)} di {filteredUsers.length}
                  </p>
                  <div className="flex gap-2">
                    <Button 
                      variant="outline" 
                      size="sm" 
                      onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                      disabled={currentPage === 1}
                    >
                      <ChevronLeft className="w-4 h-4" />
                    </Button>
                    <span className="px-3 py-1 text-sm">{currentPage} / {totalUserPages}</span>
                    <Button 
                      variant="outline" 
                      size="sm" 
                      onClick={() => setCurrentPage(p => Math.min(totalUserPages, p + 1))}
                      disabled={currentPage === totalUserPages}
                    >
                      <ChevronRight className="w-4 h-4" />
                    </Button>
                  </div>
                </div>
              )}
            </Card>
          </TabsContent>

          {/* Orders Tab */}
          <TabsContent value="orders">
            <Card className="p-6">
              <div className="flex items-center justify-between mb-6">
                <Select value={orderFilter} onValueChange={setOrderFilter}>
                  <SelectTrigger className="w-[180px]">
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="all">Tutti gli Stati</SelectItem>
                    <SelectItem value="confirmed">Confermati</SelectItem>
                    <SelectItem value="in_progress">In Lavorazione</SelectItem>
                    <SelectItem value="ready">Pronti</SelectItem>
                    <SelectItem value="shipped">Spediti</SelectItem>
                    <SelectItem value="delivered">Consegnati</SelectItem>
                    <SelectItem value="completed">Completati</SelectItem>
                    <SelectItem value="cancelled">Annullati</SelectItem>
                  </SelectContent>
                </Select>
                <Button variant="outline" onClick={loadOrders}>
                  <RefreshCw className="w-4 h-4 mr-2" />Aggiorna
                </Button>
              </div>

              <div className="space-y-3">
                {filteredOrders.map(order => (
                  <div key={order.id} className="flex items-center gap-4 p-4 bg-slate-50 rounded-lg">
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2 mb-1">
                        <p className="font-semibold truncate">{order.title}</p>
                        <Badge className={getStatusColor(order.status)}>{order.status}</Badge>
                      </div>
                      <div className="flex items-center gap-4 text-sm text-slate-500">
                        <span>Cliente: {order.client?.full_name || '-'}</span>
                        <span>Artigiano: {order.crafter?.storefront_title || order.crafter?.full_name || '-'}</span>
                        <span>{formatDate(order.created_at)}</span>
                      </div>
                    </div>
                    <div className="text-right">
                      <p className="text-lg font-bold text-green-600">€{(order.total || order.agreed_price || 0).toFixed(2)}</p>
                    </div>
                    <div className="flex gap-2">
                      <Select 
                        value={order.status} 
                        onValueChange={(val) => updateOrderStatus(order.id, val)}
                      >
                        <SelectTrigger className="w-[140px] h-9">
                          <SelectValue />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectItem value="confirmed">Confermato</SelectItem>
                          <SelectItem value="in_progress">In Lavorazione</SelectItem>
                          <SelectItem value="ready">Pronto</SelectItem>
                          <SelectItem value="shipped">Spedito</SelectItem>
                          <SelectItem value="delivered">Consegnato</SelectItem>
                          <SelectItem value="completed">Completato</SelectItem>
                          <SelectItem value="cancelled">Annullato</SelectItem>
                        </SelectContent>
                      </Select>
                    </div>
                  </div>
                ))}
                {filteredOrders.length === 0 && (
                  <div className="text-center py-8 text-slate-500">
                    <Package className="w-12 h-12 mx-auto mb-3 text-slate-300" />
                    <p>Nessun ordine trovato</p>
                  </div>
                )}
              </div>
            </Card>
          </TabsContent>

          {/* Requests Tab */}
          <TabsContent value="requests">
            <Card className="p-6">
              <div className="flex items-center justify-between mb-6">
                <h3 className="font-bold text-lg">Tutte le Richieste</h3>
                <Button variant="outline" onClick={loadRequests}>
                  <RefreshCw className="w-4 h-4 mr-2" />Aggiorna
                </Button>
              </div>

              <div className="space-y-3">
                {requests.map(req => (
                  <div key={req.id} className="p-4 border rounded-lg hover:bg-slate-50">
                    <div className="flex items-start justify-between gap-4">
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center gap-2 mb-1">
                          <p className="font-semibold">{req.title}</p>
                          <Badge className={getStatusColor(req.status)}>{req.status}</Badge>
                        </div>
                        <p className="text-sm text-slate-600 line-clamp-2">{req.description}</p>
                        <div className="flex items-center gap-4 mt-2 text-xs text-slate-500">
                          <span>Da: {req.client?.full_name || '-'}</span>
                          <span>Budget: {req.budget_range}</span>
                          <span>Categoria: {req.category}</span>
                          <span>{formatDate(req.created_at)}</span>
                        </div>
                      </div>
                      <div className="text-right">
                        <Badge variant="outline">{req.proposals?.[0]?.count || 0} proposte</Badge>
                      </div>
                    </div>
                  </div>
                ))}
                {requests.length === 0 && (
                  <div className="text-center py-8 text-slate-500">
                    <FileText className="w-12 h-12 mx-auto mb-3 text-slate-300" />
                    <p>Nessuna richiesta trovata</p>
                  </div>
                )}
              </div>
            </Card>
          </TabsContent>

          {/* Messages Tab */}
          <TabsContent value="messages">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
              {/* Messages List */}
              <Card className="lg:col-span-2 p-6">
                <div className="flex items-center justify-between mb-6">
                  <h3 className="font-bold text-lg flex items-center gap-2">
                    <Mail className="w-5 h-5 text-blue-500" />
                    Messaggi di Contatto
                    {unreadMessagesCount > 0 && (
                      <Badge className="bg-red-500 text-white ml-2">{unreadMessagesCount} non letti</Badge>
                    )}
                  </h3>
                  <div className="flex items-center gap-2">
                    <Select value={messageFilter} onValueChange={(v) => { setMessageFilter(v); fetchContactMessages(v); }}>
                      <SelectTrigger className="w-[150px]">
                        <SelectValue placeholder="Filtra" />
                      </SelectTrigger>
                      <SelectContent>
                        <SelectItem value="all">Tutti</SelectItem>
                        <SelectItem value="new">Nuovi</SelectItem>
                        <SelectItem value="in_progress">In lavorazione</SelectItem>
                        <SelectItem value="replied">Risposti</SelectItem>
                        <SelectItem value="closed">Chiusi</SelectItem>
                      </SelectContent>
                    </Select>
                    <Button 
                      variant="outline" 
                      size="sm"
                      onClick={() => fetchContactMessages(messageFilter)}
                    >
                      <RefreshCw className="w-4 h-4" />
                    </Button>
                  </div>
                </div>

                {loadingMessages ? (
                  <div className="text-center py-12">
                    <Loader2 className="w-8 h-8 animate-spin mx-auto text-slate-400" />
                    <p className="text-slate-500 mt-2">Caricamento...</p>
                  </div>
                ) : contactMessages.length === 0 ? (
                  <div className="text-center py-12 text-slate-500">
                    <Mail className="w-12 h-12 mx-auto mb-3 text-slate-300" />
                    <p>Nessun messaggio trovato</p>
                  </div>
                ) : (
                  <div className="space-y-3 max-h-[600px] overflow-y-auto">
                    {contactMessages.map((msg) => (
                      <div 
                        key={msg.id}
                        onClick={() => {
                          setSelectedMessage(msg);
                          if (!msg.read) markMessageAsRead(msg.id);
                        }}
                        className={`p-4 rounded-lg border cursor-pointer transition-all hover:shadow-md ${
                          selectedMessage?.id === msg.id 
                            ? 'border-blue-500 bg-blue-50' 
                            : msg.read 
                              ? 'border-slate-200 bg-white' 
                              : 'border-blue-300 bg-blue-50/50'
                        }`}
                      >
                        <div className="flex items-start justify-between gap-4">
                          <div className="flex-1 min-w-0">
                            <div className="flex items-center gap-2 mb-1">
                              {!msg.read && (
                                <span className="w-2 h-2 bg-blue-500 rounded-full flex-shrink-0"></span>
                              )}
                              <span className="font-semibold text-slate-900 truncate">{msg.name}</span>
                              {getStatusBadge(msg.status)}
                            </div>
                            <p className="text-sm text-slate-500 truncate">{msg.email}</p>
                            <p className="text-sm text-slate-700 mt-1 truncate">
                              {msg.subject || getReasonLabel(msg.reason)}
                            </p>
                          </div>
                          <div className="text-right flex-shrink-0">
                            <p className="text-xs text-slate-400">
                              {new Date(msg.created_at).toLocaleDateString('it-IT', { 
                                day: '2-digit', 
                                month: 'short',
                                hour: '2-digit',
                                minute: '2-digit'
                              })}
                            </p>
                            <Badge variant="outline" className="mt-1 text-xs">
                              {getReasonLabel(msg.reason)}
                            </Badge>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </Card>

              {/* Message Detail */}
              <Card className="p-6">
                {selectedMessage ? (
                  <div>
                    <div className="flex items-center justify-between mb-4">
                      <h3 className="font-bold text-lg">Dettaglio Messaggio</h3>
                      <Button 
                        variant="ghost" 
                        size="sm"
                        onClick={() => setSelectedMessage(null)}
                      >
                        <CircleX className="w-4 h-4" />
                      </Button>
                    </div>
                    
                    <div className="space-y-4">
                      <div>
                        <Label className="text-xs text-slate-500">Da</Label>
                        <p className="font-medium">{selectedMessage.name}</p>
                        <a 
                          href={`mailto:${selectedMessage.email}`}
                          className="text-sm text-blue-600 hover:underline"
                        >
                          {selectedMessage.email}
                        </a>
                      </div>

                      <div>
                        <Label className="text-xs text-slate-500">Motivo</Label>
                        <p>{getReasonLabel(selectedMessage.reason)}</p>
                      </div>

                      {selectedMessage.order_number && (
                        <div>
                          <Label className="text-xs text-slate-500">Numero Ordine</Label>
                          <p className="font-mono">{selectedMessage.order_number}</p>
                        </div>
                      )}

                      {selectedMessage.subject && (
                        <div>
                          <Label className="text-xs text-slate-500">Oggetto</Label>
                          <p>{selectedMessage.subject}</p>
                        </div>
                      )}

                      <div>
                        <Label className="text-xs text-slate-500">Messaggio</Label>
                        <div className="mt-1 p-3 bg-slate-50 rounded-lg text-sm whitespace-pre-wrap max-h-[200px] overflow-y-auto">
                          {selectedMessage.message}
                        </div>
                      </div>

                      <div>
                        <Label className="text-xs text-slate-500">Stato</Label>
                        <Select 
                          value={selectedMessage.status} 
                          onValueChange={(v) => updateMessageStatus(selectedMessage.id, v)}
                        >
                          <SelectTrigger className="mt-1">
                            <SelectValue />
                          </SelectTrigger>
                          <SelectContent>
                            <SelectItem value="new">Nuovo</SelectItem>
                            <SelectItem value="in_progress">In lavorazione</SelectItem>
                            <SelectItem value="replied">Risposto</SelectItem>
                            <SelectItem value="closed">Chiuso</SelectItem>
                          </SelectContent>
                        </Select>
                      </div>

                      <div className="pt-4 border-t flex gap-2">
                        <Button 
                          className="flex-1 bg-blue-600 hover:bg-blue-700"
                          onClick={() => window.open(`mailto:${selectedMessage.email}?subject=Re: ${selectedMessage.subject || getReasonLabel(selectedMessage.reason)}`)}
                        >
                          <Send className="w-4 h-4 mr-2" />
                          Rispondi via Email
                        </Button>
                        <Button 
                          variant="outline"
                          className="text-red-600 hover:bg-red-50"
                          onClick={() => deleteContactMessage(selectedMessage.id)}
                        >
                          <Trash2 className="w-4 h-4" />
                        </Button>
                      </div>

                      <div className="text-xs text-slate-400 mt-2">
                        Ricevuto: {new Date(selectedMessage.created_at).toLocaleString('it-IT')}
                        {selectedMessage.replied_at && (
                          <><br/>Risposto: {new Date(selectedMessage.replied_at).toLocaleString('it-IT')}</>
                        )}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="text-center py-12 text-slate-500">
                    <MessageCircle className="w-12 h-12 mx-auto mb-3 text-slate-300" />
                    <p>Seleziona un messaggio per vedere i dettagli</p>
                  </div>
                )}
              </Card>
            </div>
          </TabsContent>

          {/* Connectors Tab - OAuth Providers */}
          <TabsContent value="connectors">
            <div className="space-y-6">
              {/* Header */}
              <div className="flex items-center justify-between">
                <div>
                  <h2 className="text-2xl font-bold flex items-center gap-2">
                    <Plug className="w-6 h-6 text-blue-500" />
                    Connettori Autenticazione
                  </h2>
                  <p className="text-slate-500 mt-1">Configura i provider OAuth per login social</p>
                </div>
                <Button 
                  variant="outline" 
                  onClick={loadOAuthProviders}
                  disabled={loadingOAuth}
                >
                  <RefreshCw className={`w-4 h-4 mr-2 ${loadingOAuth ? 'animate-spin' : ''}`} />
                  Ricarica
                </Button>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                
                {/* Google OAuth Card */}
                <Card className="p-6 border-2 border-slate-200 hover:border-blue-300 transition-colors">
                  <div className="flex items-start justify-between mb-6">
                    <div className="flex items-center gap-3">
                      <div className="w-12 h-12 rounded-xl bg-white border-2 border-slate-200 flex items-center justify-center">
                        <svg className="w-6 h-6" viewBox="0 0 24 24">
                          <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                          <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                          <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                          <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                        </svg>
                      </div>
                      <div>
                        <h3 className="font-bold text-lg">Google OAuth</h3>
                        <p className="text-sm text-slate-500">Accedi con Google</p>
                      </div>
                    </div>
                    <div className="flex items-center gap-2">
                      <span className={`text-sm font-medium ${googleConfig.is_enabled ? 'text-green-600' : 'text-slate-400'}`}>
                        {googleConfig.is_enabled ? 'Attivo' : 'Disattivo'}
                      </span>
                      <Switch
                        checked={googleConfig.is_enabled}
                        onCheckedChange={() => toggleOAuthProvider('google')}
                        disabled={!googleConfig.client_id || !googleConfig.has_secret}
                      />
                    </div>
                  </div>

                  {/* Instructions Accordion */}
                  <details className="mb-4 bg-blue-50 rounded-lg">
                    <summary className="p-3 cursor-pointer flex items-center gap-2 text-sm text-blue-700 font-medium">
                      <Info className="w-4 h-4" />
                      Come ottenere le credenziali Google
                    </summary>
                    <div className="px-3 pb-3 text-sm text-slate-600 space-y-2">
                      <ol className="list-decimal list-inside space-y-1">
                        <li>Vai su <a href="https://console.cloud.google.com/" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">Google Cloud Console</a></li>
                        <li>Crea un nuovo progetto o seleziona uno esistente</li>
                        <li>Vai su <strong>API e servizi → Credenziali</strong></li>
                        <li>Clicca <strong>"Crea credenziali" → "ID client OAuth"</strong></li>
                        <li>Seleziona <strong>"Applicazione web"</strong></li>
                        <li>In "URI di reindirizzamento autorizzati" aggiungi:<br/>
                          <code className="bg-white px-2 py-1 rounded text-xs block mt-1 select-all">
                            {window.location.origin}/auth/callback/google
                          </code>
                        </li>
                        <li>Copia <strong>Client ID</strong> e <strong>Client Secret</strong></li>
                      </ol>
                      <div className="mt-2 p-2 bg-yellow-50 rounded border border-yellow-200 text-yellow-800 text-xs">
                        <strong>Nota:</strong> Devi anche configurare la "Schermata consenso OAuth" con gli scope: email, profile
                      </div>
                    </div>
                  </details>

                  {/* Form Fields */}
                  <div className="space-y-4">
                    <div>
                      <Label htmlFor="google-client-id" className="text-sm font-medium">Client ID</Label>
                      <div className="flex gap-2 mt-1">
                        <Input
                          id="google-client-id"
                          value={googleConfig.client_id}
                          onChange={(e) => setGoogleConfig({...googleConfig, client_id: e.target.value})}
                          placeholder="xxx.apps.googleusercontent.com"
                          className="font-mono text-sm"
                        />
                        {googleConfig.client_id && (
                          <Button variant="ghost" size="icon" onClick={() => {
                            navigator.clipboard.writeText(googleConfig.client_id);
                            toast.success('Client ID copiato');
                          }}>
                            <Copy className="w-4 h-4" />
                          </Button>
                        )}
                      </div>
                    </div>

                    <div>
                      <Label htmlFor="google-client-secret" className="text-sm font-medium">Client Secret</Label>
                      <div className="flex gap-2 mt-1">
                        <div className="relative flex-1">
                          <Input
                            id="google-client-secret"
                            type={showGoogleSecret ? 'text' : 'password'}
                            value={googleConfig.client_secret}
                            onChange={(e) => setGoogleConfig({...googleConfig, client_secret: e.target.value})}
                            placeholder={googleConfig.has_secret ? '••••' + googleConfig.client_secret_masked?.slice(-4) : 'Inserisci il secret'}
                            className="font-mono text-sm pr-10"
                          />
                          <button
                            type="button"
                            onClick={() => setShowGoogleSecret(!showGoogleSecret)}
                            className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600"
                          >
                            {showGoogleSecret ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                          </button>
                        </div>
                      </div>
                      {googleConfig.has_secret && !googleConfig.client_secret && (
                        <p className="text-xs text-green-600 mt-1">✓ Secret già configurato. Lascia vuoto per mantenerlo.</p>
                      )}
                    </div>

                    <div className="flex gap-2 pt-2">
                      <Button
                        onClick={() => saveOAuthProvider('google', googleConfig)}
                        disabled={savingOAuth || !googleConfig.client_id}
                        className="flex-1"
                      >
                        {savingOAuth ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <CheckCircle2 className="w-4 h-4 mr-2" />}
                        Salva Configurazione
                      </Button>
                    </div>
                  </div>
                </Card>

                {/* Facebook OAuth Card */}
                <Card className="p-6 border-2 border-slate-200 hover:border-blue-300 transition-colors">
                  <div className="flex items-start justify-between mb-6">
                    <div className="flex items-center gap-3">
                      <div className="w-12 h-12 rounded-xl bg-[#1877F2] flex items-center justify-center">
                        <svg className="w-6 h-6" viewBox="0 0 24 24" fill="white">
                          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                        </svg>
                      </div>
                      <div>
                        <h3 className="font-bold text-lg">Facebook OAuth</h3>
                        <p className="text-sm text-slate-500">Accedi con Facebook</p>
                      </div>
                    </div>
                    <div className="flex items-center gap-2">
                      <span className={`text-sm font-medium ${facebookConfig.is_enabled ? 'text-green-600' : 'text-slate-400'}`}>
                        {facebookConfig.is_enabled ? 'Attivo' : 'Disattivo'}
                      </span>
                      <Switch
                        checked={facebookConfig.is_enabled}
                        onCheckedChange={() => toggleOAuthProvider('facebook')}
                        disabled={!facebookConfig.client_id || !facebookConfig.has_secret}
                      />
                    </div>
                  </div>

                  {/* Instructions Accordion */}
                  <details className="mb-4 bg-blue-50 rounded-lg">
                    <summary className="p-3 cursor-pointer flex items-center gap-2 text-sm text-blue-700 font-medium">
                      <Info className="w-4 h-4" />
                      Come ottenere le credenziali Facebook
                    </summary>
                    <div className="px-3 pb-3 text-sm text-slate-600 space-y-2">
                      <ol className="list-decimal list-inside space-y-1">
                        <li>Vai su <a href="https://developers.facebook.com/" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">Facebook Developers</a></li>
                        <li>Clicca <strong>"Le mie app" → "Crea app"</strong></li>
                        <li>Seleziona <strong>"Consumatore"</strong> o <strong>"Business"</strong></li>
                        <li>Nel pannello dell'app, vai su <strong>"Impostazioni" → "Di base"</strong></li>
                        <li>Copia <strong>ID app</strong> (Client ID) e <strong>Chiave segreta</strong></li>
                        <li>Vai su <strong>"Facebook Login" → "Impostazioni"</strong></li>
                        <li>In "URI di reindirizzamento OAuth validi" aggiungi:<br/>
                          <code className="bg-white px-2 py-1 rounded text-xs block mt-1 select-all">
                            {window.location.origin}/auth/callback/facebook
                          </code>
                        </li>
                      </ol>
                      <div className="mt-2 p-2 bg-yellow-50 rounded border border-yellow-200 text-yellow-800 text-xs">
                        <strong>Nota:</strong> L'app deve essere in modalità "Live" per funzionare con utenti esterni
                      </div>
                    </div>
                  </details>

                  {/* Form Fields */}
                  <div className="space-y-4">
                    <div>
                      <Label htmlFor="facebook-client-id" className="text-sm font-medium">App ID (Client ID)</Label>
                      <div className="flex gap-2 mt-1">
                        <Input
                          id="facebook-client-id"
                          value={facebookConfig.client_id}
                          onChange={(e) => setFacebookConfig({...facebookConfig, client_id: e.target.value})}
                          placeholder="123456789012345"
                          className="font-mono text-sm"
                        />
                        {facebookConfig.client_id && (
                          <Button variant="ghost" size="icon" onClick={() => {
                            navigator.clipboard.writeText(facebookConfig.client_id);
                            toast.success('App ID copiato');
                          }}>
                            <Copy className="w-4 h-4" />
                          </Button>
                        )}
                      </div>
                    </div>

                    <div>
                      <Label htmlFor="facebook-client-secret" className="text-sm font-medium">App Secret (Client Secret)</Label>
                      <div className="flex gap-2 mt-1">
                        <div className="relative flex-1">
                          <Input
                            id="facebook-client-secret"
                            type={showFacebookSecret ? 'text' : 'password'}
                            value={facebookConfig.client_secret}
                            onChange={(e) => setFacebookConfig({...facebookConfig, client_secret: e.target.value})}
                            placeholder={facebookConfig.has_secret ? '••••' + facebookConfig.client_secret_masked?.slice(-4) : 'Inserisci il secret'}
                            className="font-mono text-sm pr-10"
                          />
                          <button
                            type="button"
                            onClick={() => setShowFacebookSecret(!showFacebookSecret)}
                            className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600"
                          >
                            {showFacebookSecret ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                          </button>
                        </div>
                      </div>
                      {facebookConfig.has_secret && !facebookConfig.client_secret && (
                        <p className="text-xs text-green-600 mt-1">✓ Secret già configurato. Lascia vuoto per mantenerlo.</p>
                      )}
                    </div>

                    <div className="flex gap-2 pt-2">
                      <Button
                        onClick={() => saveOAuthProvider('facebook', facebookConfig)}
                        disabled={savingOAuth || !facebookConfig.client_id}
                        className="flex-1"
                      >
                        {savingOAuth ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <CheckCircle2 className="w-4 h-4 mr-2" />}
                        Salva Configurazione
                      </Button>
                    </div>
                  </div>
                </Card>
              </div>

              {/* Divider */}
              <div className="border-t border-slate-200 my-6"></div>

              {/* Section Header - Analytics */}
              <div className="flex items-center gap-2 mb-4">
                <BarChart3 className="w-5 h-5 text-orange-500" />
                <h3 className="text-lg font-semibold">Tracking & Analytics</h3>
              </div>

              {/* Google Analytics Card */}
              <Card className="p-6 border-2 border-slate-200 hover:border-orange-300 transition-colors">
                <div className="flex items-start justify-between mb-6">
                  <div className="flex items-center gap-3">
                    <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-orange-400 to-yellow-500 flex items-center justify-center">
                      <svg className="w-6 h-6 text-white" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12.87 15.07l-2.54-2.51.03-.03A11.493 11.493 0 0014.5 6c0-.88-.11-1.74-.32-2.57l-2.05.56c.16.62.25 1.27.25 1.95 0 3.29-2.24 6.06-5.27 6.87l-.92 2.03 1.12 1.1A13.4 13.4 0 0012 18.5c.84 0 1.66-.08 2.45-.23l.01-.01-1.59-3.19zM9.25 5c0-.64.1-1.25.28-1.83L6.6 2.22C6.22 3.1 6 4.02 6 5c0 3.33 1.92 6.22 4.73 7.64l.01-.01L9.25 10c-.97-1.29-1.5-2.87-1.5-4.5 0-.17 0-.33.01-.5H7.5c-.55 0-1-.45-1-1s.45-1 1-1h3c.55 0 1 .45 1 1s-.45 1-1 1h-.26c0 .17.01.33.01.5 0 1.08.32 2.08.87 2.93l1.13-2.21c-.42-.73-.74-1.52-.91-2.35l1.97-.54A9.47 9.47 0 0112 5c0-1.02-.15-2-.44-2.93L9.53 2.5c.18.78.22 1.6.22 2.5z"/>
                        <circle cx="12" cy="12" r="3"/>
                      </svg>
                    </div>
                    <div>
                      <h3 className="font-bold text-lg">Google Analytics 4</h3>
                      <p className="text-sm text-slate-500">Tracciamento visite e comportamento</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className={`text-sm font-medium ${analyticsConfig.is_enabled ? 'text-green-600' : 'text-slate-400'}`}>
                      {analyticsConfig.is_enabled ? 'Attivo' : 'Disattivo'}
                    </span>
                    <Switch
                      checked={analyticsConfig.is_enabled}
                      onCheckedChange={toggleAnalytics}
                      disabled={!analyticsConfig.measurement_id}
                    />
                  </div>
                </div>

                {/* Instructions Accordion */}
                <details className="mb-4 bg-orange-50 rounded-lg">
                  <summary className="p-3 cursor-pointer flex items-center gap-2 text-sm text-orange-700 font-medium">
                    <Info className="w-4 h-4" />
                    Come ottenere il Measurement ID
                  </summary>
                  <div className="px-3 pb-3 text-sm text-slate-600 space-y-2">
                    <ol className="list-decimal list-inside space-y-1">
                      <li>Vai su <a href="https://analytics.google.com/" target="_blank" rel="noopener noreferrer" className="text-orange-600 underline">Google Analytics</a></li>
                      <li>Clicca <strong>"Amministratore"</strong> (icona ingranaggio in basso a sinistra)</li>
                      <li>Nella colonna "Proprietà", clicca <strong>"Flussi di dati"</strong></li>
                      <li>Seleziona o crea un flusso web per il tuo sito</li>
                      <li>Copia il <strong>Measurement ID</strong> (formato: G-XXXXXXXXXX)</li>
                    </ol>
                    <div className="mt-2 p-2 bg-yellow-50 rounded border border-yellow-200 text-yellow-800 text-xs">
                      <strong>Nota:</strong> Il Measurement ID di GA4 inizia sempre con "G-" seguito da caratteri alfanumerici
                    </div>
                  </div>
                </details>

                {/* Form Fields */}
                <div className="space-y-4">
                  <div>
                    <Label htmlFor="ga-measurement-id" className="text-sm font-medium">Measurement ID</Label>
                    <div className="flex gap-2 mt-1">
                      <Input
                        id="ga-measurement-id"
                        value={analyticsConfig.measurement_id}
                        onChange={(e) => setAnalyticsConfig({...analyticsConfig, measurement_id: e.target.value})}
                        placeholder="G-XXXXXXXXXX"
                        className="font-mono text-sm"
                      />
                      {analyticsConfig.measurement_id && (
                        <Button variant="ghost" size="icon" onClick={() => {
                          navigator.clipboard.writeText(analyticsConfig.measurement_id);
                          toast.success('Measurement ID copiato');
                        }}>
                          <Copy className="w-4 h-4" />
                        </Button>
                      )}
                    </div>
                    {analyticsConfig.measurement_id && !analyticsConfig.measurement_id.startsWith('G-') && (
                      <p className="text-xs text-amber-600 mt-1">⚠️ Il Measurement ID dovrebbe iniziare con "G-"</p>
                    )}
                  </div>

                  {/* Privacy Options */}
                  <div className="space-y-3 pt-2">
                    <div className="flex items-center justify-between">
                      <div>
                        <Label className="text-sm font-medium">Anonimizza IP</Label>
                        <p className="text-xs text-slate-500">Rende anonimi gli indirizzi IP degli utenti</p>
                      </div>
                      <Switch
                        checked={analyticsConfig.anonymize_ip}
                        onCheckedChange={(checked) => setAnalyticsConfig({...analyticsConfig, anonymize_ip: checked})}
                      />
                    </div>

                    <div className="flex items-center justify-between">
                      <div>
                        <Label className="text-sm font-medium">Richiedi consenso cookie</Label>
                        <p className="text-xs text-slate-500">Attiva Analytics solo dopo consenso GDPR</p>
                      </div>
                      <Switch
                        checked={analyticsConfig.cookie_consent_required}
                        onCheckedChange={(checked) => setAnalyticsConfig({...analyticsConfig, cookie_consent_required: checked})}
                      />
                    </div>
                  </div>

                  <div className="flex gap-2 pt-2">
                    <Button
                      onClick={saveAnalyticsConfig}
                      disabled={savingAnalytics || !analyticsConfig.measurement_id}
                      className="flex-1"
                    >
                      {savingAnalytics ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <CheckCircle2 className="w-4 h-4 mr-2" />}
                      Salva Configurazione
                    </Button>
                  </div>
                </div>
              </Card>

              {/* Section Header - Payments */}
              <div className="flex items-center gap-2 mb-4 mt-8">
                <CreditCard className="w-5 h-5 text-purple-500" />
                <h3 className="text-lg font-semibold">Pagamenti</h3>
              </div>

              {/* Stripe Card */}
              <Card className="p-6 border-2 border-slate-200 hover:border-purple-300 transition-colors">
                <div className="flex items-start justify-between mb-6">
                  <div className="flex items-center gap-3">
                    <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-purple-500 to-indigo-600 flex items-center justify-center">
                      <svg className="w-6 h-6 text-white" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M13.976 9.15c-2.172-.806-3.356-1.426-3.356-2.409 0-.831.683-1.305 1.901-1.305 2.227 0 4.515.858 6.09 1.631l.89-5.494C18.252.975 15.697 0 12.165 0 9.667 0 7.589.654 6.104 1.872 4.56 3.147 3.757 4.992 3.757 7.218c0 4.039 2.467 5.76 6.476 7.219 2.585.92 3.445 1.574 3.445 2.583 0 .98-.84 1.545-2.354 1.545-1.875 0-4.965-.921-6.99-2.109l-.9 5.555C5.175 22.99 8.385 24 11.714 24c2.641 0 4.843-.624 6.328-1.813 1.664-1.305 2.525-3.236 2.525-5.732 0-4.128-2.524-5.851-6.591-7.305z"/>
                      </svg>
                    </div>
                    <div>
                      <h3 className="font-bold text-lg">Stripe</h3>
                      <p className="text-sm text-slate-500">Pagamenti e Connect per artigiani</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    <Badge variant={stripeConfig.is_live_mode ? 'default' : 'secondary'} className={stripeConfig.is_live_mode ? 'bg-green-100 text-green-700' : 'bg-yellow-100 text-yellow-700'}>
                      {stripeConfig.is_live_mode ? 'LIVE' : 'TEST'}
                    </Badge>
                    <span className={`text-sm font-medium ${stripeConfig.is_enabled ? 'text-green-600' : 'text-slate-400'}`}>
                      {stripeConfig.is_enabled ? 'Attivo' : 'Disattivo'}
                    </span>
                    <Switch
                      checked={stripeConfig.is_enabled}
                      onCheckedChange={toggleStripe}
                      disabled={!stripeConfig.has_api_key}
                    />
                  </div>
                </div>

                {/* Instructions Accordion */}
                <details className="mb-4 bg-purple-50 rounded-lg">
                  <summary className="p-3 cursor-pointer flex items-center gap-2 text-sm text-purple-700 font-medium">
                    <Info className="w-4 h-4" />
                    Come ottenere le credenziali Stripe
                  </summary>
                  <div className="px-3 pb-3 text-sm text-slate-600 space-y-2">
                    <ol className="list-decimal list-inside space-y-1">
                      <li>Vai su <a href="https://dashboard.stripe.com/apikeys" target="_blank" rel="noopener noreferrer" className="text-purple-600 underline">Stripe Dashboard → API Keys</a></li>
                      <li>Copia la <strong>Secret Key</strong> (inizia con sk_test_ o sk_live_)</li>
                      <li>Per i webhook, vai su <strong>Developers → Webhooks</strong></li>
                      <li>Crea un endpoint puntando a: <code className="bg-white px-2 py-1 rounded text-xs">{window.location.origin.replace('https://', 'https://').replace(':3000', '')}/api/webhook/stripe</code></li>
                      <li>Copia il <strong>Signing Secret</strong> del webhook (inizia con whsec_)</li>
                    </ol>
                    <div className="mt-2 p-2 bg-yellow-50 rounded border border-yellow-200 text-yellow-800 text-xs">
                      <strong>Importante:</strong> Per passare in produzione, sostituisci le chiavi test (sk_test_) con quelle live (sk_live_)
                    </div>
                  </div>
                </details>

                {/* Form Fields */}
                <div className="space-y-6">
                  {/* Banner modalità attiva */}
                  <div className={`p-3 rounded-lg border-2 ${stripeConfig.is_live_mode ? 'bg-red-50 border-red-300' : 'bg-emerald-50 border-emerald-300'}`}>
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-2">
                        <div className={`w-2 h-2 rounded-full ${stripeConfig.is_live_mode ? 'bg-red-500 animate-pulse' : 'bg-emerald-500'}`}></div>
                        <span className="text-sm font-semibold">
                          Modalità attualmente attiva: <strong>{stripeConfig.is_live_mode ? 'LIVE (produzione)' : 'TEST (sandbox)'}</strong>
                        </span>
                      </div>
                      <Switch
                        checked={stripeConfig.is_live_mode}
                        onCheckedChange={(checked) => setStripeConfig({...stripeConfig, is_live_mode: checked})}
                        data-testid="stripe-live-mode-toggle"
                      />
                    </div>
                    <p className="text-xs text-slate-600 mt-1">
                      Il backend utilizzerà le chiavi <strong>{stripeConfig.is_live_mode ? 'LIVE' : 'TEST'}</strong> configurate qui sotto.
                    </p>
                  </div>

                  {/* ============ CHIAVI TEST (SANDBOX) ============ */}
                  <div className={`p-4 rounded-lg border-2 ${!stripeConfig.is_live_mode ? 'border-emerald-400 bg-emerald-50/30' : 'border-slate-200'}`}>
                    <div className="flex items-center gap-2 mb-3">
                      <div className="w-2 h-2 rounded-full bg-emerald-500"></div>
                      <h5 className="font-semibold text-slate-800">Chiavi TEST (Sandbox)</h5>
                      {!stripeConfig.is_live_mode && (
                        <Badge className="bg-emerald-500 text-white text-xs">ATTIVA</Badge>
                      )}
                    </div>

                    <div className="space-y-3">
                      {/* API Key TEST */}
                      <div>
                        <Label htmlFor="stripe-api-key-test" className="text-xs font-medium">Secret API Key (sk_test_...)</Label>
                        <div className="relative flex-1 mt-1">
                          <Input
                            id="stripe-api-key-test"
                            type={showStripeApiKeyTest ? 'text' : 'password'}
                            value={stripeConfig.api_key_test}
                            onChange={(e) => setStripeConfig({...stripeConfig, api_key_test: e.target.value})}
                            placeholder={stripeConfig.has_api_key_test ? stripeConfig.api_key_test_masked : 'sk_test_...'}
                            className="font-mono text-sm pr-10"
                            data-testid="stripe-api-key-test-input"
                          />
                          <button
                            type="button"
                            onClick={() => setShowStripeApiKeyTest(!showStripeApiKeyTest)}
                            className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600"
                          >
                            {showStripeApiKeyTest ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                          </button>
                        </div>
                        {stripeConfig.has_api_key_test && !stripeConfig.api_key_test && (
                          <p className="text-xs text-green-600 mt-1">✓ Configurata. Lascia vuoto per mantenerla.</p>
                        )}
                      </div>

                      {/* Publishable Key TEST */}
                      <div>
                        <Label htmlFor="stripe-pub-key-test" className="text-xs font-medium">Publishable Key (pk_test_...)</Label>
                        <Input
                          id="stripe-pub-key-test"
                          value={stripeConfig.publishable_key_test}
                          onChange={(e) => setStripeConfig({...stripeConfig, publishable_key_test: e.target.value})}
                          placeholder="pk_test_..."
                          className="font-mono text-sm mt-1"
                          data-testid="stripe-pub-key-test-input"
                        />
                        <p className="text-xs text-slate-500 mt-1">Usata dal frontend per Stripe Elements/Checkout.</p>
                      </div>

                      {/* Webhook Secret TEST */}
                      <div>
                        <Label htmlFor="stripe-webhook-secret-test" className="text-xs font-medium">Webhook Signing Secret (whsec_...)</Label>
                        <div className="relative flex-1 mt-1">
                          <Input
                            id="stripe-webhook-secret-test"
                            type={showStripeWebhookSecretTest ? 'text' : 'password'}
                            value={stripeConfig.webhook_secret_test}
                            onChange={(e) => setStripeConfig({...stripeConfig, webhook_secret_test: e.target.value})}
                            placeholder={stripeConfig.has_webhook_secret_test ? stripeConfig.webhook_secret_test_masked : 'whsec_...'}
                            className="font-mono text-sm pr-10"
                            data-testid="stripe-webhook-secret-test-input"
                          />
                          <button
                            type="button"
                            onClick={() => setShowStripeWebhookSecretTest(!showStripeWebhookSecretTest)}
                            className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600"
                          >
                            {showStripeWebhookSecretTest ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                          </button>
                        </div>
                        {stripeConfig.has_webhook_secret_test && !stripeConfig.webhook_secret_test && (
                          <p className="text-xs text-green-600 mt-1">✓ Configurato. Lascia vuoto per mantenerlo.</p>
                        )}
                      </div>

                      {/* Fee Reconcile Webhook Secret TEST */}
                      <div>
                        <Label htmlFor="stripe-fee-webhook-secret-test" className="text-xs font-medium">
                          Webhook Fee Reconcile Secret (whsec_...)
                          <span className="text-slate-400 font-normal"> — per <code>application_fee.created</code></span>
                        </Label>
                        <div className="relative flex-1 mt-1">
                          <Input
                            id="stripe-fee-webhook-secret-test"
                            type={showStripeFeeWebhookSecretTest ? 'text' : 'password'}
                            value={stripeConfig.fee_reconcile_webhook_secret_test}
                            onChange={(e) => setStripeConfig({...stripeConfig, fee_reconcile_webhook_secret_test: e.target.value})}
                            placeholder={stripeConfig.has_fee_reconcile_webhook_secret_test ? stripeConfig.fee_reconcile_webhook_secret_test_masked : 'whsec_...'}
                            className="font-mono text-sm pr-10"
                            data-testid="stripe-fee-webhook-secret-test-input"
                          />
                          <button
                            type="button"
                            onClick={() => setShowStripeFeeWebhookSecretTest(!showStripeFeeWebhookSecretTest)}
                            className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600"
                          >
                            {showStripeFeeWebhookSecretTest ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                          </button>
                        </div>
                        <p className="text-xs text-slate-500 mt-1">
                          Endpoint: <code>/api/webhooks/stripe/fee-reconcile</code> · evento <code>application_fee.created</code>
                        </p>
                        {stripeConfig.has_fee_reconcile_webhook_secret_test && !stripeConfig.fee_reconcile_webhook_secret_test && (
                          <p className="text-xs text-green-600 mt-1">✓ Configurato. Lascia vuoto per mantenerlo.</p>
                        )}
                      </div>

                      {/* Connect Client ID TEST */}
                      <div>
                        <Label htmlFor="stripe-connect-test" className="text-xs font-medium">Connect Client ID <span className="text-slate-400 font-normal">(opzionale)</span></Label>
                        <Input
                          id="stripe-connect-test"
                          value={stripeConfig.connect_client_id_test}
                          onChange={(e) => setStripeConfig({...stripeConfig, connect_client_id_test: e.target.value})}
                          placeholder="ca_..."
                          className="font-mono text-sm mt-1"
                        />
                      </div>
                    </div>
                  </div>

                  {/* ============ CHIAVI LIVE (PRODUZIONE) ============ */}
                  <div className={`p-4 rounded-lg border-2 ${stripeConfig.is_live_mode ? 'border-red-400 bg-red-50/30' : 'border-slate-200'}`}>
                    <div className="flex items-center gap-2 mb-3">
                      <div className="w-2 h-2 rounded-full bg-red-500"></div>
                      <h5 className="font-semibold text-slate-800">Chiavi LIVE (Produzione)</h5>
                      {stripeConfig.is_live_mode && (
                        <Badge className="bg-red-500 text-white text-xs">ATTIVA</Badge>
                      )}
                    </div>

                    <div className="space-y-3">
                      {/* API Key LIVE */}
                      <div>
                        <Label htmlFor="stripe-api-key" className="text-xs font-medium">Secret API Key (sk_live_...)</Label>
                        <div className="relative flex-1 mt-1">
                          <Input
                            id="stripe-api-key"
                            type={showStripeApiKey ? 'text' : 'password'}
                            value={stripeConfig.api_key}
                            onChange={(e) => setStripeConfig({...stripeConfig, api_key: e.target.value})}
                            placeholder={stripeConfig.has_api_key ? stripeConfig.api_key_masked : 'sk_live_...'}
                            className="font-mono text-sm pr-10"
                            data-testid="stripe-api-key-input"
                          />
                          <button
                            type="button"
                            onClick={() => setShowStripeApiKey(!showStripeApiKey)}
                            className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600"
                          >
                            {showStripeApiKey ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                          </button>
                        </div>
                        {stripeConfig.has_api_key && !stripeConfig.api_key && (
                          <p className="text-xs text-green-600 mt-1">✓ Configurata. Lascia vuoto per mantenerla.</p>
                        )}
                      </div>

                      {/* Publishable Key LIVE */}
                      <div>
                        <Label htmlFor="stripe-pub-key" className="text-xs font-medium">Publishable Key (pk_live_...)</Label>
                        <Input
                          id="stripe-pub-key"
                          value={stripeConfig.publishable_key}
                          onChange={(e) => setStripeConfig({...stripeConfig, publishable_key: e.target.value})}
                          placeholder="pk_live_..."
                          className="font-mono text-sm mt-1"
                          data-testid="stripe-pub-key-input"
                        />
                        <p className="text-xs text-slate-500 mt-1">Usata dal frontend per Stripe Elements/Checkout.</p>
                      </div>

                      {/* Webhook Secret LIVE */}
                      <div>
                        <Label htmlFor="stripe-webhook-secret" className="text-xs font-medium">Webhook Signing Secret (whsec_...)</Label>
                        <div className="relative flex-1 mt-1">
                          <Input
                            id="stripe-webhook-secret"
                            type={showStripeWebhookSecret ? 'text' : 'password'}
                            value={stripeConfig.webhook_secret}
                            onChange={(e) => setStripeConfig({...stripeConfig, webhook_secret: e.target.value})}
                            placeholder={stripeConfig.has_webhook_secret ? stripeConfig.webhook_secret_masked : 'whsec_...'}
                            className="font-mono text-sm pr-10"
                            data-testid="stripe-webhook-secret-input"
                          />
                          <button
                            type="button"
                            onClick={() => setShowStripeWebhookSecret(!showStripeWebhookSecret)}
                            className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600"
                          >
                            {showStripeWebhookSecret ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                          </button>
                        </div>
                        {stripeConfig.has_webhook_secret && !stripeConfig.webhook_secret && (
                          <p className="text-xs text-green-600 mt-1">✓ Configurato. Lascia vuoto per mantenerlo.</p>
                        )}
                      </div>

                      {/* Fee Reconcile Webhook Secret LIVE */}
                      <div>
                        <Label htmlFor="stripe-fee-webhook-secret" className="text-xs font-medium">
                          Webhook Fee Reconcile Secret (whsec_...)
                          <span className="text-slate-400 font-normal"> — per <code>application_fee.created</code></span>
                        </Label>
                        <div className="relative flex-1 mt-1">
                          <Input
                            id="stripe-fee-webhook-secret"
                            type={showStripeFeeWebhookSecret ? 'text' : 'password'}
                            value={stripeConfig.fee_reconcile_webhook_secret}
                            onChange={(e) => setStripeConfig({...stripeConfig, fee_reconcile_webhook_secret: e.target.value})}
                            placeholder={stripeConfig.has_fee_reconcile_webhook_secret ? stripeConfig.fee_reconcile_webhook_secret_masked : 'whsec_...'}
                            className="font-mono text-sm pr-10"
                            data-testid="stripe-fee-webhook-secret-input"
                          />
                          <button
                            type="button"
                            onClick={() => setShowStripeFeeWebhookSecret(!showStripeFeeWebhookSecret)}
                            className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600"
                          >
                            {showStripeFeeWebhookSecret ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                          </button>
                        </div>
                        <p className="text-xs text-slate-500 mt-1">
                          Endpoint: <code>/api/webhooks/stripe/fee-reconcile</code> · evento <code>application_fee.created</code>
                        </p>
                        {stripeConfig.has_fee_reconcile_webhook_secret && !stripeConfig.fee_reconcile_webhook_secret && (
                          <p className="text-xs text-green-600 mt-1">✓ Configurato. Lascia vuoto per mantenerlo.</p>
                        )}
                      </div>

                      {/* Connect Client ID LIVE */}
                      <div>
                        <Label htmlFor="stripe-connect-client-id" className="text-xs font-medium">Connect Client ID <span className="text-slate-400 font-normal">(opzionale)</span></Label>
                        <Input
                          id="stripe-connect-client-id"
                          value={stripeConfig.connect_client_id}
                          onChange={(e) => setStripeConfig({...stripeConfig, connect_client_id: e.target.value})}
                          placeholder="ca_..."
                          className="font-mono text-sm mt-1"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Platform Fee */}
                  <div>
                    <Label htmlFor="stripe-platform-fee" className="text-sm font-medium">Commissione Piattaforma (%)</Label>
                    <div className="flex items-center gap-2 mt-1">
                      <Input
                        id="stripe-platform-fee"
                        type="number"
                        min="0"
                        max="50"
                        step="0.5"
                        value={stripeConfig.platform_fee_percent}
                        onChange={(e) => setStripeConfig({...stripeConfig, platform_fee_percent: parseFloat(e.target.value) || 0})}
                        className="w-24"
                      />
                      <span className="text-sm text-slate-500">% trattenuta su ogni transazione</span>
                    </div>
                  </div>

                  {/* Metodi di pagamento accettati al checkout */}
                  <div className="p-4 rounded-lg border-2 border-slate-200 bg-white">
                    <Label className="text-sm font-semibold">Metodi di pagamento accettati al checkout</Label>
                    <p className="text-xs text-slate-500 mt-1 mb-3">
                      Seleziona i metodi che il cliente vedrà nel checkout Rarifex. Se non
                      selezioni nulla, Stripe deciderà automaticamente (usa i metodi abilitati
                      nel Dashboard piattaforma). Devono essere abilitati sul tuo account Stripe.
                    </p>
                    <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
                      {[
                        { id: 'card',         label: 'Carta di credito/debito' },
                        { id: 'revolut_pay',  label: 'Revolut Pay' },
                        { id: 'satispay',     label: 'Satispay' },
                        { id: 'amazon_pay',   label: 'Amazon Pay' },
                        { id: 'link',         label: 'Link (Stripe)' },
                        { id: 'klarna',       label: 'Klarna' },
                        { id: 'sepa_debit',   label: 'SEPA Direct Debit' },
                        { id: 'bancontact',   label: 'Bancontact' },
                        { id: 'eps',          label: 'EPS' },
                        { id: 'p24',          label: 'Przelewy24' },
                        { id: 'ideal',        label: 'iDEAL' },
                        { id: 'paypal',       label: 'PayPal' },
                      ].map((m) => {
                        const checked = (stripeConfig.enabled_payment_methods || []).includes(m.id);
                        return (
                          <label
                            key={m.id}
                            className={`flex items-center gap-2 px-3 py-2 rounded-md border cursor-pointer transition-colors ${
                              checked ? 'border-[#008080] bg-teal-50' : 'border-slate-200 hover:border-slate-300'
                            }`}
                            data-testid={`payment-method-${m.id}`}
                          >
                            <input
                              type="checkbox"
                              checked={checked}
                              onChange={(e) => {
                                const cur = stripeConfig.enabled_payment_methods || [];
                                const next = e.target.checked
                                  ? [...cur, m.id]
                                  : cur.filter((x) => x !== m.id);
                                setStripeConfig({ ...stripeConfig, enabled_payment_methods: next });
                              }}
                              className="w-4 h-4 accent-[#008080]"
                            />
                            <span className="text-sm">{m.label}</span>
                          </label>
                        );
                      })}
                    </div>
                    {(stripeConfig.enabled_payment_methods || []).length > 0 && (
                      <p className="text-xs text-teal-700 mt-3">
                        ✓ Selezionati: <strong>{(stripeConfig.enabled_payment_methods || []).length}</strong> metodi.
                        Il cliente vedrà solo questi al checkout.
                      </p>
                    )}
                  </div>

                  {/* Live Mode warning quando attiva LIVE */}
                  {stripeConfig.is_live_mode && (
                    <div className="p-3 bg-amber-50 border border-amber-200 rounded-lg">
                      <div className="flex items-start gap-2">
                        <TriangleAlert className="w-4 h-4 text-amber-600 mt-0.5" />
                        <div className="text-sm text-amber-800">
                          <strong>Attenzione:</strong> Con la modalità Live attiva, verranno processati pagamenti reali. Assicurati di aver configurato le chiavi live (sk_live_).
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="flex gap-2 pt-2">
                    <Button
                      onClick={saveStripeConfig}
                      disabled={savingStripe}
                      className="flex-1 bg-purple-600 hover:bg-purple-700"
                    >
                      {savingStripe ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <CheckCircle2 className="w-4 h-4 mr-2" />}
                      Salva Configurazione
                    </Button>
                    <Button
                      variant="outline"
                      onClick={loadStripeConfig}
                      disabled={loadingStripe}
                    >
                      <RefreshCw className={`w-4 h-4 ${loadingStripe ? 'animate-spin' : ''}`} />
                    </Button>
                  </div>
                </div>
              </Card>

              {/* Info Box */}
              <Card className="p-4 bg-slate-50 border-slate-200 mt-6">
                <div className="flex items-start gap-3">
                  <Info className="w-5 h-5 text-slate-500 mt-0.5" />
                  <div className="text-sm text-slate-600">
                    <p className="font-medium mb-1">Come funziona:</p>
                    <ul className="list-disc list-inside space-y-1 text-slate-500">
                      <li>Gli utenti vedranno i pulsanti "Accedi con Google/Facebook" solo se attivi</li>
                      <li>Il toggle si può attivare solo dopo aver configurato Client ID e Secret</li>
                      <li>I Client Secret sono criptati nel database</li>
                      <li>L'URI di callback deve corrispondere a quello configurato nei provider</li>
                    </ul>
                  </div>
                </div>
              </Card>
            </div>
          </TabsContent>

          {/* Settings Tab */}
          <TabsContent value="settings">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {/* Maintenance Mode Card */}
              <Card className="p-6">
                <div className="flex items-start gap-4 mb-6">
                  <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${
                    maintenanceMode 
                      ? 'bg-gradient-to-br from-red-500 to-red-600' 
                      : 'bg-gradient-to-br from-green-500 to-green-600'
                  }`}>
                    <Shield className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h3 className="font-bold text-lg">Modalità Manutenzione</h3>
                    <p className="text-sm text-slate-500">Blocca l'accesso al sito mostrando "Coming Soon"</p>
                  </div>
                </div>
                
                <div className={`p-4 rounded-xl border-2 transition-all ${
                  maintenanceMode 
                    ? 'bg-red-50 border-red-200' 
                    : 'bg-green-50 border-green-200'
                }`}>
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center gap-3">
                      <Lock className="w-5 h-5 text-slate-600" />
                      <span className="font-medium">Stato Sito</span>
                    </div>
                    <div className="flex items-center gap-3">
                      <span className={`text-sm font-semibold ${maintenanceMode ? 'text-red-600' : 'text-green-600'}`}>
                        {maintenanceMode ? 'Bloccato' : 'Aperto'}
                      </span>
                      <Switch
                        checked={maintenanceMode}
                        onCheckedChange={toggleMaintenanceMode}
                        disabled={savingSettings}
                      />
                    </div>
                  </div>
                  
                  {maintenanceMode ? (
                    <div className="p-3 bg-red-100 rounded-lg text-sm text-red-800">
                      <p className="font-semibold mb-1">🔒 Sito in manutenzione</p>
                      <p>I visitatori vedono la pagina "Coming Soon". Solo chi clicca "Accesso Team" e fa login può navigare.</p>
                    </div>
                  ) : (
                    <div className="p-3 bg-green-100 rounded-lg text-sm text-green-800">
                      <p className="font-semibold mb-1">✅ Sito aperto al pubblico</p>
                      <p>Tutti i visitatori possono navigare liberamente nel marketplace.</p>
                    </div>
                  )}
                </div>
              </Card>

              {/* Launch Mode Card */}
              <Card className="p-6">
                <div className="flex items-start gap-4 mb-6">
                  <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-amber-400 to-orange-500 flex items-center justify-center">
                    <Rocket className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h3 className="font-bold text-lg">Modalità Lancio</h3>
                    <p className="text-sm text-slate-500">Azzera le commissioni Rarifex per il periodo di lancio</p>
                  </div>
                </div>
                
                <div className={`p-4 rounded-xl border-2 transition-all ${
                  launchMode 
                    ? 'bg-green-50 border-green-200' 
                    : 'bg-slate-50 border-slate-200'
                }`}>
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center gap-3">
                      <Percent className="w-5 h-5 text-slate-600" />
                      <span className="font-medium">Commissioni Rarifex</span>
                    </div>
                    <div className="flex items-center gap-3">
                      <span className={`text-sm font-semibold ${launchMode ? 'text-green-600' : 'text-slate-600'}`}>
                        {launchMode ? '0% (Sconto lancio)' : '8%'}
                      </span>
                      <Switch
                        checked={launchMode}
                        onCheckedChange={toggleLaunchMode}
                        disabled={savingSettings}
                      />
                    </div>
                  </div>
                  
                  {launchMode ? (
                    <div className="p-3 bg-green-100 rounded-lg text-sm text-green-800">
                      <p className="font-semibold mb-1">🚀 Modalità lancio attiva</p>
                      <p>Le commissioni dell'8% sono azzerate. Gli artigiani ricevono il 100% del prezzo di vendita!</p>
                    </div>
                  ) : (
                    <div className="p-3 bg-slate-100 rounded-lg text-sm text-slate-600">
                      <p>Quando attivi la modalità lancio, le commissioni Rarifex (8%) vengono azzerate per gli artigiani.</p>
                    </div>
                  )}
                </div>

                {/* Checkout Mode Toggle (Redirect vs Express) */}
                <div
                  className={`p-4 rounded-xl border-2 transition-all mt-4 ${
                    checkoutMode === 'express'
                      ? 'bg-teal-50 border-teal-200'
                      : 'bg-slate-50 border-slate-200'
                  }`}
                  data-testid="checkout-mode-card"
                >
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center gap-3">
                      <CreditCard className="w-5 h-5 text-slate-600" />
                      <span className="font-medium">Modalità Checkout</span>
                    </div>
                    <div className="flex items-center gap-3">
                      <span
                        className={`text-sm font-semibold ${
                          checkoutMode === 'express' ? 'text-teal-700' : 'text-slate-600'
                        }`}
                      >
                        {checkoutMode === 'express' ? 'Express (in-page)' : 'Redirect (hosted)'}
                      </span>
                      <Switch
                        checked={checkoutMode === 'express'}
                        onCheckedChange={toggleCheckoutMode}
                        disabled={savingSettings}
                        data-testid="checkout-mode-switch"
                      />
                    </div>
                  </div>

                  {checkoutMode === 'express' ? (
                    <div className="p-3 bg-teal-100 rounded-lg text-sm text-teal-800">
                      <p className="font-semibold mb-1">💳 Express Checkout attivo</p>
                      <p>
                        I pulsanti di pagamento (Google Pay, Link, PayPal, e Apple Pay quando il dominio sarà verificato)
                        appaiono direttamente nel carrello. Nessun redirect esterno.
                      </p>
                    </div>
                  ) : (
                    <div className="p-3 bg-slate-100 rounded-lg text-sm text-slate-600">
                      <p>
                        Modalità classica: il carrello reindirizza a Stripe hosted checkout. Attiva Express per un'esperienza in-page (raccomandato dopo la verifica del dominio Apple Pay).
                      </p>
                    </div>
                  )}
                </div>
              </Card>

              {/* Premium Features Card */}
              <Card className="p-6">
                <div className="flex items-start gap-4 mb-6">
                  <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${
                    premiumFeaturesEnabled 
                      ? 'bg-gradient-to-br from-[#DAA520] to-[#B8860B]' 
                      : 'bg-gradient-to-br from-slate-400 to-slate-500'
                  }`}>
                    <Crown className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h3 className="font-bold text-lg">Funzionalità Premium</h3>
                    <p className="text-sm text-slate-500">Abilita/disabilita i vantaggi per gli abbonati</p>
                  </div>
                </div>
                
                <div className={`p-4 rounded-xl border-2 transition-all ${
                  premiumFeaturesEnabled 
                    ? 'bg-amber-50 border-amber-200' 
                    : 'bg-slate-50 border-slate-200'
                }`}>
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center gap-3">
                      <Sparkles className="w-5 h-5 text-slate-600" />
                      <span className="font-medium">Distinzione Free/Premium</span>
                    </div>
                    <div className="flex items-center gap-3">
                      <span className={`text-sm font-semibold ${premiumFeaturesEnabled ? 'text-amber-600' : 'text-slate-600'}`}>
                        {premiumFeaturesEnabled ? 'Attiva' : 'Disattivata'}
                      </span>
                      <Switch
                        checked={premiumFeaturesEnabled}
                        onCheckedChange={togglePremiumFeatures}
                        disabled={savingSettings}
                      />
                    </div>
                  </div>
                  
                  {premiumFeaturesEnabled ? (
                    <div className="p-3 bg-amber-100 rounded-lg text-sm text-amber-800">
                      <p className="font-semibold mb-1">👑 Distinzione attiva</p>
                      <p>Gli utenti Free hanno limitazioni (5 risposte/settimana, richieste con 24h di ritardo). Gli abbonati Premium (€10/mese) hanno tutti i vantaggi.</p>
                    </div>
                  ) : (
                    <div className="p-3 bg-slate-100 rounded-lg text-sm text-slate-600">
                      <p className="font-semibold mb-1">🎁 Tutti Premium</p>
                      <p>Tutti gli utenti hanno accesso ai vantaggi Premium gratuitamente. Utile per promozioni o lancio.</p>
                    </div>
                  )}
                </div>
              </Card>

              {/* Fee Structure Info */}
              <Card className="p-6">
                <div className="flex items-start gap-4 mb-6">
                  <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#008080] to-[#006666] flex items-center justify-center">
                    <Euro className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h3 className="font-bold text-lg">Struttura Commissioni</h3>
                    <p className="text-sm text-slate-500">Dettaglio delle fee applicate</p>
                  </div>
                </div>

                <div className="space-y-3">
                  <div className="flex items-center justify-between p-3 bg-slate-50 rounded-lg">
                    <div>
                      <span className="text-slate-600">Commissione Rarifex</span>
                      <span className="block text-xs text-slate-400">onnicomprensiva (piattaforma + pagamento)</span>
                    </div>
                    <span className={`font-semibold ${launchMode ? 'text-green-600 line-through' : 'text-slate-800'}`}>
                      8%
                    </span>
                  </div>
                  <div className="flex items-center justify-between p-3 bg-[#008080]/10 rounded-lg border border-[#008080]/20">
                    <span className="font-medium text-[#008080]">Su €100 di vendita</span>
                    <div className="text-right">
                      <span className="font-bold text-[#008080]">
                        Artigiano riceve: {launchMode ? '€100' : '€92'}
                      </span>
                      {!launchMode && (
                        <span className="block text-xs text-slate-500">Fee: €8</span>
                      )}
                    </div>
                  </div>
                </div>

                {launchMode && (
                  <div className="mt-4 p-3 bg-amber-50 border border-amber-200 rounded-lg">
                    <p className="text-sm text-amber-800">
                      <strong>Promo Lancio:</strong> L'artigiano riceve il 100% del prezzo impostato (al netto solo delle fee Stripe). La fee Rarifex dell'8% è temporaneamente azzerata. Nessuno sconto viene applicato ai clienti.
                    </p>
                  </div>
                )}
              </Card>

              {/* Hero Images Management */}
              <Card className="p-6 lg:col-span-2">
                <div className="flex items-start gap-4 mb-6">
                  <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-purple-500 to-indigo-600 flex items-center justify-center">
                    <ImageIcon className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h3 className="font-bold text-lg">Immagini Hero Homepage</h3>
                    <p className="text-sm text-slate-500">Gestisci le immagini di sfondo della sezione principale. Ad ogni visita viene mostrata un'immagine random.</p>
                  </div>
                </div>

                {/* Preview info */}
                <div className="p-3 bg-slate-100 rounded-lg text-sm text-slate-600 mb-4">
                  <p><strong>Nota:</strong> Le immagini vengono mostrate con un overlay teal trasparente per garantire la leggibilità del testo. Usa immagini di alta qualità (min 1920px di larghezza) che evochino l'artigianato italiano.</p>
                </div>

                {/* Images Grid */}
                {loadingHeroImages ? (
                  <div className="flex items-center justify-center py-8">
                    <Loader2 className="w-6 h-6 animate-spin text-[#008080] mr-2" />
                    <span className="text-slate-500">Caricamento immagini...</span>
                  </div>
                ) : heroImages.length === 0 ? (
                  <div className="p-8 text-center bg-slate-50 rounded-lg border-2 border-dashed border-slate-200 mb-6">
                    <ImageIcon className="w-12 h-12 text-slate-300 mx-auto mb-3" />
                    <p className="text-slate-500">Nessuna immagine configurata</p>
                    <p className="text-sm text-slate-400">Aggiungi la prima immagine qui sotto</p>
                  </div>
                ) : (
                  <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-6">
                    {heroImages.map((url, index) => (
                      <div key={index} className="relative group aspect-video rounded-lg overflow-hidden border-2 border-slate-200 bg-slate-100">
                        <img 
                          src={url} 
                          alt={`Hero ${index + 1}`}
                          className="w-full h-full object-cover"
                          onError={(e) => {
                            e.target.src = 'https://via.placeholder.com/400x250?text=Immagine+non+trovata';
                          }}
                        />
                        {/* Overlay preview */}
                        <div 
                          className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity"
                          style={{
                            background: 'linear-gradient(135deg, rgba(0, 100, 100, 0.85), rgba(0, 80, 80, 0.88))'
                          }}
                        >
                          <div className="absolute inset-0 flex items-center justify-center text-white text-xs font-medium">
                            Anteprima overlay
                          </div>
                        </div>
                        {/* Delete button */}
                        <button
                          onClick={() => removeHeroImage(index)}
                          disabled={loadingHeroImages || heroImages.length <= 1}
                          className="absolute top-2 right-2 w-8 h-8 bg-red-500 text-white rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity hover:bg-red-600 disabled:opacity-50"
                        >
                          <Trash2 className="w-4 h-4" />
                        </button>
                        {/* Index badge */}
                        <div className="absolute bottom-2 left-2 px-2 py-1 bg-black/50 text-white text-xs rounded">
                          #{index + 1}
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                {/* Add new image */}
                <div className="flex gap-3">
                  <Input
                    placeholder="Incolla URL immagine (es. https://images.unsplash.com/...)"
                    value={newHeroImageUrl}
                    onChange={(e) => setNewHeroImageUrl(e.target.value)}
                    className="flex-1"
                  />
                  <Button
                    onClick={addHeroImage}
                    disabled={loadingHeroImages || !newHeroImageUrl.trim()}
                    className="bg-[#008080] text-white"
                  >
                    {loadingHeroImages ? (
                      <Loader2 className="w-4 h-4 animate-spin" />
                    ) : (
                      <>
                        <Plus className="w-4 h-4 mr-2" />
                        Aggiungi
                      </>
                    )}
                  </Button>
                </div>

                {/* Tips */}
                <div className="mt-4 p-3 bg-blue-50 border border-blue-200 rounded-lg text-sm text-blue-800">
                  <p className="font-semibold mb-1">💡 Suggerimenti per le immagini:</p>
                  <ul className="list-disc list-inside space-y-1">
                    <li>Usa immagini di artigiani al lavoro, mani che creano, botteghe</li>
                    <li>Evita immagini con testo o loghi visibili</li>
                    <li>Preferisci toni caldi e naturali</li>
                    <li>Puoi usare Unsplash o Pexels per immagini gratuite di alta qualità</li>
                  </ul>
                </div>
              </Card>
            </div>
          </TabsContent>
        </Tabs>
      </div>

      {/* User Detail Dialog */}
      <Dialog open={!!selectedUser} onOpenChange={() => setSelectedUser(null)}>
        <DialogContent className="max-w-lg">
          <DialogHeader>
            <DialogTitle>Dettagli Utente</DialogTitle>
          </DialogHeader>
          {selectedUser && (
            <div className="space-y-4 mt-4">
              <div className="flex items-center gap-4">
                <div className="w-16 h-16 rounded-full bg-[#008080] flex items-center justify-center text-white text-2xl font-bold">
                  {(selectedUser.full_name || selectedUser.email || 'U')[0].toUpperCase()}
                </div>
                <div>
                  <h3 className="text-xl font-bold">{selectedUser.full_name || 'Nome non impostato'}</h3>
                  <p className="text-slate-500">{selectedUser.email}</p>
                </div>
              </div>
              
              <div className="grid grid-cols-2 gap-4 text-sm">
                <div className="p-3 bg-slate-50 rounded">
                  <p className="text-slate-500">ID</p>
                  <p className="font-mono text-xs truncate">{selectedUser.id}</p>
                </div>
                <div className="p-3 bg-slate-50 rounded">
                  <p className="text-slate-500">Telefono</p>
                  <p>{selectedUser.phone || '-'}</p>
                </div>
                <div className="p-3 bg-slate-50 rounded">
                  <p className="text-slate-500">Città</p>
                  <p>{selectedUser.city || '-'}</p>
                </div>
                <div className="p-3 bg-slate-50 rounded">
                  <p className="text-slate-500">Regione</p>
                  <p>{selectedUser.region || '-'}</p>
                </div>
                <div className="p-3 bg-slate-50 rounded">
                  <p className="text-slate-500">Tier</p>
                  <p className="capitalize">{selectedUser.tier || 'Free'}</p>
                </div>
                <div className="p-3 bg-slate-50 rounded">
                  <p className="text-slate-500">Registrato</p>
                  <p>{formatDate(selectedUser.created_at)}</p>
                </div>
              </div>

              {selectedUser.is_crafter_enabled && (
                <div className="p-4 bg-amber-50 rounded-lg">
                  <h4 className="font-semibold text-amber-800 mb-2">Info Artigiano</h4>
                  <p><strong>Vetrina:</strong> {selectedUser.storefront_title || '-'}</p>
                  <p><strong>Bio:</strong> {selectedUser.bio || '-'}</p>
                  <p><strong>Categorie:</strong> {selectedUser.categories?.join(', ') || '-'}</p>
                </div>
              )}

              <div className="flex gap-2 pt-4 border-t">
                <Button 
                  variant="outline" 
                  onClick={() => toggleCrafterStatus(selectedUser.id, selectedUser.is_crafter_enabled)}
                  className="flex-1"
                >
                  <Crown className="w-4 h-4 mr-2" />
                  {selectedUser.is_crafter_enabled ? 'Rimuovi Crafter' : 'Abilita Crafter'}
                </Button>
                <Button 
                  variant={selectedUser.is_banned ? "default" : "destructive"}
                  onClick={() => toggleUserStatus(selectedUser.id, selectedUser.is_banned)}
                  className="flex-1"
                >
                  {selectedUser.is_banned ? (
                    <>
                      <CircleCheck className="w-4 h-4 mr-2" />Riattiva
                    </>
                  ) : (
                    <>
                      <Ban className="w-4 h-4 mr-2" />Sospendi
                    </>
                  )}
                </Button>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
